// import { IFHAType } from './dataTypes';
export interface IFHAType {
  'MSA Code'?: string | number;
  'Metro Div Code'?: string | number;
  'MSA Name'?: string;
  'SOA Code'?: string | number;
  'Limit Type'?: 'S' | 'H';
  'Median Price'?: number;
  '1 Unit'?: number;
  '2 Unit'?: number;
  '3 Unit'?: number;
  '4 Unit'?: number;
  ST?: string;
  FIPS?: string | number;
  'State Name'?: string;
  'County Name'?: string;
  'Limit Date'?: number;
  'Median Price Det Limit'?: string | number;
  'Year Median Price Det Limit'?: string | number;
}

export const fhaLimits: IFHAType[] = [
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': '',
    FIPS: '',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 0,
    'Median Price Det Limit': '',
    'Metro Div Code': '',
    'MSA Code': '',
    'MSA Name': '',
    'SOA Code': 'ZZ203',
    ST: '',
    'State Name': '',
    'Year Median Price Det Limit': '',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': '',
    FIPS: '',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 0,
    'Median Price Det Limit': '',
    'Metro Div Code': '',
    'MSA Code': '',
    'MSA Name': '',
    'SOA Code': '203B',
    ST: '',
    'State Name': '',
    'Year Median Price Det Limit': '',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALEUTIANS EAST',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 171000,
    'Median Price Det Limit': '221000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 585350,
    '2 Unit': 749350,
    '3 Unit': 905800,
    '4 Unit': 1125700,
    'County Name': 'ALEUTIANS WEST',
    FIPS: '016',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 496000,
    'Median Price Det Limit': '509000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANCHORAGE MUNIC',
    FIPS: '020',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 460000,
    'Median Price Det Limit': '460000',
    'Metro Div Code': '0',
    'MSA Code': '11260',
    'MSA Name': 'ANCHORAGE, AK',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BETHEL CENSUS A',
    FIPS: '050',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRISTOL BAY BOR',
    FIPS: '060',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 344000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHUGACH CENSUS',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COPPER RIVER CE',
    FIPS: '066',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 449000,
    'Median Price Det Limit': '449000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DENALI BOROUGH',
    FIPS: '068',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 334000,
    'Median Price Det Limit': '334000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DILLINGHAM CENS',
    FIPS: '070',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAIRBANKS NORTH',
    FIPS: '090',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '21820',
    'MSA Name': 'FAIRBANKS-COLLEGE, AK',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAINES BOROUGH',
    FIPS: '100',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 334000,
    'Median Price Det Limit': '334000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOONAH-ANGOON C',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 355000,
    'Median Price Det Limit': '456000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 596850,
    '2 Unit': 764050,
    '3 Unit': 923600,
    '4 Unit': 1147800,
    'County Name': 'JUNEAU CITY AND',
    FIPS: '110',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 519000,
    'Median Price Det Limit': '519000',
    'Metro Div Code': '0',
    'MSA Code': '27940',
    'MSA Name': 'JUNEAU, AK',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENAI PENINSULA',
    FIPS: '122',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 319000,
    'Median Price Det Limit': '319000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KETCHIKAN GATEW',
    FIPS: '130',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 442000,
    'Median Price Det Limit': '442000',
    'Metro Div Code': '0',
    'MSA Code': '28540',
    'MSA Name': 'KETCHIKAN, AK',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541650,
    '2 Unit': 693400,
    '3 Unit': 838150,
    '4 Unit': 1041650,
    'County Name': 'KODIAK ISLAND B',
    FIPS: '150',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 455000,
    'Median Price Det Limit': '471000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KUSILVAK CENSUS',
    FIPS: '158',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE AND PENINS',
    FIPS: '164',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MATANUSKA-SUSIT',
    FIPS: '170',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 460000,
    'Median Price Det Limit': '460000',
    'Metro Div Code': '0',
    'MSA Code': '11260',
    'MSA Name': 'ANCHORAGE, AK',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOME CENSUS ARE',
    FIPS: '180',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 467000,
    'Median Price Det Limit': '467000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTH SLOPE BOR',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 393000,
    'Median Price Det Limit': '393000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHWEST ARCTI',
    FIPS: '188',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PETERSBURG CENS',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 385000,
    'Median Price Det Limit': '385000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRINCE OF WALES',
    FIPS: '198',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 283000,
    'Median Price Det Limit': '297000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'SITKA CITY AND',
    FIPS: '220',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 490000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SKAGWAY MUNICIP',
    FIPS: '230',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 466000,
    'Median Price Det Limit': '466000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOUTHEAST FAIRB',
    FIPS: '240',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 413000,
    'Median Price Det Limit': '413000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WRANGELL CITY A',
    FIPS: '275',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 338000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YAKUTAT CITY AN',
    FIPS: '282',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 219000,
    'Median Price Det Limit': '366000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YUKON-KOYUKUK C',
    FIPS: '290',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AK',
    'State Name': 'ALASKA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AUTAUGA COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '33860',
    'MSA Name': 'MONTGOMERY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BALDWIN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 320000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '19300',
    'MSA Name': 'DAPHNE-FAIRHOPE-FOLEY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARBOUR COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '21640',
    'MSA Name': 'EUFAULA, AL-GA',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BIBB COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLOUNT COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BULLOCK COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '11500',
    'MSA Name': 'ANNISTON-OXFORD, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAMBERS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '29300',
    'MSA Name': 'LAGRANGE, GA-AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHILTON COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHOCTAW COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARKE COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEBURNE COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COFFEE COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '21460',
    'MSA Name': 'ENTERPRISE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLBERT COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '22520',
    'MSA Name': 'FLORENCE-MUSCLE SHOALS, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CONECUH COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOSA COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 131000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '45180',
    'MSA Name': 'TALLADEGA-SYLACAUGA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COVINGTON COUNT',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRENSHAW COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CULLMAN COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '18980',
    'MSA Name': 'CULLMAN, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DALE COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '37120',
    'MSA Name': 'OZARK, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DALLAS COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '42820',
    'MSA Name': 'SELMA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2010',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEKALB COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 103000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '22840',
    'MSA Name': 'FORT PAYNE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELMORE COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '33860',
    'MSA Name': 'MONTGOMERY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESCAMBIA COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ETOWAH COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '23460',
    'MSA Name': 'GADSDEN, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '40770',
    'MSA Name': 'RUSSELLVILLE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GENEVA COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '20020',
    'MSA Name': 'DOTHAN, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '46220',
    'MSA Name': 'TUSCALOOSA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALE COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '46220',
    'MSA Name': 'TUSCALOOSA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '20020',
    'MSA Name': 'DOTHAN, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOUSTON COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '20020',
    'MSA Name': 'DOTHAN, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 224000,
    'Median Price Det Limit': '224000',
    'Metro Div Code': '0',
    'MSA Code': '42460',
    'MSA Name': 'SCOTTSBORO, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMAR COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '352000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAUDERDALE COUN',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '22520',
    'MSA Name': 'FLORENCE-MUSCLE SHOALS, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '19460',
    'MSA Name': 'DECATUR, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 371000,
    'Median Price Det Limit': '371000',
    'Metro Div Code': '0',
    'MSA Code': '12220',
    'MSA Name': 'AUBURN-OPELIKA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIMESTONE COUNT',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '26620',
    'MSA Name': 'HUNTSVILLE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOWNDES COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '33860',
    'MSA Name': 'MONTGOMERY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACON COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 371000,
    'Median Price Det Limit': '371000',
    'Metro Div Code': '0',
    'MSA Code': '12220',
    'MSA Name': 'AUBURN-OPELIKA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '26620',
    'MSA Name': 'HUNTSVILLE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARENGO COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '10700',
    'MSA Name': 'ALBERTVILLE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOBILE COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '33660',
    'MSA Name': 'MOBILE, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 91000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2010',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '33860',
    'MSA Name': 'MONTGOMERY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '19460',
    'MSA Name': 'DECATUR, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PICKENS COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '46220',
    'MSA Name': 'TUSCALOOSA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '45980',
    'MSA Name': 'TROY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 246000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSSELL COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CLAIR COUNT',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMTER COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TALLADEGA COUNT',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 131000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '45180',
    'MSA Name': 'TALLADEGA-SYLACAUGA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TALLAPOOSA COUN',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '10760',
    'MSA Name': 'ALEXANDER CITY, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TUSCALOOSA COUN',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '46220',
    'MSA Name': 'TUSCALOOSA, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALKER COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '13820',
    'MSA Name': 'BIRMINGHAM, AL',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILCOX COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINSTON COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AL',
    'State Name': 'ALABAMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARKANSAS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASHLEY COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '79000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAXTER COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '34260',
    'MSA Name': 'MOUNTAIN HOME, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '22220',
    'MSA Name': 'FAYETTEVILLE-SPRINGDALE-ROGERS, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '25460',
    'MSA Name': 'HARRISON, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRADLEY COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 83000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '15780',
    'MSA Name': 'CAMDEN, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 221000,
    'Median Price Det Limit': '221000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHICOT COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '219000',
    'Metro Div Code': '0',
    'MSA Code': '11660',
    'MSA Name': 'ARKADELPHIA, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEBURNE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEVELAND COUNT',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '38220',
    'MSA Name': 'PINE BLUFF, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '31620',
    'MSA Name': 'MAGNOLIA, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CONWAY COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAIGHEAD COUNT',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '27860',
    'MSA Name': 'JONESBORO, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '22900',
    'MSA Name': 'FORT SMITH, AR-OK',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRITTENDEN COUN',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROSS COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DALLAS COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 68000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DESHA COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 83000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DREW COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAULKNER COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '30780',
    'MSA Name': 'LITTLE ROCK-NORTH LITTLE ROCK-CONWAY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 121000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARLAND COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '26300',
    'MSA Name': 'HOT SPRINGS, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '30780',
    'MSA Name': 'LITTLE ROCK-NORTH LITTLE ROCK-CONWAY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '37500',
    'MSA Name': 'PARAGOULD, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HEMPSTEAD COUNT',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 81000,
    'Median Price Det Limit': '81000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOT SPRING COUN',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '31680',
    'MSA Name': 'MALVERN, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWARD COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'INDEPENDENCE CO',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '12900',
    'MSA Name': 'BATESVILLE, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IZARD COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '109000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '38220',
    'MSA Name': 'PINE BLUFF, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 218000,
    'Median Price Det Limit': '218000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFAYETTE COUNT',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 74000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LITTLE RIVER CO',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '45500',
    'MSA Name': 'TEXARKANA, TX-AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LONOKE COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '30780',
    'MSA Name': 'LITTLE ROCK-NORTH LITTLE ROCK-CONWAY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '22220',
    'MSA Name': 'FAYETTEVILLE-SPRINGDALE-ROGERS, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILLER COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '45500',
    'MSA Name': 'TEXARKANA, TX-AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MISSISSIPPI COU',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 101000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '14180',
    'MSA Name': 'BLYTHEVILLE, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEVADA COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWTON COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '25460',
    'MSA Name': 'HARRISON, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OUACHITA COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '15780',
    'MSA Name': 'CAMDEN, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '30780',
    'MSA Name': 'LITTLE ROCK-NORTH LITTLE ROCK-CONWAY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PHILLIPS COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 40000,
    'Median Price Det Limit': '65000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POINSETT COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '27860',
    'MSA Name': 'JONESBORO, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POPE COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '40780',
    'MSA Name': 'RUSSELLVILLE, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRAIRIE COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 116000,
    'Median Price Det Limit': '116000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '30780',
    'MSA Name': 'LITTLE ROCK-NORTH LITTLE ROCK-CONWAY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. FRANCIS COU',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '68000',
    'Metro Div Code': '0',
    'MSA Code': '22620',
    'MSA Name': 'FORREST CITY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALINE COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '30780',
    'MSA Name': 'LITTLE ROCK-NORTH LITTLE ROCK-CONWAY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEARCY COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEBASTIAN COUNT',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '22900',
    'MSA Name': 'FORT SMITH, AR-OK',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEVIER COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHARP COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 103000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STONE COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '20980',
    'MSA Name': 'EL DORADO, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAN BUREN COUNT',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 117000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '22220',
    'MSA Name': 'FAYETTEVILLE-SPRINGDALE-ROGERS, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITE COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '42620',
    'MSA Name': 'SEARCY, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODRUFF COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YELL COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '40780',
    'MSA Name': 'RUSSELLVILLE, AR',
    'SOA Code': '203B',
    ST: 'AR',
    'State Name': 'ARKANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EASTERN DISTRIC',
    FIPS: '010',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AS',
    'State Name': 'AMERICAN SAMOA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': "MANU'A DISTRICT",
    FIPS: '020',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AS',
    'State Name': 'AMERICAN SAMOA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROSE ISLAND',
    FIPS: '030',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AS',
    'State Name': 'AMERICAN SAMOA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWAINS ISLAND',
    FIPS: '040',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AS',
    'State Name': 'AMERICAN SAMOA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WESTERN DISTRIC',
    FIPS: '050',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AS',
    'State Name': 'AMERICAN SAMOA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'APACHE COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COCHISE COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '43420',
    'MSA Name': 'SIERRA VISTA-DOUGLAS, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 609500,
    '2 Unit': 780250,
    '3 Unit': 943150,
    '4 Unit': 1172150,
    'County Name': 'COCONINO COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 530000,
    'Median Price Det Limit': '530000',
    'Metro Div Code': '0',
    'MSA Code': '22380',
    'MSA Name': 'FLAGSTAFF, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILA COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '37740',
    'MSA Name': 'PAYSON, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAHAM COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '40940',
    'MSA Name': 'SAFFORD, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENLEE COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LA PAZ COUNTY',
    FIPS: '012',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'MARICOPA COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 485000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '38060',
    'MSA Name': 'PHOENIX-MESA-CHANDLER, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOHAVE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 267000,
    'Median Price Det Limit': '267000',
    'Metro Div Code': '0',
    'MSA Code': '29420',
    'MSA Name': 'LAKE HAVASU CITY-KINGMAN, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NAVAJO COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 294000,
    'Median Price Det Limit': '294000',
    'Metro Div Code': '0',
    'MSA Code': '43320',
    'MSA Name': 'SHOW LOW, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIMA COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 360000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '46060',
    'MSA Name': 'TUCSON, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'PINAL COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 485000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '38060',
    'MSA Name': 'PHOENIX-MESA-CHANDLER, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANTA CRUZ COUN',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '35700',
    'MSA Name': 'NOGALES, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YAVAPAI COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '425000',
    'Metro Div Code': '0',
    'MSA Code': '39150',
    'MSA Name': 'PRESCOTT VALLEY-PRESCOTT, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YUMA COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 268000,
    'Median Price Det Limit': '268000',
    'Metro Div Code': '0',
    'MSA Code': '49740',
    'MSA Name': 'YUMA, AZ',
    'SOA Code': '203B',
    ST: 'AZ',
    'State Name': 'ARIZONA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'ALAMEDA COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1750000,
    'Median Price Det Limit': '1750000',
    'Metro Div Code': '36084',
    'MSA Code': '41860',
    'MSA Name': 'SAN FRANCISCO-OAKLAND-FREMONT, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 736000,
    '2 Unit': 942200,
    '3 Unit': 1138900,
    '4 Unit': 1415400,
    'County Name': 'ALPINE COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 640000,
    'Median Price Det Limit': '640000',
    'Metro Div Code': '0',
    'MSA Code': '23820',
    'MSA Name': 'GARDNERVILLE RANCHOS, NV-CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AMADOR COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 385000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTTE COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '310000',
    'Metro Div Code': '0',
    'MSA Code': '17020',
    'MSA Name': 'CHICO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALAVERAS COUNT',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 385000,
    'Median Price Det Limit': '399000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUSA COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '400000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'CONTRA COSTA CO',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1750000,
    'Median Price Det Limit': '1750000',
    'Metro Div Code': '36084',
    'MSA Code': '41860',
    'MSA Name': 'SAN FRANCISCO-OAKLAND-FREMONT, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEL NORTE COUNT',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '18860',
    'MSA Name': 'CRESCENT CITY, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 764750,
    '2 Unit': 979000,
    '3 Unit': 1183400,
    '4 Unit': 1470700,
    'County Name': 'EL DORADO COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 665000,
    'Median Price Det Limit': '665000',
    'Metro Div Code': '0',
    'MSA Code': '40900',
    'MSA Name': 'SACRAMENTO-ROSEVILLE-FOLSOM, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRESNO COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 430000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '23420',
    'MSA Name': 'FRESNO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GLENN COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '313000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUMBOLDT COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '400000',
    'Metro Div Code': '0',
    'MSA Code': '21700',
    'MSA Name': 'EUREKA-ARCATA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IMPERIAL COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 355000,
    'Median Price Det Limit': '355000',
    'Metro Div Code': '0',
    'MSA Code': '20940',
    'MSA Name': 'EL CENTRO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'INYO COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '13860',
    'MSA Name': 'BISHOP, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KERN COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '12540',
    'MSA Name': 'BAKERSFIELD-DELANO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KINGS COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '25260',
    'MSA Name': 'HANFORD-CORCORAN, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '17340',
    'MSA Name': 'CLEARLAKE, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LASSEN COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '45000',
    'MSA Name': 'SUSANVILLE, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'LOS ANGELES COU',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1300000,
    'Median Price Det Limit': '1300000',
    'Metro Div Code': '31084',
    'MSA Code': '31080',
    'MSA Name': 'LOS ANGELES-LONG BEACH-ANAHEIM, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADERA COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 430000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '23420',
    'MSA Name': 'FRESNO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MARIN COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1750000,
    'Median Price Det Limit': '1750000',
    'Metro Div Code': '42034',
    'MSA Code': '41860',
    'MSA Name': 'SAN FRANCISCO-OAKLAND-FREMONT, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARIPOSA COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 546250,
    '2 Unit': 699300,
    '3 Unit': 845300,
    '4 Unit': 1050500,
    'County Name': 'MENDOCINO COUNT',
    FIPS: '045',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 459000,
    'Median Price Det Limit': '475000',
    'Metro Div Code': '0',
    'MSA Code': '46380',
    'MSA Name': 'UKIAH, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCED COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 420000,
    'Median Price Det Limit': '420000',
    'Metro Div Code': '0',
    'MSA Code': '32900',
    'MSA Name': 'MERCED, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MODOC COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 776250,
    '2 Unit': 993750,
    '3 Unit': 1201200,
    '4 Unit': 1492800,
    'County Name': 'MONO COUNTY',
    FIPS: '051',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 670000,
    'Median Price Det Limit': '675000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 994750,
    '2 Unit': 1273450,
    '3 Unit': 1539350,
    '4 Unit': 1913000,
    'County Name': 'MONTEREY COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 865000,
    'Median Price Det Limit': '865000',
    'Metro Div Code': '0',
    'MSA Code': '41500',
    'MSA Name': 'SALINAS, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1017750,
    '2 Unit': 1302900,
    '3 Unit': 1574900,
    '4 Unit': 1957250,
    'County Name': 'NAPA COUNTY',
    FIPS: '055',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 850000,
    'Median Price Det Limit': '885000',
    'Metro Div Code': '0',
    'MSA Code': '34900',
    'MSA Name': 'NAPA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 649750,
    '2 Unit': 831800,
    '3 Unit': 1005450,
    '4 Unit': 1249550,
    'County Name': 'NEVADA COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 565000,
    'Median Price Det Limit': '565000',
    'Metro Div Code': '0',
    'MSA Code': '46020',
    'MSA Name': 'TRUCKEE-GRASS VALLEY, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'ORANGE COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1300000,
    'Median Price Det Limit': '1300000',
    'Metro Div Code': '11244',
    'MSA Code': '31080',
    'MSA Name': 'LOS ANGELES-LONG BEACH-ANAHEIM, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 764750,
    '2 Unit': 979000,
    '3 Unit': 1183400,
    '4 Unit': 1470700,
    'County Name': 'PLACER COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 665000,
    'Median Price Det Limit': '665000',
    'Metro Div Code': '0',
    'MSA Code': '40900',
    'MSA Name': 'SACRAMENTO-ROSEVILLE-FOLSOM, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLUMAS COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'RIVERSIDE COUNT',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 600000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '40140',
    'MSA Name': 'RIVERSIDE-SAN BERNARDINO-ONTARIO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 764750,
    '2 Unit': 979000,
    '3 Unit': 1183400,
    '4 Unit': 1470700,
    'County Name': 'SACRAMENTO COUN',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 665000,
    'Median Price Det Limit': '665000',
    'Metro Div Code': '0',
    'MSA Code': '40900',
    'MSA Name': 'SACRAMENTO-ROSEVILLE-FOLSOM, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SAN BENITO COUN',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1820000,
    'Median Price Det Limit': '1820000',
    'Metro Div Code': '0',
    'MSA Code': '41940',
    'MSA Name': 'SAN JOSE-SUNNYVALE-SANTA CLARA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'SAN BERNARDINO',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 600000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '40140',
    'MSA Name': 'RIVERSIDE-SAN BERNARDINO-ONTARIO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1104000,
    '2 Unit': 1413350,
    '3 Unit': 1708400,
    '4 Unit': 2123100,
    'County Name': 'SAN DIEGO COUNT',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 960000,
    'Median Price Det Limit': '960000',
    'Metro Div Code': '0',
    'MSA Code': '41740',
    'MSA Name': 'SAN DIEGO-CHULA VISTA-CARLSBAD, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SAN FRANCISCO C',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1750000,
    'Median Price Det Limit': '1750000',
    'Metro Div Code': '41884',
    'MSA Code': '41860',
    'MSA Name': 'SAN FRANCISCO-OAKLAND-FREMONT, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 678500,
    '2 Unit': 868600,
    '3 Unit': 1049950,
    '4 Unit': 1304850,
    'County Name': 'SAN JOAQUIN COU',
    FIPS: '077',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 589000,
    'Median Price Det Limit': '590000',
    'Metro Div Code': '0',
    'MSA Code': '44700',
    'MSA Name': 'STOCKTON-LODI, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1000500,
    '2 Unit': 1280850,
    '3 Unit': 1548250,
    '4 Unit': 1924100,
    'County Name': 'SAN LUIS OBISPO',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 870000,
    'Median Price Det Limit': '870000',
    'Metro Div Code': '0',
    'MSA Code': '42020',
    'MSA Name': 'SAN LUIS OBISPO-PASO ROBLES, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SAN MATEO COUNT',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1750000,
    'Median Price Det Limit': '1750000',
    'Metro Div Code': '41884',
    'MSA Code': '41860',
    'MSA Name': 'SAN FRANCISCO-OAKLAND-FREMONT, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 941850,
    '2 Unit': 1205750,
    '3 Unit': 1457450,
    '4 Unit': 1811300,
    'County Name': 'SANTA BARBARA C',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 819000,
    'Median Price Det Limit': '819000',
    'Metro Div Code': '0',
    'MSA Code': '42200',
    'MSA Name': 'SANTA MARIA-SANTA BARBARA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SANTA CLARA COU',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1820000,
    'Median Price Det Limit': '1820000',
    'Metro Div Code': '0',
    'MSA Code': '41940',
    'MSA Name': 'SAN JOSE-SUNNYVALE-SANTA CLARA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SANTA CRUZ COUN',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1100000,
    'Median Price Det Limit': '1100000',
    'Metro Div Code': '0',
    'MSA Code': '42100',
    'MSA Name': 'SANTA CRUZ-WATSONVILLE, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHASTA COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '39820',
    'MSA Name': 'REDDING, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIERRA COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SISKIYOU COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 685400,
    '2 Unit': 877450,
    '3 Unit': 1060600,
    '4 Unit': 1318100,
    'County Name': 'SOLANO COUNTY',
    FIPS: '095',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 594000,
    'Median Price Det Limit': '596000',
    'Metro Div Code': '0',
    'MSA Code': '46700',
    'MSA Name': 'VALLEJO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 897000,
    '2 Unit': 1148350,
    '3 Unit': 1388050,
    '4 Unit': 1725050,
    'County Name': 'SONOMA COUNTY',
    FIPS: '097',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 780000,
    'Median Price Det Limit': '780000',
    'Metro Div Code': '0',
    'MSA Code': '42220',
    'MSA Name': 'SANTA ROSA-PETALUMA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 545100,
    '2 Unit': 697800,
    '3 Unit': 843500,
    '4 Unit': 1048300,
    'County Name': 'STANISLAUS COUN',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 474000,
    'Median Price Det Limit': '474000',
    'Metro Div Code': '0',
    'MSA Code': '33700',
    'MSA Name': 'MODESTO, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUTTER COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 452000,
    'Median Price Det Limit': '452000',
    'Metro Div Code': '0',
    'MSA Code': '49700',
    'MSA Name': 'YUBA CITY, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TEHAMA COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '39780',
    'MSA Name': 'RED BLUFF, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRINITY COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TULARE COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 371000,
    'Median Price Det Limit': '371000',
    'Metro Div Code': '0',
    'MSA Code': '47300',
    'MSA Name': 'VISALIA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TUOLUMNE COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 372000,
    'Median Price Det Limit': '372000',
    'Metro Div Code': '0',
    'MSA Code': '43760',
    'MSA Name': 'SONORA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1035000,
    '2 Unit': 1325000,
    '3 Unit': 1601600,
    '4 Unit': 1990450,
    'County Name': 'VENTURA COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 900000,
    'Median Price Det Limit': '900000',
    'Metro Div Code': '0',
    'MSA Code': '37100',
    'MSA Name': 'OXNARD-THOUSAND OAKS-VENTURA, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 764750,
    '2 Unit': 979000,
    '3 Unit': 1183400,
    '4 Unit': 1470700,
    'County Name': 'YOLO COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 665000,
    'Median Price Det Limit': '665000',
    'Metro Div Code': '0',
    'MSA Code': '40900',
    'MSA Name': 'SACRAMENTO-ROSEVILLE-FOLSOM, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YUBA COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 452000,
    'Median Price Det Limit': '452000',
    'Metro Div Code': '0',
    'MSA Code': '49700',
    'MSA Name': 'YUBA CITY, CA',
    'SOA Code': '203B',
    ST: 'CA',
    'State Name': 'CALIFORNIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALAMOSA COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '10480',
    'MSA Name': 'ALAMOSA, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'ARAPAHOE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARCHULETA COUNT',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 406000,
    'Median Price Det Limit': '445000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BACA COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENT COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 879750,
    '2 Unit': 1126250,
    '3 Unit': 1361350,
    '4 Unit': 1691850,
    'County Name': 'BOULDER COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 765000,
    'Median Price Det Limit': '765000',
    'Metro Div Code': '0',
    'MSA Code': '14500',
    'MSA Name': 'BOULDER, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'BROOMFIELD COUN',
    FIPS: '014',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 713000,
    '2 Unit': 912750,
    '3 Unit': 1103350,
    '4 Unit': 1371150,
    'County Name': 'CHAFFEE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 620000,
    'Median Price Det Limit': '620000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEYENNE COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 82000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'CLEAR CREEK COU',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CONEJOS COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '10480',
    'MSA Name': 'ALAMOSA, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COSTILLA COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '10480',
    'MSA Name': 'ALAMOSA, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROWLEY COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 126000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUSTER COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELTA COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'DENVER COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOLORES COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'EAGLE COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1225000,
    'Median Price Det Limit': '1275000',
    'Metro Div Code': '0',
    'MSA Code': '20780',
    'MSA Name': 'EDWARDS, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'ELBERT COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541650,
    '2 Unit': 693400,
    '3 Unit': 838150,
    '4 Unit': 1041650,
    'County Name': 'EL PASO COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 471000,
    'Median Price Det Limit': '471000',
    'Metro Div Code': '0',
    'MSA Code': '17820',
    'MSA Name': 'COLORADO SPRINGS, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREMONT COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 298000,
    'Median Price Det Limit': '298000',
    'Metro Div Code': '0',
    'MSA Code': '15860',
    'MSA Name': 'CANON CITY, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'GARFIELD COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1000000,
    'Median Price Det Limit': '1900000',
    'Metro Div Code': '0',
    'MSA Code': '40090',
    'MSA Name': 'RIFLE, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'GILPIN COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 883200,
    '2 Unit': 1130650,
    '3 Unit': 1366700,
    '4 Unit': 1698500,
    'County Name': 'GRAND COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 768000,
    'Median Price Det Limit': '768000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'GUNNISON COUNTY',
    FIPS: '051',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 584000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'HINSDALE COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 490000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUERFANO COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 153000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 289000,
    'Median Price Det Limit': '289000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIOWA COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 64000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIT CARSON COUN',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1092500,
    '2 Unit': 1398600,
    '3 Unit': 1690600,
    '4 Unit': 2101000,
    'County Name': 'LAKE COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 950000,
    'Median Price Det Limit': '950000',
    'Metro Div Code': '0',
    'MSA Code': '14720',
    'MSA Name': 'BRECKENRIDGE, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'LA PLATA COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '20420',
    'MSA Name': 'DURANGO, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 634800,
    '2 Unit': 812650,
    '3 Unit': 982300,
    '4 Unit': 1220800,
    'County Name': 'LARIMER COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 552000,
    'Median Price Det Limit': '552000',
    'Metro Div Code': '0',
    'MSA Code': '22660',
    'MSA Name': 'FORT COLLINS-LOVELAND, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAS ANIMAS COUN',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 219000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '44540',
    'MSA Name': 'STERLING, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MESA COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '400000',
    'Metro Div Code': '0',
    'MSA Code': '24300',
    'MSA Name': 'GRAND JUNCTION, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINERAL COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 338000,
    'Median Price Det Limit': '338000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1089050,
    '2 Unit': 1394200,
    '3 Unit': 1685250,
    '4 Unit': 2094350,
    'County Name': 'MOFFAT COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 947000,
    'Median Price Det Limit': '947000',
    'Metro Div Code': '0',
    'MSA Code': '44460',
    'MSA Name': 'STEAMBOAT SPRINGS, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTEZUMA COUNT',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTROSE COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 420000,
    'Median Price Det Limit': '420000',
    'Metro Div Code': '0',
    'MSA Code': '33940',
    'MSA Name': 'MONTROSE, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '22820',
    'MSA Name': 'FORT MORGAN, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTERO COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 750950,
    '2 Unit': 961350,
    '3 Unit': 1162050,
    '4 Unit': 1444150,
    'County Name': 'OURAY COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '653000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 862500,
    '2 Unit': 1104150,
    '3 Unit': 1334700,
    '4 Unit': 1658700,
    'County Name': 'PARK COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 750000,
    'Median Price Det Limit': '750000',
    'Metro Div Code': '0',
    'MSA Code': '19740',
    'MSA Name': 'DENVER-AURORA-CENTENNIAL, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PHILLIPS COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '213000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'PITKIN COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1000000,
    'Median Price Det Limit': '1900000',
    'Metro Div Code': '0',
    'MSA Code': '40090',
    'MSA Name': 'RIFLE, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PROWERS COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUEBLO COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '39380',
    'MSA Name': 'PUEBLO, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RIO BLANCO COUN',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RIO GRANDE COUN',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1089050,
    '2 Unit': 1394200,
    '3 Unit': 1685250,
    '4 Unit': 2094350,
    'County Name': 'ROUTT COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 947000,
    'Median Price Det Limit': '947000',
    'Metro Div Code': '0',
    'MSA Code': '44460',
    'MSA Name': 'STEAMBOAT SPRINGS, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAGUACHE COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN JUAN COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 410000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 1045350,
    '2 Unit': 1338250,
    '3 Unit': 1617650,
    '4 Unit': 2010350,
    'County Name': 'SAN MIGUEL COUN',
    FIPS: '113',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '909000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2012',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEDGWICK COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1092500,
    '2 Unit': 1398600,
    '3 Unit': 1690600,
    '4 Unit': 2101000,
    'County Name': 'SUMMIT COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 950000,
    'Median Price Det Limit': '950000',
    'Metro Div Code': '0',
    'MSA Code': '14720',
    'MSA Name': 'BRECKENRIDGE, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541650,
    '2 Unit': 693400,
    '3 Unit': 838150,
    '4 Unit': 1041650,
    'County Name': 'TELLER COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 471000,
    'Median Price Det Limit': '471000',
    'Metro Div Code': '0',
    'MSA Code': '17820',
    'MSA Name': 'COLORADO SPRINGS, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 575000,
    '2 Unit': 736100,
    '3 Unit': 889800,
    '4 Unit': 1105800,
    'County Name': 'WELD COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 500000,
    'Median Price Det Limit': '500000',
    'Metro Div Code': '0',
    'MSA Code': '24540',
    'MSA Name': 'GREELEY, CO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YUMA COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'CO',
    'State Name': 'COLORADO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAPITOL PLANNIN',
    FIPS: '110',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '25540',
    'MSA Name': 'HARTFORD-WEST HARTFORD-EAST HARTFORD, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 977500,
    '2 Unit': 1251400,
    '3 Unit': 1512650,
    '4 Unit': 1879850,
    'County Name': 'GREATER BRIDGEP',
    FIPS: '120',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 850000,
    'Median Price Det Limit': '850000',
    'Metro Div Code': '0',
    'MSA Code': '14860',
    'MSA Name': 'BRIDGEPORT-STAMFORD-DANBURY, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOWER CONNECTIC',
    FIPS: '130',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '25540',
    'MSA Name': 'HARTFORD-WEST HARTFORD-EAST HARTFORD, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NAUGATUCK VALLE',
    FIPS: '140',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 360000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '47930',
    'MSA Name': 'WATERBURY-SHELTON, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHEASTERN CO',
    FIPS: '150',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 360000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '39480',
    'MSA Name': 'PUTNAM, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHWEST HILLS',
    FIPS: '160',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '375000',
    'Metro Div Code': '0',
    'MSA Code': '45860',
    'MSA Name': 'TORRINGTON, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOUTH CENTRAL C',
    FIPS: '170',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 410000,
    'Median Price Det Limit': '410000',
    'Metro Div Code': '0',
    'MSA Code': '35300',
    'MSA Name': 'NEW HAVEN, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOUTHEASTERN CO',
    FIPS: '180',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '35980',
    'MSA Name': 'NORWICH-NEW LONDON-WILLIMANTIC, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 977500,
    '2 Unit': 1251400,
    '3 Unit': 1512650,
    '4 Unit': 1879850,
    'County Name': 'WESTERN CONNECT',
    FIPS: '190',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 850000,
    'Median Price Det Limit': '850000',
    'Metro Div Code': '0',
    'MSA Code': '14860',
    'MSA Name': 'BRIDGEPORT-STAMFORD-DANBURY, CT',
    'SOA Code': '203B',
    ST: 'CT',
    'State Name': 'CONNECTICUT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'DISTRICT OF COL',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '47764',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'DC',
    'State Name': 'DISTRICT OF COLUMBIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENT COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 349000,
    'Median Price Det Limit': '349000',
    'Metro Div Code': '0',
    'MSA Code': '20100',
    'MSA Name': 'DOVER, DE',
    'SOA Code': '203B',
    ST: 'DE',
    'State Name': 'DELAWARE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'NEW CASTLE COUN',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '48864',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'DE',
    'State Name': 'DELAWARE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUSSEX COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 446000,
    'Median Price Det Limit': '446000',
    'Metro Div Code': '0',
    'MSA Code': '42580',
    'MSA Name': 'SEAFORD, DE',
    'SOA Code': '203B',
    ST: 'DE',
    'State Name': 'DELAWARE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALACHUA COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '23540',
    'MSA Name': 'GAINESVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 580750,
    '2 Unit': 743450,
    '3 Unit': 898700,
    '4 Unit': 1116850,
    'County Name': 'BAKER COUNTY',
    FIPS: '003',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 486000,
    'Median Price Det Limit': '505000',
    'Metro Div Code': '0',
    'MSA Code': '27260',
    'MSA Name': 'JACKSONVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAY COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '37460',
    'MSA Name': 'PANAMA CITY-PANAMA CITY BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRADFORD COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BREVARD COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 349000,
    'Median Price Det Limit': '349000',
    'Metro Div Code': '0',
    'MSA Code': '37340',
    'MSA Name': 'PALM BAY-MELBOURNE-TITUSVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 667000,
    '2 Unit': 853900,
    '3 Unit': 1032150,
    '4 Unit': 1282700,
    'County Name': 'BROWARD COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 580000,
    'Median Price Det Limit': '580000',
    'Metro Div Code': '22744',
    'MSA Code': '33100',
    'MSA Name': 'MIAMI-FORT LAUDERDALE-WEST PALM BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 92000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHARLOTTE COUNT',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '329000',
    'Metro Div Code': '0',
    'MSA Code': '39460',
    'MSA Name': 'PUNTA GORDA, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CITRUS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 247000,
    'Median Price Det Limit': '247000',
    'Metro Div Code': '0',
    'MSA Code': '26140',
    'MSA Name': 'HOMOSASSA SPRINGS, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 580750,
    '2 Unit': 743450,
    '3 Unit': 898700,
    '4 Unit': 1116850,
    'County Name': 'CLAY COUNTY',
    FIPS: '019',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 486000,
    'Median Price Det Limit': '505000',
    'Metro Div Code': '0',
    'MSA Code': '27260',
    'MSA Name': 'JACKSONVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 764750,
    '2 Unit': 979000,
    '3 Unit': 1183400,
    '4 Unit': 1470700,
    'County Name': 'COLLIER COUNTY',
    FIPS: '021',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '665000',
    'Metro Div Code': '0',
    'MSA Code': '34940',
    'MSA Name': 'NAPLES-MARCO ISLAND, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '29380',
    'MSA Name': 'LAKE CITY, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DESOTO COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '11580',
    'MSA Name': 'ARCADIA, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DIXIE COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '109000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 580750,
    '2 Unit': 743450,
    '3 Unit': 898700,
    '4 Unit': 1116850,
    'County Name': 'DUVAL COUNTY',
    FIPS: '031',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 486000,
    'Median Price Det Limit': '505000',
    'Metro Div Code': '0',
    'MSA Code': '27260',
    'MSA Name': 'JACKSONVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESCAMBIA COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '37860',
    'MSA Name': 'PENSACOLA-FERRY PASS-BRENT, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLAGLER COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 351000,
    'Median Price Det Limit': '351000',
    'Metro Div Code': '0',
    'MSA Code': '19660',
    'MSA Name': 'DELTONA-DAYTONA BEACH-ORMOND BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GADSDEN COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '45220',
    'MSA Name': 'TALLAHASSEE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILCHRIST COUNT',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '23540',
    'MSA Name': 'GAINESVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GLADES COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '17500',
    'MSA Name': 'CLEWISTON, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GULF COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDEE COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDRY COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '17500',
    'MSA Name': 'CLEWISTON, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HERNANDO COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '45294',
    'MSA Code': '45300',
    'MSA Name': 'TAMPA-ST. PETERSBURG-CLEARWATER, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HIGHLANDS COUNT',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '42700',
    'MSA Name': 'SEBRING, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HILLSBOROUGH CO',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '45294',
    'MSA Code': '45300',
    'MSA Name': 'TAMPA-ST. PETERSBURG-CLEARWATER, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOLMES COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'INDIAN RIVER CO',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 384000,
    'Median Price Det Limit': '384000',
    'Metro Div Code': '0',
    'MSA Code': '42680',
    'MSA Name': 'SEBASTIAN-VERO BEACH-WEST VERO CORRIDOR, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '45220',
    'MSA Name': 'TALLAHASSEE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFAYETTE COUNT',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 453000,
    'Median Price Det Limit': '453000',
    'Metro Div Code': '0',
    'MSA Code': '36740',
    'MSA Name': 'ORLANDO-KISSIMMEE-SANFORD, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 364000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '15980',
    'MSA Name': 'CAPE CORAL-FORT MYERS, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEON COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '45220',
    'MSA Name': 'TALLAHASSEE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEVY COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '23540',
    'MSA Name': 'GAINESVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIBERTY COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 547400,
    '2 Unit': 700750,
    '3 Unit': 847050,
    '4 Unit': 1052700,
    'County Name': 'MANATEE COUNTY',
    FIPS: '081',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 433000,
    'Median Price Det Limit': '476000',
    'Metro Div Code': '0',
    'MSA Code': '35840',
    'MSA Name': 'NORTH PORT-BRADENTON-SARASOTA, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '36100',
    'MSA Name': 'OCALA, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 603750,
    '2 Unit': 772900,
    '3 Unit': 934250,
    '4 Unit': 1161050,
    'County Name': 'MARTIN COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 525000,
    'Median Price Det Limit': '525000',
    'Metro Div Code': '0',
    'MSA Code': '38940',
    'MSA Name': 'PORT ST. LUCIE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 667000,
    '2 Unit': 853900,
    '3 Unit': 1032150,
    '4 Unit': 1282700,
    'County Name': 'MIAMI-DADE COUN',
    FIPS: '086',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 580000,
    'Median Price Det Limit': '580000',
    'Metro Div Code': '33124',
    'MSA Code': '33100',
    'MSA Name': 'MIAMI-FORT LAUDERDALE-WEST PALM BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 990150,
    '2 Unit': 1267600,
    '3 Unit': 1532200,
    '4 Unit': 1904150,
    'County Name': 'MONROE COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 861000,
    'Median Price Det Limit': '861000',
    'Metro Div Code': '0',
    'MSA Code': '28580',
    'MSA Name': 'KEY WEST-KEY LARGO, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 580750,
    '2 Unit': 743450,
    '3 Unit': 898700,
    '4 Unit': 1116850,
    'County Name': 'NASSAU COUNTY',
    FIPS: '089',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 486000,
    'Median Price Det Limit': '505000',
    'Metro Div Code': '0',
    'MSA Code': '27260',
    'MSA Name': 'JACKSONVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 603750,
    '2 Unit': 772900,
    '3 Unit': 934250,
    '4 Unit': 1161050,
    'County Name': 'OKALOOSA COUNTY',
    FIPS: '091',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 505000,
    'Median Price Det Limit': '525000',
    'Metro Div Code': '0',
    'MSA Code': '18880',
    'MSA Name': 'CRESTVIEW-FORT WALTON BEACH-DESTIN, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OKEECHOBEE COUN',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '36380',
    'MSA Name': 'OKEECHOBEE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 453000,
    'Median Price Det Limit': '453000',
    'Metro Div Code': '0',
    'MSA Code': '36740',
    'MSA Name': 'ORLANDO-KISSIMMEE-SANFORD, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSCEOLA COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 453000,
    'Median Price Det Limit': '453000',
    'Metro Div Code': '0',
    'MSA Code': '36740',
    'MSA Name': 'ORLANDO-KISSIMMEE-SANFORD, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 667000,
    '2 Unit': 853900,
    '3 Unit': 1032150,
    '4 Unit': 1282700,
    'County Name': 'PALM BEACH COUN',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 580000,
    'Median Price Det Limit': '580000',
    'Metro Div Code': '48424',
    'MSA Code': '33100',
    'MSA Name': 'MIAMI-FORT LAUDERDALE-WEST PALM BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PASCO COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '45294',
    'MSA Code': '45300',
    'MSA Name': 'TAMPA-ST. PETERSBURG-CLEARWATER, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PINELLAS COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '41304',
    'MSA Code': '45300',
    'MSA Name': 'TAMPA-ST. PETERSBURG-CLEARWATER, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 304000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '29460',
    'MSA Name': 'LAKELAND-WINTER HAVEN, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '37260',
    'MSA Name': 'PALATKA, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 580750,
    '2 Unit': 743450,
    '3 Unit': 898700,
    '4 Unit': 1116850,
    'County Name': 'ST. JOHNS COUNT',
    FIPS: '109',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 486000,
    'Median Price Det Limit': '505000',
    'Metro Div Code': '0',
    'MSA Code': '27260',
    'MSA Name': 'JACKSONVILLE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 603750,
    '2 Unit': 772900,
    '3 Unit': 934250,
    '4 Unit': 1161050,
    'County Name': 'ST. LUCIE COUNT',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 525000,
    'Median Price Det Limit': '525000',
    'Metro Div Code': '0',
    'MSA Code': '38940',
    'MSA Name': 'PORT ST. LUCIE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANTA ROSA COUN',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '37860',
    'MSA Name': 'PENSACOLA-FERRY PASS-BRENT, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 547400,
    '2 Unit': 700750,
    '3 Unit': 847050,
    '4 Unit': 1052700,
    'County Name': 'SARASOTA COUNTY',
    FIPS: '115',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 433000,
    'Median Price Det Limit': '476000',
    'Metro Div Code': '0',
    'MSA Code': '35840',
    'MSA Name': 'NORTH PORT-BRADENTON-SARASOTA, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEMINOLE COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 453000,
    'Median Price Det Limit': '453000',
    'Metro Div Code': '0',
    'MSA Code': '36740',
    'MSA Name': 'ORLANDO-KISSIMMEE-SANFORD, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMTER COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '48680',
    'MSA Name': 'WILDWOOD-THE VILLAGES, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUWANNEE COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 181000,
    'Median Price Det Limit': '181000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VOLUSIA COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 351000,
    'Median Price Det Limit': '351000',
    'Metro Div Code': '0',
    'MSA Code': '19660',
    'MSA Name': 'DELTONA-DAYTONA BEACH-ORMOND BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAKULLA COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '45220',
    'MSA Name': 'TALLAHASSEE, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 603750,
    '2 Unit': 772900,
    '3 Unit': 934250,
    '4 Unit': 1161050,
    'County Name': 'WALTON COUNTY',
    FIPS: '131',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 505000,
    'Median Price Det Limit': '525000',
    'Metro Div Code': '0',
    'MSA Code': '18880',
    'MSA Name': 'CRESTVIEW-FORT WALTON BEACH-DESTIN, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '37460',
    'MSA Name': 'PANAMA CITY-PANAMA CITY BEACH, FL',
    'SOA Code': '203B',
    ST: 'FL',
    'State Name': 'FLORIDA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'APPLING COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ATKINSON COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '20060',
    'MSA Name': 'DOUGLAS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BACON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '81000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAKER COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 30000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BALDWIN COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '33300',
    'MSA Name': 'MILLEDGEVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BANKS COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'BARROW COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'BARTOW COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '31924',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEN HILL COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '88000',
    'Metro Div Code': '0',
    'MSA Code': '22340',
    'MSA Name': 'FITZGERALD, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERRIEN COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BIBB COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '31420',
    'MSA Name': 'MACON-BIBB COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLECKLEY COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRANTLEY COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '15260',
    'MSA Name': 'BRUNSWICK-ST. SIMONS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROOKS COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '46660',
    'MSA Name': 'VALDOSTA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRYAN COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '42340',
    'MSA Name': 'SAVANNAH, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BULLOCH COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '44340',
    'MSA Name': 'STATESBORO, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURKE COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'BUTTS COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 57000,
    'Median Price Det Limit': '78000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMDEN COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 267000,
    'Median Price Det Limit': '267000',
    'Metro Div Code': '0',
    'MSA Code': '28680',
    'MSA Name': 'KINGSLAND, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CANDLER COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'CARROLL COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CATOOSA COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '16860',
    'MSA Name': 'CHATTANOOGA, TN-GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHARLTON COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHATHAM COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '42340',
    'MSA Name': 'SAVANNAH, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHATTAHOOCHEE C',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHATTOOGA COUNT',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '44900',
    'MSA Name': 'SUMMERVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '31924',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 616400,
    '2 Unit': 789100,
    '3 Unit': 953850,
    '4 Unit': 1185400,
    'County Name': 'CLARKE COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 536000,
    'Median Price Det Limit': '536000',
    'Metro Div Code': '0',
    'MSA Code': '12020',
    'MSA Name': 'ATHENS-CLARKE COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'CLAYTON COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINCH COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 57000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'COBB COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '31924',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COFFEE COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '20060',
    'MSA Name': 'DOUGLAS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLQUITT COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '34220',
    'MSA Name': 'MOULTRIE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOK COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'COWETA COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '31420',
    'MSA Name': 'MACON-BIBB COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRISP COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '18380',
    'MSA Name': 'CORDELE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DADE COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '16860',
    'MSA Name': 'CHATTANOOGA, TN-GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'DAWSON COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DECATUR COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '12460',
    'MSA Name': 'BAINBRIDGE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'DEKALB COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DODGE COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOOLY COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGHERTY COUNT',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '10500',
    'MSA Name': 'ALBANY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EARLY COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ECHOLS COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '46660',
    'MSA Name': 'VALDOSTA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EFFINGHAM COUNT',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '42340',
    'MSA Name': 'SAVANNAH, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELBERT COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EMANUEL COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EVANS COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '44340',
    'MSA Name': 'STATESBORO, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FANNIN COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '425000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLOYD COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '40660',
    'MSA Name': 'ROME, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'FORSYTH COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'FULTON COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILMER COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GLASCOCK COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GLYNN COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '15260',
    'MSA Name': 'BRUNSWICK-ST. SIMONS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GORDON COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '15660',
    'MSA Name': 'CALHOUN, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRADY COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '45620',
    'MSA Name': 'THOMASVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 638250,
    '2 Unit': 817050,
    '3 Unit': 987650,
    '4 Unit': 1227400,
    'County Name': 'GREENE COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 555000,
    'Median Price Det Limit': '555000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'GWINNETT COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HABERSHAM COUNT',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '18460',
    'MSA Name': 'CORNELIA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALL COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 389000,
    'Median Price Det Limit': '389000',
    'Metro Div Code': '0',
    'MSA Code': '23580',
    'MSA Name': 'GAINESVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'HARALSON COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '31924',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRIS COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HART COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'HEARD COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'HENRY COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOUSTON COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '47580',
    'MSA Name': 'WARNER ROBINS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IRWIN COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 94000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '400000',
    'Metro Div Code': '0',
    'MSA Code': '27600',
    'MSA Name': 'JEFFERSON, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'JASPER COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFF DAVIS COUN',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 58000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JENKINS COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 73000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '20140',
    'MSA Name': 'DUBLIN, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JONES COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '31420',
    'MSA Name': 'MACON-BIBB COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMAR COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANIER COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '46660',
    'MSA Name': 'VALDOSTA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAURENS COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '20140',
    'MSA Name': 'DUBLIN, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '10500',
    'MSA Name': 'ALBANY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIBERTY COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '25980',
    'MSA Name': 'HINESVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LONG COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '25980',
    'MSA Name': 'HINESVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOWNDES COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '46660',
    'MSA Name': 'VALDOSTA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'LUMPKIN COUNTY',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCDUFFIE COUNTY',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCINTOSH COUNTY',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '15260',
    'MSA Name': 'BRUNSWICK-ST. SIMONS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACON COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 616400,
    '2 Unit': 789100,
    '3 Unit': 953850,
    '4 Unit': 1185400,
    'County Name': 'MADISON COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 536000,
    'Median Price Det Limit': '536000',
    'Metro Div Code': '0',
    'MSA Code': '12020',
    'MSA Name': 'ATHENS-CLARKE COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'MERIWETHER COUN',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILLER COUNTY',
    FIPS: '201',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MITCHELL COUNTY',
    FIPS: '205',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '207',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '31420',
    'MSA Name': 'MACON-BIBB COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '209',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '47080',
    'MSA Name': 'VIDALIA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'MORGAN COUNTY',
    FIPS: '211',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MURRAY COUNTY',
    FIPS: '213',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 233000,
    'Median Price Det Limit': '233000',
    'Metro Div Code': '0',
    'MSA Code': '19140',
    'MSA Name': 'DALTON, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUSCOGEE COUNTY',
    FIPS: '215',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'NEWTON COUNTY',
    FIPS: '217',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 616400,
    '2 Unit': 789100,
    '3 Unit': 953850,
    '4 Unit': 1185400,
    'County Name': 'OCONEE COUNTY',
    FIPS: '219',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 536000,
    'Median Price Det Limit': '536000',
    'Metro Div Code': '0',
    'MSA Code': '12020',
    'MSA Name': 'ATHENS-CLARKE COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 616400,
    '2 Unit': 789100,
    '3 Unit': 953850,
    '4 Unit': 1185400,
    'County Name': 'OGLETHORPE COUN',
    FIPS: '221',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 536000,
    'Median Price Det Limit': '536000',
    'Metro Div Code': '0',
    'MSA Code': '12020',
    'MSA Name': 'ATHENS-CLARKE COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'PAULDING COUNTY',
    FIPS: '223',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '31924',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEACH COUNTY',
    FIPS: '225',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '47580',
    'MSA Name': 'WARNER ROBINS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'PICKENS COUNTY',
    FIPS: '227',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIERCE COUNTY',
    FIPS: '229',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '48180',
    'MSA Name': 'WAYCROSS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'PIKE COUNTY',
    FIPS: '231',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '233',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '16340',
    'MSA Name': 'CEDARTOWN, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '235',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '237',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'QUITMAN COUNTY',
    FIPS: '239',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '21640',
    'MSA Name': 'EUFAULA, AL-GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RABUN COUNTY',
    FIPS: '241',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '243',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHMOND COUNTY',
    FIPS: '245',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'ROCKDALE COUNTY',
    FIPS: '247',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHLEY COUNTY',
    FIPS: '249',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '11140',
    'MSA Name': 'AMERICUS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCREVEN COUNTY',
    FIPS: '251',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 84000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEMINOLE COUNTY',
    FIPS: '253',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'SPALDING COUNTY',
    FIPS: '255',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEPHENS COUNTY',
    FIPS: '257',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '45740',
    'MSA Name': 'TOCCOA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEWART COUNTY',
    FIPS: '259',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMTER COUNTY',
    FIPS: '261',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '11140',
    'MSA Name': 'AMERICUS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TALBOT COUNTY',
    FIPS: '263',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '17980',
    'MSA Name': 'COLUMBUS, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TALIAFERRO COUN',
    FIPS: '265',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '121000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TATTNALL COUNTY',
    FIPS: '267',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '269',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 74000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TELFAIR COUNTY',
    FIPS: '271',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TERRELL COUNTY',
    FIPS: '273',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '10500',
    'MSA Name': 'ALBANY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'THOMAS COUNTY',
    FIPS: '275',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '45620',
    'MSA Name': 'THOMASVILLE, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIFT COUNTY',
    FIPS: '277',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '45700',
    'MSA Name': 'TIFTON, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TOOMBS COUNTY',
    FIPS: '279',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '47080',
    'MSA Name': 'VIDALIA, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TOWNS COUNTY',
    FIPS: '281',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TREUTLEN COUNTY',
    FIPS: '283',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 47000,
    'Median Price Det Limit': '87000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TROUP COUNTY',
    FIPS: '285',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '29300',
    'MSA Name': 'LAGRANGE, GA-AL',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TURNER COUNTY',
    FIPS: '287',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '45700',
    'MSA Name': 'TIFTON, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TWIGGS COUNTY',
    FIPS: '289',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '31420',
    'MSA Name': 'MACON-BIBB COUNTY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '291',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UPSON COUNTY',
    FIPS: '293',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '45580',
    'MSA Name': 'THOMASTON, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALKER COUNTY',
    FIPS: '295',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '16860',
    'MSA Name': 'CHATTANOOGA, TN-GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'WALTON COUNTY',
    FIPS: '297',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '12054',
    'MSA Code': '12060',
    'MSA Name': 'ATLANTA-SANDY SPRINGS-ROSWELL, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARE COUNTY',
    FIPS: '299',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '48180',
    'MSA Name': 'WAYCROSS, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '301',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '303',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '305',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '27700',
    'MSA Name': 'JESUP, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '307',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 50000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHEELER COUNTY',
    FIPS: '309',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 84000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITE COUNTY',
    FIPS: '311',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITFIELD COUNT',
    FIPS: '313',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 233000,
    'Median Price Det Limit': '233000',
    'Metro Div Code': '0',
    'MSA Code': '19140',
    'MSA Name': 'DALTON, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILCOX COUNTY',
    FIPS: '315',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILKES COUNTY',
    FIPS: '317',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILKINSON COUNT',
    FIPS: '319',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WORTH COUNTY',
    FIPS: '321',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '10500',
    'MSA Name': 'ALBANY, GA',
    'SOA Code': '203B',
    ST: 'GA',
    'State Name': 'GEORGIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'GUAM',
    FIPS: '010',
    'Limit Date': 20140101,
    'Limit Type': 'H',
    'Median Price': 444000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'GU',
    'State Name': 'GUAM',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'HAWAII COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 510000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '25900',
    'MSA Name': 'HILO-KAILUA, HI',
    'SOA Code': '203B',
    ST: 'HI',
    'State Name': 'HAWAII',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 828000,
    '2 Unit': 1060000,
    '3 Unit': 1281300,
    '4 Unit': 1592350,
    'County Name': 'HONOLULU COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 720000,
    'Median Price Det Limit': '720000',
    'Metro Div Code': '0',
    'MSA Code': '46520',
    'MSA Name': 'URBAN HONOLULU, HI',
    'SOA Code': '203B',
    ST: 'HI',
    'State Name': 'HAWAII',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1299500,
    '2 Unit': 1663600,
    '3 Unit': 2010950,
    '4 Unit': 2499100,
    'County Name': 'KALAWAO COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1130000,
    'Median Price Det Limit': '1130000',
    'Metro Div Code': '0',
    'MSA Code': '27980',
    'MSA Name': 'KAHULUI-WAILUKU, HI',
    'SOA Code': '203B',
    ST: 'HI',
    'State Name': 'HAWAII',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1110900,
    '2 Unit': 1422150,
    '3 Unit': 1719050,
    '4 Unit': 2136400,
    'County Name': 'KAUAI COUNTY',
    FIPS: '007',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 932000,
    'Median Price Det Limit': '966000',
    'Metro Div Code': '0',
    'MSA Code': '28180',
    'MSA Name': 'KAPAA, HI',
    'SOA Code': '203B',
    ST: 'HI',
    'State Name': 'HAWAII',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1299500,
    '2 Unit': 1663600,
    '3 Unit': 2010950,
    '4 Unit': 2499100,
    'County Name': 'MAUI COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1130000,
    'Median Price Det Limit': '1130000',
    'Metro Div Code': '0',
    'MSA Code': '27980',
    'MSA Name': 'KAHULUI-WAILUKU, HI',
    'SOA Code': '203B',
    ST: 'HI',
    'State Name': 'HAWAII',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAIR COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLAMAKEE COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 156000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'APPANOOSE COUNT',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '109000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AUDUBON COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '113000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '16300',
    'MSA Name': 'CEDAR RAPIDS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLACK HAWK COUN',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '47940',
    'MSA Name': 'WATERLOO-CEDAR FALLS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 266000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '11180',
    'MSA Name': 'AMES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BREMER COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '47940',
    'MSA Name': 'WATERLOO-CEDAR FALLS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUCHANAN COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUENA VISTA COU',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '162000',
    'Metro Div Code': '0',
    'MSA Code': '44740',
    'MSA Name': 'STORM LAKE, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '16140',
    'MSA Name': 'CARROLL, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CEDAR COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 199000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CERRO GORDO COU',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '32380',
    'MSA Name': 'MASON CITY, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHICKASAW COUNT',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 143000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARKE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '43980',
    'MSA Name': 'SPENCER, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAYTON COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '17540',
    'MSA Name': 'CLINTON, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DALLAS COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '19780',
    'MSA Name': 'DES MOINES-WEST DES MOINES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVIS COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DECATUR COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 94000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELAWARE COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DES MOINES COUN',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '15460',
    'MSA Name': 'BURLINGTON, IA-IL',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DICKINSON COUNT',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 360000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '44020',
    'MSA Name': 'SPIRIT LAKE, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUBUQUE COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '20220',
    'MSA Name': 'DUBUQUE, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EMMET COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLOYD COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREMONT COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 121000,
    'Median Price Det Limit': '121000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRUNDY COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '47940',
    'MSA Name': 'WATERLOO-CEDAR FALLS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUTHRIE COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '19780',
    'MSA Name': 'DES MOINES-WEST DES MOINES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 143000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDIN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWARD COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 124000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUMBOLDT COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IDA COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '113000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IOWA COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JASPER COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '19780',
    'MSA Name': 'DES MOINES-WEST DES MOINES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 347000,
    'Median Price Det Limit': '347000',
    'Metro Div Code': '0',
    'MSA Code': '26980',
    'MSA Name': 'IOWA CITY, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JONES COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '16300',
    'MSA Name': 'CEDAR RAPIDS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEOKUK COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KOSSUTH COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '22800',
    'MSA Name': 'FORT MADISON, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINN COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '16300',
    'MSA Name': 'CEDAR RAPIDS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOUISA COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUCAS COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYON COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '19780',
    'MSA Name': 'DES MOINES-WEST DES MOINES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAHASKA COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '36820',
    'MSA Name': 'OSKALOOSA, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '37800',
    'MSA Name': 'PELLA, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '32260',
    'MSA Name': 'MARSHALLTOWN, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILLS COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MITCHELL COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 146000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONONA COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 91000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUSCATINE COUNT',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '34700',
    'MSA Name': 'MUSCATINE, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': "O'BRIEN COUNTY",
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSCEOLA COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAGE COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PALO ALTO COUNT',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLYMOUTH COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '30180',
    'MSA Name': 'LE MARS, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POCAHONTAS COUN',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '86000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '19780',
    'MSA Name': 'DES MOINES-WEST DES MOINES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POTTAWATTAMIE C',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POWESHIEK COUNT',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RINGGOLD COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 82000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAC COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 103000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '19340',
    'MSA Name': 'DAVENPORT-MOLINE-ROCK ISLAND, IA-IL',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIOUX COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STORY COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 266000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '11180',
    'MSA Name': 'AMES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAMA COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAN BUREN COUNT',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 72000,
    'Median Price Det Limit': '84000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAPELLO COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '36900',
    'MSA Name': 'OTTUMWA, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '19780',
    'MSA Name': 'DES MOINES-WEST DES MOINES, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 347000,
    'Median Price Det Limit': '347000',
    'Metro Div Code': '0',
    'MSA Code': '26980',
    'MSA Name': 'IOWA CITY, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 76000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '22700',
    'MSA Name': 'FORT DODGE, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINNEBAGO COUNT',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINNESHIEK COUN',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODBURY COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '359000',
    'Metro Div Code': '0',
    'MSA Code': '43580',
    'MSA Name': 'SIOUX CITY, IA-NE-SD',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WORTH COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '32380',
    'MSA Name': 'MASON CITY, IA',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WRIGHT COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IA',
    'State Name': 'IOWA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'ADA COUNTY',
    FIPS: '001',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 491000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '14260',
    'MSA Name': 'BOISE CITY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 355000,
    'Median Price Det Limit': '355000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BANNOCK COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 331000,
    'Median Price Det Limit': '331000',
    'Metro Div Code': '0',
    'MSA Code': '38540',
    'MSA Name': 'POCATELLO, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAR LAKE COUNT',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 334000,
    'Median Price Det Limit': '334000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENEWAH COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BINGHAM COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 336000,
    'Median Price Det Limit': '336000',
    'Metro Div Code': '0',
    'MSA Code': '13940',
    'MSA Name': 'BLACKFOOT, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 759000,
    '2 Unit': 971650,
    '3 Unit': 1174500,
    '4 Unit': 1459650,
    'County Name': 'BLAINE COUNTY',
    FIPS: '013',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 657000,
    'Median Price Det Limit': '660000',
    'Metro Div Code': '0',
    'MSA Code': '25200',
    'MSA Name': 'HAILEY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'BOISE COUNTY',
    FIPS: '015',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 491000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '14260',
    'MSA Name': 'BOISE CITY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BONNER COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '41760',
    'MSA Name': 'SANDPOINT, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BONNEVILLE COUN',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 410000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '0',
    'MSA Code': '26820',
    'MSA Name': 'IDAHO FALLS, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOUNDARY COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTTE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 410000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '0',
    'MSA Code': '26820',
    'MSA Name': 'IDAHO FALLS, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 759000,
    '2 Unit': 971650,
    '3 Unit': 1174500,
    '4 Unit': 1459650,
    'County Name': 'CAMAS COUNTY',
    FIPS: '025',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 657000,
    'Median Price Det Limit': '660000',
    'Metro Div Code': '0',
    'MSA Code': '25200',
    'MSA Name': 'HAILEY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'CANYON COUNTY',
    FIPS: '027',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 491000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '14260',
    'MSA Name': 'BOISE CITY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARIBOU COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASSIA COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 314000,
    'Median Price Det Limit': '314000',
    'Metro Div Code': '0',
    'MSA Code': '15420',
    'MSA Name': 'BURLEY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEARWATER COUN',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUSTER COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 298000,
    'Median Price Det Limit': '298000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELMORE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 348000,
    'Median Price Det Limit': '348000',
    'Metro Div Code': '0',
    'MSA Code': '34300',
    'MSA Name': 'MOUNTAIN HOME, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '30860',
    'MSA Name': 'LOGAN, UT-ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREMONT COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 384000,
    'Median Price Det Limit': '386000',
    'Metro Div Code': '0',
    'MSA Code': '39940',
    'MSA Name': 'REXBURG, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'GEM COUNTY',
    FIPS: '045',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 491000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '14260',
    'MSA Name': 'BOISE CITY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOODING COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IDAHO COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 284000,
    'Median Price Det Limit': '284000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 410000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '0',
    'MSA Code': '26820',
    'MSA Name': 'IDAHO FALLS, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEROME COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 334000,
    'Median Price Det Limit': '334000',
    'Metro Div Code': '0',
    'MSA Code': '46300',
    'MSA Name': 'TWIN FALLS, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 572700,
    '2 Unit': 733150,
    '3 Unit': 886200,
    '4 Unit': 1101350,
    'County Name': 'KOOTENAI COUNTY',
    FIPS: '055',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 498000,
    'Median Price Det Limit': '498000',
    'Metro Div Code': '0',
    'MSA Code': '17660',
    'MSA Name': "COEUR D'ALENE, ID",
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LATAH COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 398000,
    'Median Price Det Limit': '414000',
    'Metro Div Code': '0',
    'MSA Code': '34140',
    'MSA Name': 'MOSCOW, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEMHI COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 314000,
    'Median Price Det Limit': '314000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 759000,
    '2 Unit': 971650,
    '3 Unit': 1174500,
    '4 Unit': 1459650,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 657000,
    'Median Price Det Limit': '660000',
    'Metro Div Code': '0',
    'MSA Code': '25200',
    'MSA Name': 'HAILEY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 384000,
    'Median Price Det Limit': '386000',
    'Metro Div Code': '0',
    'MSA Code': '39940',
    'MSA Name': 'REXBURG, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINIDOKA COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 314000,
    'Median Price Det Limit': '314000',
    'Metro Div Code': '0',
    'MSA Code': '15420',
    'MSA Name': 'BURLEY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEZ PERCE COUNT',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 357000,
    'Median Price Det Limit': '357000',
    'Metro Div Code': '0',
    'MSA Code': '30300',
    'MSA Name': 'LEWISTON, ID-WA',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONEIDA COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 401000,
    'Median Price Det Limit': '404000',
    'Metro Div Code': '0',
    'MSA Code': '14940',
    'MSA Name': 'BRIGHAM CITY, UT-ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'OWYHEE COUNTY',
    FIPS: '073',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 491000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '14260',
    'MSA Name': 'BOISE CITY, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAYETTE COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '36620',
    'MSA Name': 'ONTARIO, OR-ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POWER COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 278000,
    'Median Price Det Limit': '278000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHOSHONE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'TETON COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1740000,
    'Median Price Det Limit': '1800000',
    'Metro Div Code': '0',
    'MSA Code': '27220',
    'MSA Name': 'JACKSON, WY-ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TWIN FALLS COUN',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 334000,
    'Median Price Det Limit': '334000',
    'Metro Div Code': '0',
    'MSA Code': '46300',
    'MSA Name': 'TWIN FALLS, ID',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 615250,
    '2 Unit': 787650,
    '3 Unit': 952050,
    '4 Unit': 1183200,
    'County Name': 'VALLEY COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 535000,
    'Median Price Det Limit': '535000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 293000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ID',
    'State Name': 'IDAHO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '39500',
    'MSA Name': 'QUINCY, IL-MO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALEXANDER COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '16020',
    'MSA Name': 'CAPE GIRARDEAU, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOND COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 336000,
    'Median Price Det Limit': '336000',
    'Metro Div Code': '0',
    'MSA Code': '40420',
    'MSA Name': 'ROCKFORD, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUREAU COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '36837',
    'MSA Name': 'OTTAWA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 126000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 73000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAMPAIGN COUNT',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '16580',
    'MSA Name': 'CHAMPAIGN-URBANA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHRISTIAN COUNT',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '45380',
    'MSA Name': 'TAYLORVILLE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 101000,
    'Median Price Det Limit': '101000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLES COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '16660',
    'MSA Name': 'CHARLESTON-MATTOON, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOK COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '16984',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 88000,
    'Median Price Det Limit': '88000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '20820',
    'MSA Name': 'EFFINGHAM, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEKALB COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '20994',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DE WITT COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 124000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUPAGE COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '16984',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDGAR COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDWARDS COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '81000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EFFINGHAM COUNT',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '20820',
    'MSA Name': 'EFFINGHAM, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FORD COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '16580',
    'MSA Name': 'CHAMPAIGN-URBANA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 117000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '87000',
    'Metro Div Code': '0',
    'MSA Code': '15900',
    'MSA Name': 'CANTON, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GALLATIN COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '87000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRUNDY COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '16984',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDIN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 64000,
    'Median Price Det Limit': '79000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDERSON COUNT',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '15460',
    'MSA Name': 'BURLINGTON, IA-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '19340',
    'MSA Name': 'DAVENPORT-MOLINE-ROCK ISLAND, IA-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IROQUOIS COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 224000,
    'Median Price Det Limit': '224000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '16060',
    'MSA Name': 'CARBONDALE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JASPER COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '34500',
    'MSA Name': 'MOUNT VERNON, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JERSEY COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JO DAVIESS COUN',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KANE COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '20994',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KANKAKEE COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '182000',
    'Metro Div Code': '0',
    'MSA Code': '28100',
    'MSA Name': 'KANKAKEE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENDALL COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '20994',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '23660',
    'MSA Name': 'GALESBURG, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '29404',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LASALLE COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '36837',
    'MSA Name': 'OTTAWA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '19940',
    'MSA Name': 'DIXON, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVINGSTON COUN',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '38700',
    'MSA Name': 'PONTIAC, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 126000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '30660',
    'MSA Name': 'LINCOLN, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCDONOUGH COUNT',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '31380',
    'MSA Name': 'MACOMB, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCHENRY COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '16984',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCLEAN COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '14010',
    'MSA Name': 'BLOOMINGTON, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACON COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '19500',
    'MSA Name': 'DECATUR, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACOUPIN COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 83000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '16460',
    'MSA Name': 'CENTRALIA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '37900',
    'MSA Name': 'PEORIA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASON COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 84000,
    'Median Price Det Limit': '87000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASSAC COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37140',
    'MSA Name': 'PADUCAH, KY-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MENARD COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '44100',
    'MSA Name': 'SPRINGFIELD, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '19340',
    'MSA Name': 'DAVENPORT-MOLINE-ROCK ISLAND, IA-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '27300',
    'MSA Name': 'JACKSONVILLE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOULTRIE COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OGLE COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '40300',
    'MSA Name': 'ROCHELLE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEORIA COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '37900',
    'MSA Name': 'PEORIA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 82000,
    'Median Price Det Limit': '84000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIATT COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '16580',
    'MSA Name': 'CHAMPAIGN-URBANA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POPE COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 216000,
    'Median Price Det Limit': '216000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '36837',
    'MSA Name': 'OTTAWA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 121000,
    'Median Price Det Limit': '121000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCK ISLAND COU',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '19340',
    'MSA Name': 'DAVENPORT-MOLINE-ROCK ISLAND, IA-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CLAIR COUNT',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALINE COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANGAMON COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '44100',
    'MSA Name': 'SPRINGFIELD, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHUYLER COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '27300',
    'MSA Name': 'JACKSONVILLE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STARK COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '37900',
    'MSA Name': 'PEORIA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEPHENSON COUN',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '133000',
    'Metro Div Code': '0',
    'MSA Code': '23300',
    'MSA Name': 'FREEPORT, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAZEWELL COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '37900',
    'MSA Name': 'PEORIA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VERMILION COUNT',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '19180',
    'MSA Name': 'DANVILLE, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WABASH COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 102000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 91000,
    'Median Price Det Limit': '91000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITE COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 72000,
    'Median Price Det Limit': '79000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITESIDE COUNT',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 124000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '44580',
    'MSA Name': 'STERLING, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILL COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '16984',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILLIAMSON COUN',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '32060',
    'MSA Name': 'MARION-HERRIN, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINNEBAGO COUNT',
    FIPS: '201',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 336000,
    'Median Price Det Limit': '336000',
    'Metro Div Code': '0',
    'MSA Code': '40420',
    'MSA Name': 'ROCKFORD, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODFORD COUNTY',
    FIPS: '203',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '37900',
    'MSA Name': 'PEORIA, IL',
    'SOA Code': '203B',
    ST: 'IL',
    'State Name': 'ILLINOIS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '186000',
    'Metro Div Code': '0',
    'MSA Code': '19540',
    'MSA Name': 'DECATUR, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 249000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '23060',
    'MSA Name': 'FORT WAYNE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARTHOLOMEW COU',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '18020',
    'MSA Name': 'COLUMBUS, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '29200',
    'MSA Name': 'LAFAYETTE-WEST LAFAYETTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLACKFORD COUNT',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '121000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '29200',
    'MSA Name': 'LAFAYETTE-WEST LAFAYETTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '30900',
    'MSA Name': 'LOGANSPORT, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '45460',
    'MSA Name': 'TERRE HAUTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 187000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '23140',
    'MSA Name': 'FRANKFORT, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVIESS COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '47780',
    'MSA Name': 'WASHINGTON, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEARBORN COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DECATUR COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '24700',
    'MSA Name': 'GREENSBURG, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEKALB COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 224000,
    'Median Price Det Limit': '224000',
    'Metro Div Code': '0',
    'MSA Code': '12140',
    'MSA Name': 'AUBURN, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELAWARE COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '34620',
    'MSA Name': 'MUNCIE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUBOIS COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '27540',
    'MSA Name': 'JASPER, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELKHART COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '21140',
    'MSA Name': 'ELKHART-GOSHEN, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '18220',
    'MSA Name': 'CONNERSVILLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLOYD COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FOUNTAIN COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GIBSON COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '31980',
    'MSA Name': 'MARION, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDRICKS COUNT',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 156000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '35220',
    'MSA Name': 'NEW CASTLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWARD COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '29020',
    'MSA Name': 'KOKOMO, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUNTINGTON COUN',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '181000',
    'Metro Div Code': '0',
    'MSA Code': '26540',
    'MSA Name': 'HUNTINGTON, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '42980',
    'MSA Name': 'SEYMOUR, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JASPER COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '29414',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JAY COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '31500',
    'MSA Name': 'MADISON, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JENNINGS COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 133000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '47180',
    'MSA Name': 'VINCENNES, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KOSCIUSKO COUNT',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 223000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '47700',
    'MSA Name': 'WARSAW, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAGRANGE COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 266000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '29414',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAPORTE COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '33140',
    'MSA Name': 'MICHIGAN CITY-LA PORTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '13260',
    'MSA Name': 'BEDFORD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 219000,
    'Median Price Det Limit': '219000',
    'Metro Div Code': '0',
    'MSA Code': '38500',
    'MSA Name': 'PLYMOUTH, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARTIN COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '133000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIAMI COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '37940',
    'MSA Name': 'PERU, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 310000,
    'Median Price Det Limit': '319000',
    'Metro Div Code': '0',
    'MSA Code': '14020',
    'MSA Name': 'BLOOMINGTON, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '18820',
    'MSA Name': 'CRAWFORDSVILLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWTON COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '29414',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOBLE COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '28340',
    'MSA Name': 'KENDALLVILLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OHIO COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGE COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OWEN COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 310000,
    'Median Price Det Limit': '319000',
    'Metro Div Code': '0',
    'MSA Code': '14020',
    'MSA Name': 'BLOOMINGTON, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PARKE COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '181000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PORTER COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '29414',
    'MSA Code': '16980',
    'MSA Name': 'CHICAGO-NAPERVILLE-ELGIN, IL-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POSEY COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '21780',
    'MSA Name': 'EVANSVILLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '176000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '24600',
    'MSA Name': 'GREENCASTLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RIPLEY COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSH COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. JOSEPH COUN',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '43780',
    'MSA Name': 'SOUTH BEND-MISHAWAKA, IN-MI',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '171000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SPENCER COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 162000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STARKE COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEUBEN COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '11420',
    'MSA Name': 'ANGOLA, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLIVAN COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '45460',
    'MSA Name': 'TERRE HAUTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWITZERLAND COU',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIPPECANOE COUN',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '29200',
    'MSA Name': 'LAFAYETTE-WEST LAFAYETTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIPTON COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 455000,
    'Median Price Det Limit': '455000',
    'Metro Div Code': '0',
    'MSA Code': '26900',
    'MSA Name': 'INDIANAPOLIS-CARMEL-GREENWOOD, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VANDERBURGH COU',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '21780',
    'MSA Name': 'EVANSVILLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VERMILLION COUN',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '45460',
    'MSA Name': 'TERRE HAUTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VIGO COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '45460',
    'MSA Name': 'TERRE HAUTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WABASH COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '47340',
    'MSA Name': 'WABASH, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '29200',
    'MSA Name': 'LAFAYETTE-WEST LAFAYETTE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARRICK COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '21780',
    'MSA Name': 'EVANSVILLE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '39980',
    'MSA Name': 'RICHMOND, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WELLS COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 249000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '23060',
    'MSA Name': 'FORT WAYNE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITE COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '33900',
    'MSA Name': 'MONTICELLO, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITLEY COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 249000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '23060',
    'MSA Name': 'FORT WAYNE, IN',
    'SOA Code': '203B',
    ST: 'IN',
    'State Name': 'INDIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEN COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '121000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDERSON COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ATCHISON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '11860',
    'MSA Name': 'ATCHISON, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARBER COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARTON COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 156000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '24460',
    'MSA Name': 'GREAT BEND, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOURBON COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 126000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 241000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48620',
    'MSA Name': 'WICHITA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHASE COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '21380',
    'MSA Name': 'EMPORIA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAUTAUQUA COUN',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 84000,
    'Median Price Det Limit': '84000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '27900',
    'MSA Name': 'JOPLIN, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEYENNE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 207000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 104000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '152000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLOUD COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COFFEY COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 278000,
    'Median Price Det Limit': '278000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COMANCHE COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '113000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COWLEY COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '11680',
    'MSA Name': 'ARKANSAS CITY-WINFIELD, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '38260',
    'MSA Name': 'PITTSBURG, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DECATUR COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 104000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DICKINSON COUNT',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DONIPHAN COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '41140',
    'MSA Name': 'ST. JOSEPH, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 320000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '29940',
    'MSA Name': 'LAWRENCE, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDWARDS COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 94000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELK COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 81000,
    'Median Price Det Limit': '81000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELLIS COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '25700',
    'MSA Name': 'HAYS, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELLSWORTH COUNT',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FINNEY COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 247000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '23780',
    'MSA Name': 'GARDEN CITY, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FORD COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '19980',
    'MSA Name': 'DODGE CITY, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '268000',
    'Metro Div Code': '0',
    'MSA Code': '36840',
    'MSA Name': 'OTTAWA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GEARY COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 303000,
    'Median Price Det Limit': '303000',
    'Metro Div Code': '0',
    'MSA Code': '31740',
    'MSA Name': 'MANHATTAN, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOVE COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAHAM COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 81000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAY COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 189000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREELEY COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENWOOD COUNT',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARPER COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 103000,
    'Median Price Det Limit': '116000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARVEY COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 241000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48620',
    'MSA Name': 'WICHITA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HASKELL COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 201000,
    'Median Price Det Limit': '212000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HODGEMAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '243000',
    'Metro Div Code': '0',
    'MSA Code': '45820',
    'MSA Name': 'TOPEKA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '243000',
    'Metro Div Code': '0',
    'MSA Code': '45820',
    'MSA Name': 'TOPEKA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEWELL COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 266000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEARNY COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KINGMAN COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 143000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIOWA COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LABETTE COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEAVENWORTH COU',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 201000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINN COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYON COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '21380',
    'MSA Name': 'EMPORIA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCPHERSON COUNT',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '32700',
    'MSA Name': 'MCPHERSON, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEADE COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 162000,
    'Median Price Det Limit': '187000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIAMI COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MITCHELL COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORRIS COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORTON COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEMAHA COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEOSHO COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NESS COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '113000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTON COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 69000,
    'Median Price Det Limit': '213000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSAGE COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '243000',
    'Metro Div Code': '0',
    'MSA Code': '45820',
    'MSA Name': 'TOPEKA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSBORNE COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '113000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTTAWA COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 218000,
    'Median Price Det Limit': '218000',
    'Metro Div Code': '0',
    'MSA Code': '41460',
    'MSA Name': 'SALINA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAWNEE COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PHILLIPS COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 126000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POTTAWATOMIE CO',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 303000,
    'Median Price Det Limit': '303000',
    'Metro Div Code': '0',
    'MSA Code': '31740',
    'MSA Name': 'MANHATTAN, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRATT COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '152000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RAWLINS COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RENO COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 166000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '26740',
    'MSA Name': 'HUTCHINSON, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REPUBLIC COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 101000,
    'Median Price Det Limit': '101000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICE COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RILEY COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 303000,
    'Median Price Det Limit': '303000',
    'Metro Div Code': '0',
    'MSA Code': '31740',
    'MSA Name': 'MANHATTAN, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROOKS COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSH COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSSELL COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALINE COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 218000,
    'Median Price Det Limit': '218000',
    'Metro Div Code': '0',
    'MSA Code': '41460',
    'MSA Name': 'SALINA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '249000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEDGWICK COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 241000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48620',
    'MSA Name': 'WICHITA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEWARD COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '30580',
    'MSA Name': 'LIBERAL, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHAWNEE COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '243000',
    'Metro Div Code': '0',
    'MSA Code': '45820',
    'MSA Name': 'TOPEKA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERIDAN COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 202000,
    'Median Price Det Limit': '202000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERMAN COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SMITH COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 121000,
    'Median Price Det Limit': '121000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STAFFORD COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '131000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STANTON COUNTY',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEVENS COUNTY',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '182000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMNER COUNTY',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 241000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48620',
    'MSA Name': 'WICHITA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'THOMAS COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TREGO COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 153000,
    'Median Price Det Limit': '212000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WABAUNSEE COUNT',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '243000',
    'Metro Div Code': '0',
    'MSA Code': '45820',
    'MSA Name': 'TOPEKA, KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALLACE COUNTY',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '131000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '201',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WICHITA COUNTY',
    FIPS: '203',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILSON COUNTY',
    FIPS: '205',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODSON COUNTY',
    FIPS: '207',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WYANDOTTE COUNT',
    FIPS: '209',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'KS',
    'State Name': 'KANSAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAIR COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '14540',
    'MSA Name': 'BOWLING GREEN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDERSON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '23180',
    'MSA Name': 'FRANKFORT, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BALLARD COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37140',
    'MSA Name': 'PADUCAH, KY-IL',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARREN COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '23980',
    'MSA Name': 'GLASGOW, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BATH COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '34460',
    'MSA Name': 'MOUNT STERLING, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BELL COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '33180',
    'MSA Name': 'MIDDLESBOROUGH, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOURBON COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '30460',
    'MSA Name': 'LEXINGTON-FAYETTE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOYD COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOYLE COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '19220',
    'MSA Name': 'DANVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRACKEN COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BREATHITT COUNT',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 20000,
    'Median Price Det Limit': '63000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRECKINRIDGE CO',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '87000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BULLITT COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '14540',
    'MSA Name': 'BOWLING GREEN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALDWELL COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 89000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALLOWAY COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '34660',
    'MSA Name': 'MURRAY, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMPBELL COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARLISLE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37140',
    'MSA Name': 'PADUCAH, KY-IL',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARTER COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASEY COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 184000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHRISTIAN COUNT',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 305000,
    'Median Price Det Limit': '305000',
    'Metro Div Code': '0',
    'MSA Code': '17300',
    'MSA Name': 'CLARKSVILLE, TN-KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '30460',
    'MSA Name': 'LEXINGTON-FAYETTE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '18340',
    'MSA Name': 'CORBIN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 72000,
    'Median Price Det Limit': '74000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2012',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRITTENDEN COUN',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 53000,
    'Median Price Det Limit': '202000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVIESS COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '36980',
    'MSA Name': 'OWENSBORO, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDMONSON COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '14540',
    'MSA Name': 'BOWLING GREEN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELLIOTT COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESTILL COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '40080',
    'MSA Name': 'RICHMOND-BEREA, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '30460',
    'MSA Name': 'LEXINGTON-FAYETTE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLEMING COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 102000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLOYD COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '38210',
    'MSA Name': 'PIKEVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '23180',
    'MSA Name': 'FRANKFORT, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GALLATIN COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARRARD COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAVES COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '32460',
    'MSA Name': 'MAYFIELD, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAYSON COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '372000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREEN COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '15820',
    'MSA Name': 'CAMPBELLSVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENUP COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDIN COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '21060',
    'MSA Name': 'ELIZABETHTOWN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARLAN COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 35000,
    'Median Price Det Limit': '67000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HART COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 251000,
    'Median Price Det Limit': '251000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDERSON COUNT',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '25775',
    'MSA Name': 'HENDERSON, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HICKMAN COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOPKINS COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '31580',
    'MSA Name': 'MADISONVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 39000,
    'Median Price Det Limit': '73000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JESSAMINE COUNT',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '30460',
    'MSA Name': 'LEXINGTON-FAYETTE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENTON COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOTT COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 72000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '18340',
    'MSA Name': 'CORBIN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LARUE COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '21060',
    'MSA Name': 'ELIZABETHTOWN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAUREL COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '18340',
    'MSA Name': 'CORBIN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LESLIE COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 101000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LETCHER COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 96000,
    'Median Price Det Limit': '96000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 54000,
    'Median Price Det Limit': '60000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '19220',
    'MSA Name': 'DANVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVINGSTON COUN',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37140',
    'MSA Name': 'PADUCAH, KY-IL',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYON COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCRACKEN COUNT',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37140',
    'MSA Name': 'PADUCAH, KY-IL',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCREARY COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 116000,
    'Median Price Det Limit': '116000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCLEAN COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '36980',
    'MSA Name': 'OWENSBORO, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '40080',
    'MSA Name': 'RICHMOND-BEREA, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAGOFFIN COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 25000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARTIN COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASON COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEADE COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MENIFEE COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '34460',
    'MSA Name': 'MOUNT STERLING, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'METCALFE COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '23980',
    'MSA Name': 'GLASGOW, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '82000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '34460',
    'MSA Name': 'MOUNT STERLING, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 116000,
    'Median Price Det Limit': '116000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUHLENBERG COUN',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 84000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NELSON COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NICHOLAS COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OHIO COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OLDHAM COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OWEN COUNTY',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OWSLEY COUNTY',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENDLETON COUNT',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '131000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 109000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '38210',
    'MSA Name': 'PIKEVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POWELL COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '43700',
    'MSA Name': 'SOMERSET, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROBERTSON COUNT',
    FIPS: '201',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 103000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCKCASTLE COUN',
    FIPS: '203',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '40080',
    'MSA Name': 'RICHMOND-BEREA, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROWAN COUNTY',
    FIPS: '205',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSSELL COUNTY',
    FIPS: '207',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 88000,
    'Median Price Det Limit': '88000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '209',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '30460',
    'MSA Name': 'LEXINGTON-FAYETTE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '211',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIMPSON COUNTY',
    FIPS: '213',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 363000,
    'Median Price Det Limit': '363000',
    'Metro Div Code': '0',
    'MSA Code': '23190',
    'MSA Name': 'FRANKLIN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SPENCER COUNTY',
    FIPS: '215',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 427000,
    'Median Price Det Limit': '427000',
    'Metro Div Code': '0',
    'MSA Code': '31140',
    'MSA Name': 'LOUISVILLE\/JEFFERSON COUNTY, KY-IN',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '217',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '15820',
    'MSA Name': 'CAMPBELLSVILLE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TODD COUNTY',
    FIPS: '219',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRIGG COUNTY',
    FIPS: '221',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 305000,
    'Median Price Det Limit': '305000',
    'Metro Div Code': '0',
    'MSA Code': '17300',
    'MSA Name': 'CLARKSVILLE, TN-KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRIMBLE COUNTY',
    FIPS: '223',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '131000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '225',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '227',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '14540',
    'MSA Name': 'BOWLING GREEN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '229',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '223000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '231',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '233',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '25775',
    'MSA Name': 'HENDERSON, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITLEY COUNTY',
    FIPS: '235',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '18340',
    'MSA Name': 'CORBIN, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOLFE COUNTY',
    FIPS: '237',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 25000,
    'Median Price Det Limit': '73000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODFORD COUNTY',
    FIPS: '239',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '30460',
    'MSA Name': 'LEXINGTON-FAYETTE, KY',
    'SOA Code': '203B',
    ST: 'KY',
    'State Name': 'KENTUCKY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ACADIA PARISH',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '29180',
    'MSA Name': 'LAFAYETTE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEN PARISH',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASCENSION PARIS',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASSUMPTION PARI',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AVOYELLES PARIS',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 82000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2010',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAUREGARD PARI',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '19760',
    'MSA Name': 'DERIDDER, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BIENVILLE PARIS',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOSSIER PARISH',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 233000,
    'Median Price Det Limit': '233000',
    'Metro Div Code': '0',
    'MSA Code': '43340',
    'MSA Name': 'SHREVEPORT-BOSSIER CITY, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CADDO PARISH',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 233000,
    'Median Price Det Limit': '233000',
    'Metro Div Code': '0',
    'MSA Code': '43340',
    'MSA Name': 'SHREVEPORT-BOSSIER CITY, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALCASIEU PARIS',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '29340',
    'MSA Name': 'LAKE CHARLES, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALDWELL PARISH',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMERON PARISH',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '29340',
    'MSA Name': 'LAKE CHARLES, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CATAHOULA PARIS',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '109000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAIBORNE PARIS',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '92000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CONCORDIA PARIS',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '35020',
    'MSA Name': 'NATCHEZ, MS-LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DE SOTO PARISH',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 233000,
    'Median Price Det Limit': '233000',
    'Metro Div Code': '0',
    'MSA Code': '43340',
    'MSA Name': 'SHREVEPORT-BOSSIER CITY, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EAST BATON ROUG',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EAST CARROLL PA',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EAST FELICIANA',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EVANGELINE PARI',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '92000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN PARISH',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT PARISH',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '10780',
    'MSA Name': 'ALEXANDRIA, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IBERIA PARISH',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '35340',
    'MSA Name': 'NEW IBERIA, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IBERVILLE PARIS',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON PARISH',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 83000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON PARIS',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON DAVIS',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '29340',
    'MSA Name': 'LAKE CHARLES, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFAYETTE PARIS',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '29180',
    'MSA Name': 'LAFAYETTE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFOURCHE PARIS',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '26380',
    'MSA Name': 'HOUMA-BAYOU CANE-THIBODAUX, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LA SALLE PARISH',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 176000,
    'Median Price Det Limit': '304000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN PARISH',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 213000,
    'Median Price Det Limit': '213000',
    'Metro Div Code': '0',
    'MSA Code': '40820',
    'MSA Name': 'RUSTON, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVINGSTON PARI',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON PARISH',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOREHOUSE PARIS',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '33740',
    'MSA Name': 'MONROE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NATCHITOCHES PA',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '35060',
    'MSA Name': 'NATCHITOCHES, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORLEANS PARISH',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OUACHITA PARISH',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '33740',
    'MSA Name': 'MONROE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLAQUEMINES PAR',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POINTE COUPEE P',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RAPIDES PARISH',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '10780',
    'MSA Name': 'ALEXANDRIA, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RED RIVER PARIS',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND PARISH',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '33740',
    'MSA Name': 'MONROE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SABINE PARISH',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. BERNARD PAR',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CHARLES PAR',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. HELENA PARI',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. JAMES PARIS',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. JOHN THE BA',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '35380',
    'MSA Name': 'NEW ORLEANS-METAIRIE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. LANDRY PARI',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '36660',
    'MSA Name': 'OPELOUSAS, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. MARTIN PARI',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '29180',
    'MSA Name': 'LAFAYETTE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. MARY PARISH',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '34020',
    'MSA Name': 'MORGAN CITY, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. TAMMANY PAR',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 281000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '43640',
    'MSA Name': 'SLIDELL-MANDEVILLE-COVINGTON, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TANGIPAHOA PARI',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '25220',
    'MSA Name': 'HAMMOND, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TENSAS PARISH',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 97000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TERREBONNE PARI',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '26380',
    'MSA Name': 'HOUMA-BAYOU CANE-THIBODAUX, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION PARISH',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '33740',
    'MSA Name': 'MONROE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VERMILION PARIS',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '29180',
    'MSA Name': 'LAFAYETTE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VERNON PARISH',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON PARI',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '14220',
    'MSA Name': 'BOGALUSA, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER PARISH',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '33380',
    'MSA Name': 'MINDEN, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEST BATON ROUG',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEST CARROLL PA',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEST FELICIANA',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '12940',
    'MSA Name': 'BATON ROUGE, LA',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINN PARISH',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 124000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'LA',
    'State Name': 'LOUISIANA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 828000,
    '2 Unit': 1060000,
    '3 Unit': 1281300,
    '4 Unit': 1592350,
    'County Name': 'BARNSTABLE COUN',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 720000,
    'Median Price Det Limit': '720000',
    'Metro Div Code': '0',
    'MSA Code': '12700',
    'MSA Name': 'BARNSTABLE TOWN, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERKSHIRE COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 328000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '38340',
    'MSA Name': 'PITTSFIELD, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 787750,
    '2 Unit': 1008450,
    '3 Unit': 1219000,
    '4 Unit': 1514950,
    'County Name': 'BRISTOL COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 685000,
    'Median Price Det Limit': '685000',
    'Metro Div Code': '0',
    'MSA Code': '39300',
    'MSA Name': 'PROVIDENCE-WARWICK, RI-MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'DUKES COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1520000,
    'Median Price Det Limit': '1520000',
    'Metro Div Code': '0',
    'MSA Code': '47240',
    'MSA Name': 'VINEYARD HAVEN, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'ESSEX COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '15764',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '24640',
    'MSA Name': 'GREENFIELD, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMPDEN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '44140',
    'MSA Name': 'SPRINGFIELD, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMPSHIRE COUNT',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 418000,
    'Median Price Det Limit': '418000',
    'Metro Div Code': '0',
    'MSA Code': '11200',
    'MSA Name': 'AMHERST TOWN-NORTHAMPTON, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'MIDDLESEX COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '15764',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'NANTUCKET COUNT',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 2375000,
    'Median Price Det Limit': '2525000',
    'Metro Div Code': '0',
    'MSA Code': '34880',
    'MSA Name': 'NANTUCKET, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'NORFOLK COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '14454',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'PLYMOUTH COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '14454',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'SUFFOLK COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '14454',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 545100,
    '2 Unit': 697800,
    '3 Unit': 843500,
    '4 Unit': 1048300,
    'County Name': 'WORCESTER COUNT',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 474000,
    'Median Price Det Limit': '474000',
    'Metro Div Code': '0',
    'MSA Code': '49340',
    'MSA Name': 'WORCESTER, MA',
    'SOA Code': '203B',
    ST: 'MA',
    'State Name': 'MASSACHUSETTS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEGANY COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 187000,
    'Median Price Det Limit': '187000',
    'Metro Div Code': '0',
    'MSA Code': '19060',
    'MSA Name': 'CUMBERLAND, MD-WV',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'ANNE ARUNDEL CO',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'BALTIMORE COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALVERT COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '30500',
    'MSA Name': 'LEXINGTON PARK, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAROLINE COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'CARROLL COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'CECIL COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '48864',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'CHARLES COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '47764',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DORCHESTER COUN',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '15700',
    'MSA Name': 'CAMBRIDGE, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'FREDERICK COUNT',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '23224',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARRETT COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'HARFORD COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'HOWARD COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENT COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 310000,
    'Median Price Det Limit': '310000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '23224',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': "PRINCE GEORGE'S",
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '47764',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': "QUEEN ANNE'S CO",
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': "ST. MARY'S COUN",
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '30500',
    'MSA Name': 'LEXINGTON PARK, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOMERSET COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '41540',
    'MSA Name': 'SALISBURY, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TALBOT COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 465000,
    'Median Price Det Limit': '465000',
    'Metro Div Code': '0',
    'MSA Code': '20660',
    'MSA Name': 'EASTON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '25180',
    'MSA Name': 'HAGERSTOWN-MARTINSBURG, MD-WV',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WICOMICO COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '41540',
    'MSA Name': 'SALISBURY, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WORCESTER COUNT',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 390000,
    'Median Price Det Limit': '390000',
    'Metro Div Code': '0',
    'MSA Code': '36180',
    'MSA Name': 'OCEAN PINES, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 747500,
    '2 Unit': 956950,
    '3 Unit': 1156700,
    '4 Unit': 1437500,
    'County Name': 'BALTIMORE CITY',
    FIPS: '510',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '650000',
    'Metro Div Code': '0',
    'MSA Code': '12580',
    'MSA Name': 'BALTIMORE-COLUMBIA-TOWSON, MD',
    'SOA Code': '203B',
    ST: 'MD',
    'State Name': 'MARYLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDROSCOGGIN CO',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 318000,
    'Median Price Det Limit': '318000',
    'Metro Div Code': '0',
    'MSA Code': '30340',
    'MSA Name': 'LEWISTON-AUBURN, ME',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AROOSTOOK COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 615250,
    '2 Unit': 787650,
    '3 Unit': 952050,
    '4 Unit': 1183200,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 535000,
    'Median Price Det Limit': '535000',
    'Metro Div Code': '0',
    'MSA Code': '38860',
    'MSA Name': 'PORTLAND-SOUTH PORTLAND, ME',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 246000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENNEBEC COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '12300',
    'MSA Name': 'AUGUSTA-WATERVILLE, ME',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 361000,
    'Median Price Det Limit': '386000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 359000,
    'Median Price Det Limit': '359000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OXFORD COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENOBSCOT COUNT',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 284000,
    'Median Price Det Limit': '284000',
    'Metro Div Code': '0',
    'MSA Code': '12620',
    'MSA Name': 'BANGOR, ME',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PISCATAQUIS COU',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 615250,
    '2 Unit': 787650,
    '3 Unit': 952050,
    '4 Unit': 1183200,
    'County Name': 'SAGADAHOC COUNT',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 535000,
    'Median Price Det Limit': '535000',
    'Metro Div Code': '0',
    'MSA Code': '38860',
    'MSA Name': 'PORTLAND-SOUTH PORTLAND, ME',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOMERSET COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALDO COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 221000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 615250,
    '2 Unit': 787650,
    '3 Unit': 952050,
    '4 Unit': 1183200,
    'County Name': 'YORK COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 535000,
    'Median Price Det Limit': '535000',
    'Metro Div Code': '0',
    'MSA Code': '38860',
    'MSA Name': 'PORTLAND-SOUTH PORTLAND, ME',
    'SOA Code': '203B',
    ST: 'ME',
    'State Name': 'MAINE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALCONA COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALGER COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEGAN COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '26090',
    'MSA Name': 'HOLLAND, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALPENA COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '10980',
    'MSA Name': 'ALPENA, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANTRIM COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 177000,
    'Median Price Det Limit': '177000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARENAC COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARAGA COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARRY COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '24340',
    'MSA Name': 'GRAND RAPIDS-WYOMING-KENTWOOD, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAY COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '13020',
    'MSA Name': 'BAY CITY, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENZIE COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '45900',
    'MSA Name': 'TRAVERSE CITY, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERRIEN COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '35660',
    'MSA Name': 'NILES, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRANCH COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '17740',
    'MSA Name': 'COLDWATER, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '12980',
    'MSA Name': 'BATTLE CREEK, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '43780',
    'MSA Name': 'SOUTH BEND-MISHAWAKA, IN-MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHARLEVOIX COUN',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 398000,
    'Median Price Det Limit': '398000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEBOYGAN COUNT',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 320000,
    'Median Price Det Limit': '357000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHIPPEWA COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '42300',
    'MSA Name': 'SAULT STE. MARIE, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARE COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '29620',
    'MSA Name': 'LANSING-EAST LANSING, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELTA COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 133000,
    'Median Price Det Limit': '133000',
    'Metro Div Code': '0',
    'MSA Code': '21540',
    'MSA Name': 'ESCANABA, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DICKINSON COUNT',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '27020',
    'MSA Name': 'IRON MOUNTAIN, MI-WI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EATON COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '29620',
    'MSA Name': 'LANSING-EAST LANSING, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EMMET COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '37950',
    'MSA Name': 'PETOSKEY, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GENESEE COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '22420',
    'MSA Name': 'FLINT, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GLADWIN COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOGEBIC COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAND TRAVERSE',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '45900',
    'MSA Name': 'TRAVERSE CITY, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRATIOT COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '10940',
    'MSA Name': 'ALMA, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HILLSDALE COUNT',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '25880',
    'MSA Name': 'HILLSDALE, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOUGHTON COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '26340',
    'MSA Name': 'HOUGHTON, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HURON COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'INGHAM COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '29620',
    'MSA Name': 'LANSING-EAST LANSING, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IONIA COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '24340',
    'MSA Name': 'GRAND RAPIDS-WYOMING-KENTWOOD, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IOSCO COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IRON COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ISABELLA COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 186000,
    'Median Price Det Limit': '186000',
    'Metro Div Code': '0',
    'MSA Code': '34380',
    'MSA Name': 'MOUNT PLEASANT, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '27100',
    'MSA Name': 'JACKSON, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KALAMAZOO COUNT',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '28020',
    'MSA Name': 'KALAMAZOO-PORTAGE, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KALKASKA COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '45900',
    'MSA Name': 'TRAVERSE CITY, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENT COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '24340',
    'MSA Name': 'GRAND RAPIDS-WYOMING-KENTWOOD, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEWEENAW COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '26340',
    'MSA Name': 'HOUGHTON, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAPEER COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '362000',
    'Metro Div Code': '47664',
    'MSA Code': '19820',
    'MSA Name': 'DETROIT-WARREN-DEARBORN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEELANAU COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '45900',
    'MSA Name': 'TRAVERSE CITY, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LENAWEE COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '10300',
    'MSA Name': 'ADRIAN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVINGSTON COUN',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '362000',
    'Metro Div Code': '47664',
    'MSA Code': '19820',
    'MSA Name': 'DETROIT-WARREN-DEARBORN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUCE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 99000,
    'Median Price Det Limit': '153000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACKINAC COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACOMB COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '362000',
    'Metro Div Code': '47664',
    'MSA Code': '19820',
    'MSA Name': 'DETROIT-WARREN-DEARBORN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MANISTEE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARQUETTE COUNT',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '32100',
    'MSA Name': 'MARQUETTE, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASON COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '31220',
    'MSA Name': 'LUDINGTON, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MECOSTA COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 189000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '13660',
    'MSA Name': 'BIG RAPIDS, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MENOMINEE COUNT',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '31940',
    'MSA Name': 'MARINETTE, WI-MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIDLAND COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '33220',
    'MSA Name': 'MIDLAND, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MISSAUKEE COUNT',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 171000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '15620',
    'MSA Name': 'CADILLAC, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '33780',
    'MSA Name': 'MONROE, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTCALM COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '24340',
    'MSA Name': 'GRAND RAPIDS-WYOMING-KENTWOOD, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTMORENCY COU',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUSKEGON COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '34740',
    'MSA Name': 'MUSKEGON-NORTON SHORES, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWAYGO COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OAKLAND COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '362000',
    'Metro Div Code': '47664',
    'MSA Code': '19820',
    'MSA Name': 'DETROIT-WARREN-DEARBORN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OCEANA COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OGEMAW COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONTONAGON COUNT',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '87000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSCEOLA COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSCODA COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 102000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTSEGO COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 304000,
    'Median Price Det Limit': '304000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTTAWA COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '24340',
    'MSA Name': 'GRAND RAPIDS-WYOMING-KENTWOOD, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRESQUE ISLE CO',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROSCOMMON COUNT',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAGINAW COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '40980',
    'MSA Name': 'SAGINAW, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CLAIR COUNT',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '362000',
    'Metro Div Code': '47664',
    'MSA Code': '19820',
    'MSA Name': 'DETROIT-WARREN-DEARBORN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. JOSEPH COUN',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '44780',
    'MSA Name': 'STURGIS, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANILAC COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHOOLCRAFT COU',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHIAWASSEE COUN',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '37020',
    'MSA Name': 'OWOSSO, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TUSCOLA COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAN BUREN COUNT',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHTENAW COUNT',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 385000,
    'Median Price Det Limit': '385000',
    'Metro Div Code': '0',
    'MSA Code': '11460',
    'MSA Name': 'ANN ARBOR, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '362000',
    'Metro Div Code': '19804',
    'MSA Code': '19820',
    'MSA Name': 'DETROIT-WARREN-DEARBORN, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEXFORD COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 171000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '15620',
    'MSA Name': 'CADILLAC, MI',
    'SOA Code': '203B',
    ST: 'MI',
    'State Name': 'MICHIGAN',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AITKIN COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'ANOKA COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BECKER COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 255000,
    'Median Price Det Limit': '255000',
    'Metro Div Code': '0',
    'MSA Code': '19810',
    'MSA Name': 'DETROIT LAKES, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BELTRAMI COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '13420',
    'MSA Name': 'BEMIDJI, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '41060',
    'MSA Name': 'ST. CLOUD, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BIG STONE COUNT',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLUE EARTH COUN',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '31860',
    'MSA Name': 'MANKATO, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '182000',
    'Metro Div Code': '0',
    'MSA Code': '35580',
    'MSA Name': 'NEW ULM, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARLTON COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '20260',
    'MSA Name': 'DULUTH, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'CARVER COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 256000,
    'Median Price Det Limit': '256000',
    'Metro Div Code': '0',
    'MSA Code': '14660',
    'MSA Name': 'BRAINERD, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHIPPEWA COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'CHISAGO COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '22020',
    'MSA Name': 'FARGO, ND-MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEARWATER COUN',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOK COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COTTONWOOD COUN',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 133000,
    'Median Price Det Limit': '133000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROW WING COUNT',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 256000,
    'Median Price Det Limit': '256000',
    'Metro Div Code': '0',
    'MSA Code': '14660',
    'MSA Name': 'BRAINERD, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'DAKOTA COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DODGE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '40340',
    'MSA Name': 'ROCHESTER, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '10820',
    'MSA Name': 'ALEXANDRIA, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FARIBAULT COUNT',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FILLMORE COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '40340',
    'MSA Name': 'ROCHESTER, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREEBORN COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '10660',
    'MSA Name': 'ALBERT LEA, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOODHUE COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '39860',
    'MSA Name': 'RED WING, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'HENNEPIN COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOUSTON COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '29100',
    'MSA Name': 'LA CROSSE-ONALASKA, WI-MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUBBARD COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'ISANTI COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ITASCA COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '24330',
    'MSA Name': 'GRAND RAPIDS, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KANABEC COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KANDIYOHI COUNT',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '48820',
    'MSA Name': 'WILLMAR, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KITTSON COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KOOCHICHING COU',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAC QUI PARLE C',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE OF THE WOO',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'LE SUEUR COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYON COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '32140',
    'MSA Name': 'MARSHALL, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCLEOD COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '26780',
    'MSA Name': 'HUTCHINSON, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAHNOMEN COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARTIN COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '21860',
    'MSA Name': 'FAIRMONT, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEEKER COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 219000,
    'Median Price Det Limit': '219000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'MILLE LACS COUN',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORRISON COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOWER COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '12380',
    'MSA Name': 'AUSTIN, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MURRAY COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NICOLLET COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '31860',
    'MSA Name': 'MANKATO, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOBLES COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '49380',
    'MSA Name': 'WORTHINGTON, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORMAN COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OLMSTED COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '40340',
    'MSA Name': 'ROCHESTER, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTTER TAIL COUN',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '22260',
    'MSA Name': 'FERGUS FALLS, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENNINGTON COUN',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PINE COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIPESTONE COUNT',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '24220',
    'MSA Name': 'GRAND FORKS, ND-MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POPE COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'RAMSEY COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RED LAKE COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REDWOOD COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RENVILLE COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICE COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 316000,
    'Median Price Det Limit': '316000',
    'Metro Div Code': '0',
    'MSA Code': '22060',
    'MSA Name': 'FARIBAULT-NORTHFIELD, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCK COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 405000,
    'Median Price Det Limit': '405000',
    'Metro Div Code': '0',
    'MSA Code': '43620',
    'MSA Name': 'SIOUX FALLS, SD-MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROSEAU COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. LOUIS COUNT',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '20260',
    'MSA Name': 'DULUTH, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'SCOTT COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'SHERBURNE COUNT',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIBLEY COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEARNS COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '41060',
    'MSA Name': 'ST. CLOUD, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEELE COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 256000,
    'Median Price Det Limit': '256000',
    'Metro Div Code': '0',
    'MSA Code': '36940',
    'MSA Name': 'OWATONNA, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEVENS COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWIFT COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '113000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TODD COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRAVERSE COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '93000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WABASHA COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '40340',
    'MSA Name': 'ROCHESTER, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WADENA COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASECA COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'WASHINGTON COUN',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WATONWAN COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILKIN COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '47420',
    'MSA Name': 'WAHPETON, ND-MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINONA COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 233000,
    'Median Price Det Limit': '233000',
    'Metro Div Code': '0',
    'MSA Code': '49100',
    'MSA Name': 'WINONA, MN',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'WRIGHT COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YELLOW MEDICINE',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MN',
    'State Name': 'MINNESOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAIR COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '28860',
    'MSA Name': 'KIRKSVILLE, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDREW COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '41140',
    'MSA Name': 'ST. JOSEPH, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ATCHISON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AUDRAIN COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 167000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '33020',
    'MSA Name': 'MEXICO, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARRY COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARTON COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BATES COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOLLINGER COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '16020',
    'MSA Name': 'CAPE GIRARDEAU, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 312000,
    'Median Price Det Limit': '312000',
    'Metro Div Code': '0',
    'MSA Code': '17860',
    'MSA Name': 'COLUMBIA, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUCHANAN COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '41140',
    'MSA Name': 'ST. JOSEPH, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '38740',
    'MSA Name': 'POPLAR BLUFF, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALDWELL COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALLAWAY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 287000,
    'Median Price Det Limit': '287000',
    'Metro Div Code': '0',
    'MSA Code': '27620',
    'MSA Name': 'JEFFERSON CITY, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMDEN COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 389000,
    'Median Price Det Limit': '389000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAPE GIRARDEAU',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '16020',
    'MSA Name': 'CAPE GIRARDEAU, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 153000,
    'Median Price Det Limit': '153000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARTER COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 201000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CEDAR COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHARITON COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 156000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHRISTIAN COUNT',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '309000',
    'Metro Div Code': '0',
    'MSA Code': '44180',
    'MSA Name': 'SPRINGFIELD, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLE COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 287000,
    'Median Price Det Limit': '287000',
    'Metro Div Code': '0',
    'MSA Code': '27620',
    'MSA Name': 'JEFFERSON CITY, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOPER COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 312000,
    'Median Price Det Limit': '312000',
    'Metro Div Code': '0',
    'MSA Code': '17860',
    'MSA Name': 'COLUMBIA, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DADE COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 218000,
    'Median Price Det Limit': '218000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DALLAS COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '309000',
    'Metro Div Code': '0',
    'MSA Code': '44180',
    'MSA Name': 'SPRINGFIELD, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVIESS COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEKALB COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '41140',
    'MSA Name': 'ST. JOSEPH, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DENT COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 207000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '182000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUNKLIN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '131000',
    'Metro Div Code': '0',
    'MSA Code': '28380',
    'MSA Name': 'KENNETT, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GASCONADE COUNT',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 207000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GENTRY COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '309000',
    'Metro Div Code': '0',
    'MSA Code': '44180',
    'MSA Name': 'SPRINGFIELD, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRUNDY COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '216000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HICKORY COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOLT COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWARD COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 312000,
    'Median Price Det Limit': '312000',
    'Metro Div Code': '0',
    'MSA Code': '17860',
    'MSA Name': 'COLUMBIA, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWELL COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '48460',
    'MSA Name': 'WEST PLAINS, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IRON COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JASPER COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '27900',
    'MSA Name': 'JOPLIN, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '47660',
    'MSA Name': 'WARRENSBURG, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LACLEDE COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '30060',
    'MSA Name': 'LEBANON, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFAYETTE COUNT',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 199000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '39500',
    'MSA Name': 'QUINCY, IL-MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINN COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVINGSTON COUN',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 171000,
    'Median Price Det Limit': '171000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCDONALD COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACON COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARIES COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 207000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '25300',
    'MSA Name': 'HANNIBAL, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILLER COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MISSISSIPPI COU',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 162000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '43460',
    'MSA Name': 'SIKESTON, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONITEAU COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 287000,
    'Median Price Det Limit': '287000',
    'Metro Div Code': '0',
    'MSA Code': '27620',
    'MSA Name': 'JEFFERSON CITY, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 176000,
    'Median Price Det Limit': '176000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEW MADRID COUN',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWTON COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '27900',
    'MSA Name': 'JOPLIN, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NODAWAY COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '32340',
    'MSA Name': 'MARYVILLE, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OREGON COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSAGE COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 287000,
    'Median Price Det Limit': '287000',
    'Metro Div Code': '0',
    'MSA Code': '27620',
    'MSA Name': 'JEFFERSON CITY, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OZARK COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 186000,
    'Median Price Det Limit': '186000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEMISCOT COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 226000,
    'Median Price Det Limit': '226000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PETTIS COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 199000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '42740',
    'MSA Name': 'SEDALIA, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PHELPS COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '40620',
    'MSA Name': 'ROLLA, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 189000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLATTE COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '309000',
    'Metro Div Code': '0',
    'MSA Code': '44180',
    'MSA Name': 'SPRINGFIELD, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '22780',
    'MSA Name': 'FORT LEONARD WOOD, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RALLS COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '25300',
    'MSA Name': 'HANNIBAL, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '33620',
    'MSA Name': 'MOBERLY, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RAY COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 454000,
    'Median Price Det Limit': '454000',
    'Metro Div Code': '0',
    'MSA Code': '28140',
    'MSA Name': 'KANSAS CITY, MO-KS',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REYNOLDS COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RIPLEY COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 143000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CHARLES COU',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CLAIR COUNT',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STE. GENEVIEVE',
    FIPS: '186',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. FRANCOIS CO',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '22100',
    'MSA Name': 'FARMINGTON, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. LOUIS COUNT',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALINE COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '32180',
    'MSA Name': 'MARSHALL, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHUYLER COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '28860',
    'MSA Name': 'KIRKSVILLE, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTLAND COUNTY',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '201',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 162000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '43460',
    'MSA Name': 'SIKESTON, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHANNON COUNTY',
    FIPS: '203',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '205',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STODDARD COUNTY',
    FIPS: '207',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STONE COUNTY',
    FIPS: '209',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLIVAN COUNTY',
    FIPS: '211',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TANEY COUNTY',
    FIPS: '213',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '14700',
    'MSA Name': 'BRANSON, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TEXAS COUNTY',
    FIPS: '215',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VERNON COUNTY',
    FIPS: '217',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '219',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '221',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '223',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '225',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 309000,
    'Median Price Det Limit': '309000',
    'Metro Div Code': '0',
    'MSA Code': '44180',
    'MSA Name': 'SPRINGFIELD, MO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WORTH COUNTY',
    FIPS: '227',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 131000,
    'Median Price Det Limit': '131000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WRIGHT COUNTY',
    FIPS: '229',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. LOUIS CITY',
    FIPS: '510',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '41180',
    'MSA Name': 'ST. LOUIS, MO-IL',
    'SOA Code': '203B',
    ST: 'MO',
    'State Name': 'MISSOURI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHERN ISLAND',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 104000,
    'Median Price Det Limit': '456000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MP',
    'State Name': '(NORTHERN) MARIANA ISLANDS',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROTA MUNICIPALI',
    FIPS: '100',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '357000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MP',
    'State Name': '(NORTHERN) MARIANA ISLANDS',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAIPAN MUNICIPA',
    FIPS: '110',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 322000,
    'Median Price Det Limit': '460000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MP',
    'State Name': '(NORTHERN) MARIANA ISLANDS',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TINIAN MUNICIPA',
    FIPS: '120',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '463000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MP',
    'State Name': '(NORTHERN) MARIANA ISLANDS',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '35020',
    'MSA Name': 'NATCHEZ, MS-LA',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALCORN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 184000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '18420',
    'MSA Name': 'CORINTH, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AMITE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 116000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ATTALA COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOLIVAR COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '17380',
    'MSA Name': 'CLEVELAND, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 107000,
    'Median Price Det Limit': '109000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '24900',
    'MSA Name': 'GREENWOOD, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHICKASAW COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHOCTAW COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAIBORNE COUNT',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 104000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARKE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '32940',
    'MSA Name': 'MERIDIAN, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COAHOMA COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '17260',
    'MSA Name': 'CLARKSDALE, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COPIAH COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COVINGTON COUNT',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DESOTO COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FORREST COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '25620',
    'MSA Name': 'HATTIESBURG, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 88000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GEORGE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 217000,
    'Median Price Det Limit': '217000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRENADA COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '24980',
    'MSA Name': 'GRENADA, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '25060',
    'MSA Name': 'GULFPORT-BILOXI, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '25060',
    'MSA Name': 'GULFPORT-BILOXI, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HINDS COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOLMES COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUMPHREYS COUNT',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ISSAQUENA COUNT',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ITAWAMBA COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 286000,
    'Median Price Det Limit': '286000',
    'Metro Div Code': '0',
    'MSA Code': '46180',
    'MSA Name': 'TUPELO, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '25060',
    'MSA Name': 'GULFPORT-BILOXI, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JASPER COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '29860',
    'MSA Name': 'LAUREL, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '35020',
    'MSA Name': 'NATCHEZ, MS-LA',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON DAVIS',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JONES COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '29860',
    'MSA Name': 'LAUREL, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEMPER COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 89000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFAYETTE COUNT',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 408000,
    'Median Price Det Limit': '408000',
    'Metro Div Code': '0',
    'MSA Code': '37060',
    'MSA Name': 'OXFORD, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMAR COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '25620',
    'MSA Name': 'HATTIESBURG, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAUDERDALE COUN',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '32940',
    'MSA Name': 'MERIDIAN, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEAKE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 286000,
    'Median Price Det Limit': '286000',
    'Metro Div Code': '0',
    'MSA Code': '46180',
    'MSA Name': 'TUPELO, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEFLORE COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '24900',
    'MSA Name': 'GREENWOOD, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '183000',
    'Metro Div Code': '0',
    'MSA Code': '15020',
    'MSA Name': 'BROOKHAVEN, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOWNDES COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 226000,
    'Median Price Det Limit': '226000',
    'Metro Div Code': '0',
    'MSA Code': '18060',
    'MSA Name': 'COLUMBUS, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '24980',
    'MSA Name': 'GRENADA, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NESHOBA COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWTON COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 133000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOXUBEE COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 226000,
    'Median Price Det Limit': '226000',
    'Metro Div Code': '0',
    'MSA Code': '18060',
    'MSA Name': 'COLUMBUS, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OKTIBBEHA COUNT',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 312000,
    'Median Price Det Limit': '312000',
    'Metro Div Code': '0',
    'MSA Code': '44260',
    'MSA Name': 'STARKVILLE, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PANOLA COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEARL RIVER COU',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 216000,
    'Median Price Det Limit': '216000',
    'Metro Div Code': '0',
    'MSA Code': '38100',
    'MSA Name': 'PICAYUNE, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '25620',
    'MSA Name': 'HATTIESBURG, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 242000,
    'Median Price Det Limit': '242000',
    'Metro Div Code': '0',
    'MSA Code': '32620',
    'MSA Name': 'MCCOMB, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PONTOTOC COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 293000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRENTISS COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 286000,
    'Median Price Det Limit': '286000',
    'Metro Div Code': '0',
    'MSA Code': '46180',
    'MSA Name': 'TUPELO, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'QUITMAN COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 89000,
    'Median Price Det Limit': '89000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANKIN COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHARKEY COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 16000,
    'Median Price Det Limit': '116000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIMPSON COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SMITH COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STONE COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '25060',
    'MSA Name': 'GULFPORT-BILOXI, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUNFLOWER COUNT',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TALLAHATCHIE CO',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TATE COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIPPAH COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 166000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TISHOMINGO COUN',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TUNICA COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALTHALL COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 242000,
    'Median Price Det Limit': '242000',
    'Metro Div Code': '0',
    'MSA Code': '32620',
    'MSA Name': 'MCCOMB, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 186000,
    'Median Price Det Limit': '187000',
    'Metro Div Code': '0',
    'MSA Code': '46980',
    'MSA Name': 'VICKSBURG, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '24740',
    'MSA Name': 'GREENVILLE, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 252000,
    'Median Price Det Limit': '252000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 312000,
    'Median Price Det Limit': '312000',
    'Metro Div Code': '0',
    'MSA Code': '44260',
    'MSA Name': 'STARKVILLE, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILKINSON COUNT',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 104000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINSTON COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 156000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YALOBUSHA COUNT',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 408000,
    'Median Price Det Limit': '408000',
    'Metro Div Code': '0',
    'MSA Code': '37060',
    'MSA Name': 'OXFORD, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YAZOO COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 327000,
    'Median Price Det Limit': '327000',
    'Metro Div Code': '0',
    'MSA Code': '27140',
    'MSA Name': 'JACKSON, MS',
    'SOA Code': '203B',
    ST: 'MS',
    'State Name': 'MISSISSIPPI',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAVERHEAD COUN',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 316000,
    'Median Price Det Limit': '324000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BIG HORN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLAINE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 183000,
    'Median Price Det Limit': '297000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROADWATER COUN',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 441000,
    'Median Price Det Limit': '441000',
    'Metro Div Code': '0',
    'MSA Code': '25740',
    'MSA Name': 'HELENA, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 754400,
    '2 Unit': 965750,
    '3 Unit': 1167400,
    '4 Unit': 1450800,
    'County Name': 'CARBON COUNTY',
    FIPS: '009',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 606000,
    'Median Price Det Limit': '656000',
    'Metro Div Code': '0',
    'MSA Code': '13740',
    'MSA Name': 'BILLINGS, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARTER COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASCADE COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 317000,
    'Median Price Det Limit': '317000',
    'Metro Div Code': '0',
    'MSA Code': '24500',
    'MSA Name': 'GREAT FALLS, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHOUTEAU COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUSTER COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '298000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DANIELS COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 251000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAWSON COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEER LODGE COUN',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 268000,
    'Median Price Det Limit': '273000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FALLON COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 334000,
    'Median Price Det Limit': '343000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FERGUS COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 615250,
    '2 Unit': 787650,
    '3 Unit': 952050,
    '4 Unit': 1183200,
    'County Name': 'FLATHEAD COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 535000,
    'Median Price Det Limit': '535000',
    'Metro Div Code': '0',
    'MSA Code': '28060',
    'MSA Name': 'KALISPELL, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'GALLATIN COUNTY',
    FIPS: '031',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 620000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '0',
    'MSA Code': '14580',
    'MSA Name': 'BOZEMAN, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARFIELD COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 251000,
    'Median Price Det Limit': '252000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GLACIER COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 201000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOLDEN VALLEY C',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANITE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 399000,
    'Median Price Det Limit': '399000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HILL COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 264000,
    'Median Price Det Limit': '272000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 441000,
    'Median Price Det Limit': '441000',
    'Metro Div Code': '0',
    'MSA Code': '25740',
    'MSA Name': 'HELENA, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JUDITH BASIN CO',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 266000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 426000,
    'Median Price Det Limit': '426000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS AND CLARK',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 441000,
    'Median Price Det Limit': '441000',
    'Metro Div Code': '0',
    'MSA Code': '25740',
    'MSA Name': 'HELENA, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIBERTY COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '226000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 316000,
    'Median Price Det Limit': '316000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCONE COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 203000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 438000,
    'Median Price Det Limit': '438000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEAGHER COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '244000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'MINERAL COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '33540',
    'MSA Name': 'MISSOULA, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'MISSOULA COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '33540',
    'MSA Name': 'MISSOULA, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUSSELSHELL COU',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 312000,
    'Median Price Det Limit': '329000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'PARK COUNTY',
    FIPS: '067',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 488000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PETROLEUM COUNT',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PHILLIPS COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 257000,
    'Median Price Det Limit': '272000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PONDERA COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POWDER RIVER CO',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 217000,
    'Median Price Det Limit': '217000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POWELL COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 360000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRAIRIE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 560050,
    '2 Unit': 716950,
    '3 Unit': 866650,
    '4 Unit': 1077050,
    'County Name': 'RAVALLI COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 487000,
    'Median Price Det Limit': '487000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '379000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROOSEVELT COUNT',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '244000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROSEBUD COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANDERS COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 313000,
    'Median Price Det Limit': '313000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERIDAN COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SILVER BOW COUN',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 303000,
    'Median Price Det Limit': '303000',
    'Metro Div Code': '0',
    'MSA Code': '15580',
    'MSA Name': 'BUTTE-SILVER BOW, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 754400,
    '2 Unit': 965750,
    '3 Unit': 1167400,
    '4 Unit': 1450800,
    'County Name': 'STILLWATER COUN',
    FIPS: '095',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 606000,
    'Median Price Det Limit': '656000',
    'Metro Div Code': '0',
    'MSA Code': '13740',
    'MSA Name': 'BILLINGS, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWEET GRASS COU',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 392000,
    'Median Price Det Limit': '392000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TETON COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TOOLE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 186000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TREASURE COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 303000,
    'Median Price Det Limit': '312000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VALLEY COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHEATLAND COUNT',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '243000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WIBAUX COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 754400,
    '2 Unit': 965750,
    '3 Unit': 1167400,
    '4 Unit': 1450800,
    'County Name': 'YELLOWSTONE COU',
    FIPS: '111',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 606000,
    'Median Price Det Limit': '656000',
    'Metro Div Code': '0',
    'MSA Code': '13740',
    'MSA Name': 'BILLINGS, MT',
    'SOA Code': '203B',
    ST: 'MT',
    'State Name': 'MONTANA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALAMANCE COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '15500',
    'MSA Name': 'BURLINGTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALEXANDER COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '25860',
    'MSA Name': 'HICKORY-LENOIR-MORGANTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEGHANY COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANSON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASHE COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AVERY COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAUFORT COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '47820',
    'MSA Name': 'WASHINGTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERTIE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 50000,
    'Median Price Det Limit': '75000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLADEN COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRUNSWICK COUNT',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 430000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '48900',
    'MSA Name': 'WILMINGTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUNCOMBE COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '11700',
    'MSA Name': 'ASHEVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURKE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '25860',
    'MSA Name': 'HICKORY-LENOIR-MORGANTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CABARRUS COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALDWELL COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '25860',
    'MSA Name': 'HICKORY-LENOIR-MORGANTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'CAMDEN COUNTY',
    FIPS: '029',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARTERET COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 399000,
    'Median Price Det Limit': '399000',
    'Metro Div Code': '0',
    'MSA Code': '33980',
    'MSA Name': 'MOREHEAD CITY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASWELL COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CATAWBA COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '25860',
    'MSA Name': 'HICKORY-LENOIR-MORGANTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 634800,
    '2 Unit': 812650,
    '3 Unit': 982300,
    '4 Unit': 1220800,
    'County Name': 'CHATHAM COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 552000,
    'Median Price Det Limit': '552000',
    'Metro Div Code': '0',
    'MSA Code': '20500',
    'MSA Name': 'DURHAM-CHAPEL HILL, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHOWAN COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEVELAND COUNT',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '43140',
    'MSA Name': 'SHELBY-KINGS MOUNTAIN, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBUS COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAVEN COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '35100',
    'MSA Name': 'NEW BERN, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '273000',
    'Metro Div Code': '0',
    'MSA Code': '22180',
    'MSA Name': 'FAYETTEVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'CURRITUCK COUNT',
    FIPS: '053',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'DARE COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '0',
    'MSA Code': '28620',
    'MSA Name': 'KILL DEVIL HILLS, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVIDSON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '49180',
    'MSA Name': 'WINSTON-SALEM, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVIE COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '49180',
    'MSA Name': 'WINSTON-SALEM, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUPLIN COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 634800,
    '2 Unit': 812650,
    '3 Unit': 982300,
    '4 Unit': 1220800,
    'County Name': 'DURHAM COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 552000,
    'Median Price Det Limit': '552000',
    'Metro Div Code': '0',
    'MSA Code': '20500',
    'MSA Name': 'DURHAM-CHAPEL HILL, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDGECOMBE COUNT',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '40580',
    'MSA Name': 'ROCKY MOUNT, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FORSYTH COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '49180',
    'MSA Name': 'WINSTON-SALEM, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 468000,
    'Median Price Det Limit': '468000',
    'Metro Div Code': '0',
    'MSA Code': '39580',
    'MSA Name': 'RALEIGH-CARY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GASTON COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'GATES COUNTY',
    FIPS: '073',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAHAM COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANVILLE COUNT',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUILFORD COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '24660',
    'MSA Name': 'GREENSBORO-HIGH POINT, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALIFAX COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '40260',
    'MSA Name': 'ROANOKE RAPIDS, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARNETT COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 320000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '11360',
    'MSA Name': 'ANDERSON CREEK, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAYWOOD COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '48200',
    'MSA Name': 'WAYNESVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDERSON COUNT',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '11700',
    'MSA Name': 'ASHEVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HERTFORD COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOKE COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '273000',
    'Metro Div Code': '0',
    'MSA Code': '22180',
    'MSA Name': 'FAYETTEVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HYDE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '420000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IREDELL COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 349000,
    'Median Price Det Limit': '349000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSTON COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 468000,
    'Median Price Det Limit': '468000',
    'Metro Div Code': '0',
    'MSA Code': '39580',
    'MSA Name': 'RALEIGH-CARY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JONES COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '35100',
    'MSA Name': 'NEW BERN, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '41820',
    'MSA Name': 'SANFORD, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LENOIR COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 153000,
    'Median Price Det Limit': '153000',
    'Metro Div Code': '0',
    'MSA Code': '28820',
    'MSA Name': 'KINSTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCDOWELL COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '32000',
    'MSA Name': 'MARION, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MACON COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '11700',
    'MSA Name': 'ASHEVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARTIN COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 99000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MECKLENBURG COU',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MITCHELL COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOORE COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 400000,
    'Median Price Det Limit': '400000',
    'Metro Div Code': '0',
    'MSA Code': '38240',
    'MSA Name': 'PINEHURST-SOUTHERN PINES, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NASH COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '40580',
    'MSA Name': 'ROCKY MOUNT, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEW HANOVER COU',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 430000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '48900',
    'MSA Name': 'WILMINGTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHAMPTON COU',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '40260',
    'MSA Name': 'ROANOKE RAPIDS, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONSLOW COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '27340',
    'MSA Name': 'JACKSONVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 634800,
    '2 Unit': 812650,
    '3 Unit': 982300,
    '4 Unit': 1220800,
    'County Name': 'ORANGE COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 552000,
    'Median Price Det Limit': '552000',
    'Metro Div Code': '0',
    'MSA Code': '20500',
    'MSA Name': 'DURHAM-CHAPEL HILL, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAMLICO COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '35100',
    'MSA Name': 'NEW BERN, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PASQUOTANK COUN',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '21020',
    'MSA Name': 'ELIZABETH CITY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENDER COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 430000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '48900',
    'MSA Name': 'WILMINGTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 805000,
    '2 Unit': 1030550,
    '3 Unit': 1245700,
    '4 Unit': 1548100,
    'County Name': 'PERQUIMANS COUN',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 175000,
    'Median Price Det Limit': '700000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2010',
  },
  {
    '1 Unit': 634800,
    '2 Unit': 812650,
    '3 Unit': 982300,
    '4 Unit': 1220800,
    'County Name': 'PERSON COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 552000,
    'Median Price Det Limit': '552000',
    'Metro Div Code': '0',
    'MSA Code': '20500',
    'MSA Name': 'DURHAM-CHAPEL HILL, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PITT COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '24780',
    'MSA Name': 'GREENVILLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 396000,
    'Median Price Det Limit': '396000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '24660',
    'MSA Name': 'GREENSBORO-HIGH POINT, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHMOND COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 117000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '40460',
    'MSA Name': 'ROCKINGHAM, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROBESON COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '31300',
    'MSA Name': 'LUMBERTON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCKINGHAM COUN',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '24660',
    'MSA Name': 'GREENSBORO-HIGH POINT, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROWAN COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUTHERFORD COUN',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '22580',
    'MSA Name': 'FOREST CITY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAMPSON COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTLAND COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 86000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '29900',
    'MSA Name': 'LAURINBURG, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STANLY COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '10620',
    'MSA Name': 'ALBEMARLE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STOKES COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '49180',
    'MSA Name': 'WINSTON-SALEM, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SURRY COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '34340',
    'MSA Name': 'MOUNT AIRY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWAIN COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '221000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRANSYLVANIA CO',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 403000,
    'Median Price Det Limit': '403000',
    'Metro Div Code': '0',
    'MSA Code': '14820',
    'MSA Name': 'BREVARD, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TYRRELL COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VANCE COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '25780',
    'MSA Name': 'HENDERSON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAKE COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 468000,
    'Median Price Det Limit': '468000',
    'Metro Div Code': '0',
    'MSA Code': '39580',
    'MSA Name': 'RALEIGH-CARY, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WATAUGA COUNTY',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 448000,
    'Median Price Det Limit': '448000',
    'Metro Div Code': '0',
    'MSA Code': '14380',
    'MSA Name': 'BOONE, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '24140',
    'MSA Name': 'GOLDSBORO, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILKES COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '35900',
    'MSA Name': 'NORTH WILKESBORO, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILSON COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '48980',
    'MSA Name': 'WILSON, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YADKIN COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '49180',
    'MSA Name': 'WINSTON-SALEM, NC',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YANCEY COUNTY',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 249000,
    'Median Price Det Limit': '249000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NC',
    'State Name': 'NORTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARNES COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENSON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BILLINGS COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 404000,
    'Median Price Det Limit': '442000',
    'Metro Div Code': '0',
    'MSA Code': '19860',
    'MSA Name': 'DICKINSON, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOTTINEAU COUNT',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOWMAN COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 101000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURKE COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 67000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURLEIGH COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 337000,
    'Median Price Det Limit': '337000',
    'Metro Div Code': '0',
    'MSA Code': '13900',
    'MSA Name': 'BISMARCK, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '22020',
    'MSA Name': 'FARGO, ND-MN',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAVALIER COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DICKEY COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DIVIDE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2012',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUNN COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 404000,
    'Median Price Det Limit': '442000',
    'Metro Div Code': '0',
    'MSA Code': '19860',
    'MSA Name': 'DICKINSON, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDDY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '91000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EMMONS COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 121000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FOSTER COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOLDEN VALLEY C',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2014',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAND FORKS COU',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '24220',
    'MSA Name': 'GRAND FORKS, ND-MN',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRIGGS COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 82000,
    'Median Price Det Limit': '93000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HETTINGER COUNT',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIDDER COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMOURE COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 76000,
    'Median Price Det Limit': '81000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCHENRY COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '33500',
    'MSA Name': 'MINOT, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCINTOSH COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 333000,
    'Median Price Det Limit': '333000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCKENZIE COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 373000,
    'Median Price Det Limit': '373000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCLEAN COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '181000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORTON COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 337000,
    'Median Price Det Limit': '337000',
    'Metro Div Code': '0',
    'MSA Code': '13900',
    'MSA Name': 'BISMARCK, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOUNTRAIL COUNT',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2014',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NELSON COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2015',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OLIVER COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 337000,
    'Median Price Det Limit': '337000',
    'Metro Div Code': '0',
    'MSA Code': '13900',
    'MSA Name': 'BISMARCK, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEMBINA COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIERCE COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 133000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RAMSEY COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANSOM COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RENVILLE COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '33500',
    'MSA Name': 'MINOT, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '47420',
    'MSA Name': 'WAHPETON, ND-MN',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROLETTE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SARGENT COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERIDAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 72000,
    'Median Price Det Limit': '86000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIOUX COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2014',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SLOPE COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STARK COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 404000,
    'Median Price Det Limit': '442000',
    'Metro Div Code': '0',
    'MSA Code': '19860',
    'MSA Name': 'DICKINSON, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEELE COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2014',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STUTSMAN COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '27420',
    'MSA Name': 'JAMESTOWN, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TOWNER COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRAILL COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALSH COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 122000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARD COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '33500',
    'MSA Name': 'MINOT, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WELLS COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 96000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2014',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILLIAMS COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '48780',
    'MSA Name': 'WILLISTON, ND',
    'SOA Code': '203B',
    ST: 'ND',
    'State Name': 'NORTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '25580',
    'MSA Name': 'HASTINGS, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANTELOPE COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARTHUR COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BANNER COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 221000,
    'Median Price Det Limit': '244000',
    'Metro Div Code': '0',
    'MSA Code': '42420',
    'MSA Name': 'SCOTTSBLUFF, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLAINE COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '176000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOX BUTTE COUNT',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '223000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOYD COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 17000,
    'Median Price Det Limit': '45000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUFFALO COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '28260',
    'MSA Name': 'KEARNEY, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURT COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CEDAR COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHASE COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '244000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHERRY COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEYENNE COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '25580',
    'MSA Name': 'HASTINGS, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLFAX COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '18100',
    'MSA Name': 'COLUMBUS, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMING COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUSTER COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 118000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAKOTA COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '359000',
    'Metro Div Code': '0',
    'MSA Code': '43580',
    'MSA Name': 'SIOUX CITY, IA-NE-SD',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAWES COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 603750,
    '2 Unit': 772900,
    '3 Unit': 934250,
    '4 Unit': 1161050,
    'County Name': 'DAWSON COUNTY',
    FIPS: '047',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 307000,
    'Median Price Det Limit': '525000',
    'Metro Div Code': '0',
    'MSA Code': '30420',
    'MSA Name': 'LEXINGTON, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEUEL COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DIXON COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DODGE COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 202000,
    'Median Price Det Limit': '204000',
    'Metro Div Code': '0',
    'MSA Code': '23340',
    'MSA Name': 'FREMONT, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUNDY COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 171000,
    'Median Price Det Limit': '171000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FILLMORE COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '267000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRONTIER COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FURNAS COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GAGE COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '13100',
    'MSA Name': 'BEATRICE, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARDEN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 62000,
    'Median Price Det Limit': '69000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARFIELD COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 603750,
    '2 Unit': 772900,
    '3 Unit': 934250,
    '4 Unit': 1161050,
    'County Name': 'GOSPER COUNTY',
    FIPS: '073',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 307000,
    'Median Price Det Limit': '525000',
    'Metro Div Code': '0',
    'MSA Code': '30420',
    'MSA Name': 'LEXINGTON, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREELEY COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALL COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '24260',
    'MSA Name': 'GRAND ISLAND, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARLAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '162000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAYES COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 68000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HITCHCOCK COUNT',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 63000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOLT COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 202000,
    'Median Price Det Limit': '202000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOOKER COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWARD COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '24260',
    'MSA Name': 'GRAND ISLAND, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEARNEY COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '28260',
    'MSA Name': 'KEARNEY, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEITH COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEYA PAHA COUNT',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIMBALL COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 124000,
    'Median Price Det Limit': '269000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANCASTER COUNT',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 283000,
    'Median Price Det Limit': '283000',
    'Metro Div Code': '0',
    'MSA Code': '30700',
    'MSA Name': 'LINCOLN, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 213000,
    'Median Price Det Limit': '213000',
    'Metro Div Code': '0',
    'MSA Code': '35820',
    'MSA Name': 'NORTH PLATTE, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 213000,
    'Median Price Det Limit': '213000',
    'Metro Div Code': '0',
    'MSA Code': '35820',
    'MSA Name': 'NORTH PLATTE, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOUP COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 91000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCPHERSON COUNT',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '377000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '35740',
    'MSA Name': 'NORFOLK, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERRICK COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '24260',
    'MSA Name': 'GRAND ISLAND, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORRILL COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NANCE COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEMAHA COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NUCKOLLS COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTOE COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAWNEE COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '65000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERKINS COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PHELPS COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 167000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIERCE COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '35740',
    'MSA Name': 'NORFOLK, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLATTE COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '18100',
    'MSA Name': 'COLUMBUS, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RED WILLOW COUN',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHARDSON COUN',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 62000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCK COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALINE COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SARPY COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAUNDERS COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTTS BLUFF CO',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 221000,
    'Median Price Det Limit': '244000',
    'Metro Div Code': '0',
    'MSA Code': '42420',
    'MSA Name': 'SCOTTSBLUFF, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEWARD COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 283000,
    'Median Price Det Limit': '283000',
    'Metro Div Code': '0',
    'MSA Code': '30700',
    'MSA Name': 'LINCOLN, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERIDAN COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERMAN COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 69000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIOUX COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STANTON COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '35740',
    'MSA Name': 'NORFOLK, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'THAYER COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'THOMAS COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '177000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'THURSTON COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '171000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VALLEY COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '36540',
    'MSA Name': 'OMAHA, NE-IA',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '25580',
    'MSA Name': 'HASTINGS, NE',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHEELER COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YORK COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NE',
    'State Name': 'NEBRASKA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BELKNAP COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 413000,
    'Median Price Det Limit': '413000',
    'Metro Div Code': '0',
    'MSA Code': '29060',
    'MSA Name': 'LACONIA, NH',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 546250,
    '2 Unit': 699300,
    '3 Unit': 845300,
    '4 Unit': 1050500,
    'County Name': 'CARROLL COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 475000,
    'Median Price Det Limit': '475000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHESHIRE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 331000,
    'Median Price Det Limit': '331000',
    'Metro Div Code': '0',
    'MSA Code': '28300',
    'MSA Name': 'KEENE, NH',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOS COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAFTON COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 379000,
    'Median Price Det Limit': '379000',
    'Metro Div Code': '0',
    'MSA Code': '30150',
    'MSA Name': 'LEBANON-CLAREMONT, NH-VT',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 589950,
    '2 Unit': 755250,
    '3 Unit': 912900,
    '4 Unit': 1134550,
    'County Name': 'HILLSBOROUGH CO',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 513000,
    'Median Price Det Limit': '513000',
    'Metro Div Code': '0',
    'MSA Code': '31700',
    'MSA Name': 'MANCHESTER-NASHUA, NH',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERRIMACK COUNT',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 445000,
    'Median Price Det Limit': '445000',
    'Metro Div Code': '0',
    'MSA Code': '18180',
    'MSA Name': 'CONCORD, NH',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'ROCKINGHAM COUN',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '40484',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 962550,
    '2 Unit': 1232250,
    '3 Unit': 1489500,
    '4 Unit': 1851100,
    'County Name': 'STRAFFORD COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 837000,
    'Median Price Det Limit': '837000',
    'Metro Div Code': '40484',
    'MSA Code': '14460',
    'MSA Name': 'BOSTON-CAMBRIDGE-NEWTON, MA-NH',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLIVAN COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 379000,
    'Median Price Det Limit': '379000',
    'Metro Div Code': '0',
    'MSA Code': '30150',
    'MSA Name': 'LEBANON-CLAREMONT, NH-VT',
    'SOA Code': '203B',
    ST: 'NH',
    'State Name': 'NEW HAMPSHIRE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 730250,
    '2 Unit': 934850,
    '3 Unit': 1130000,
    '4 Unit': 1404350,
    'County Name': 'ATLANTIC COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 635000,
    'Median Price Det Limit': '635000',
    'Metro Div Code': '0',
    'MSA Code': '12100',
    'MSA Name': 'ATLANTIC CITY-HAMMONTON, NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'BERGEN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'BURLINGTON COUN',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '15804',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'CAMDEN COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '15804',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 730250,
    '2 Unit': 934850,
    '3 Unit': 1130000,
    '4 Unit': 1404350,
    'County Name': 'CAPE MAY COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 635000,
    'Median Price Det Limit': '635000',
    'Metro Div Code': '0',
    'MSA Code': '12100',
    'MSA Name': 'ATLANTIC CITY-HAMMONTON, NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '47220',
    'MSA Name': 'VINELAND, NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'ESSEX COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35084',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'GLOUCESTER COUN',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '15804',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'HUDSON COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'HUNTERDON COUNT',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35084',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 391000,
    'Median Price Det Limit': '391000',
    'Metro Div Code': '0',
    'MSA Code': '45940',
    'MSA Name': 'TRENTON-PRINCETON, NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MIDDLESEX COUNT',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '29484',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MONMOUTH COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '29484',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MORRIS COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35084',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'OCEAN COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '29484',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'PASSAIC COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'SALEM COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '48864',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SOMERSET COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '29484',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SUSSEX COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35084',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'UNION COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35084',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '10900',
    'MSA Name': 'ALLENTOWN-BETHLEHEM-EASTON, PA-NJ',
    'SOA Code': '203B',
    ST: 'NJ',
    'State Name': 'NEW JERSEY',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERNALILLO COUN',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 366000,
    'Median Price Det Limit': '366000',
    'Metro Div Code': '0',
    'MSA Code': '10740',
    'MSA Name': 'ALBUQUERQUE, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CATRON COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '349000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAVES COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 211000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '40740',
    'MSA Name': 'ROSWELL, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CIBOLA COUNTY',
    FIPS: '006',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '183000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLFAX COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '375000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CURRY COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '17580',
    'MSA Name': 'CLOVIS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DE BACA COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DONA ANA COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 305000,
    'Median Price Det Limit': '305000',
    'Metro Div Code': '0',
    'MSA Code': '29740',
    'MSA Name': 'LAS CRUCES, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDDY COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '16100',
    'MSA Name': 'CARLSBAD-ARTESIA, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 199000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '43500',
    'MSA Name': 'SILVER CITY, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUADALUPE COUNT',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDING COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '375000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HIDALGO COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEA COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '26020',
    'MSA Name': 'HOBBS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 343000,
    'Median Price Det Limit': '343000',
    'Metro Div Code': '0',
    'MSA Code': '40760',
    'MSA Name': 'RUIDOSO, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 692300,
    '2 Unit': 886250,
    '3 Unit': 1071300,
    '4 Unit': 1331350,
    'County Name': 'LOS ALAMOS COUN',
    FIPS: '028',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 600000,
    'Median Price Det Limit': '602000',
    'Metro Div Code': '0',
    'MSA Code': '31060',
    'MSA Name': 'LOS ALAMOS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUNA COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '19700',
    'MSA Name': 'DEMING, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCKINLEY COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '23700',
    'MSA Name': 'GALLUP, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORA COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 267000,
    'Median Price Det Limit': '267000',
    'Metro Div Code': '0',
    'MSA Code': '29780',
    'MSA Name': 'LAS VEGAS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTERO COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '10460',
    'MSA Name': 'ALAMOGORDO, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'QUAY COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RIO ARRIBA COUN',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '21580',
    'MSA Name': 'ESPANOLA, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROOSEVELT COUNT',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '17580',
    'MSA Name': 'CLOVIS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANDOVAL COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 366000,
    'Median Price Det Limit': '366000',
    'Metro Div Code': '0',
    'MSA Code': '10740',
    'MSA Name': 'ALBUQUERQUE, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN JUAN COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 294000,
    'Median Price Det Limit': '294000',
    'Metro Div Code': '0',
    'MSA Code': '22140',
    'MSA Name': 'FARMINGTON, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN MIGUEL COUN',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 267000,
    'Median Price Det Limit': '267000',
    'Metro Div Code': '0',
    'MSA Code': '29780',
    'MSA Name': 'LAS VEGAS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 569250,
    '2 Unit': 728750,
    '3 Unit': 880900,
    '4 Unit': 1094700,
    'County Name': 'SANTA FE COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 495000,
    'Median Price Det Limit': '495000',
    'Metro Div Code': '0',
    'MSA Code': '42140',
    'MSA Name': 'SANTA FE, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SIERRA COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOCORRO COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAOS COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 419000,
    'Median Price Det Limit': '419000',
    'Metro Div Code': '0',
    'MSA Code': '45340',
    'MSA Name': 'TAOS, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TORRANCE COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 366000,
    'Median Price Det Limit': '366000',
    'Metro Div Code': '0',
    'MSA Code': '10740',
    'MSA Name': 'ALBUQUERQUE, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VALENCIA COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 366000,
    'Median Price Det Limit': '366000',
    'Metro Div Code': '0',
    'MSA Code': '10740',
    'MSA Name': 'ALBUQUERQUE, NM',
    'SOA Code': '203B',
    ST: 'NM',
    'State Name': 'NEW MEXICO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHURCHILL COUNT',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '365000',
    'Metro Div Code': '0',
    'MSA Code': '21980',
    'MSA Name': 'FALLON, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 462000,
    'Median Price Det Limit': '462000',
    'Metro Div Code': '0',
    'MSA Code': '29820',
    'MSA Name': 'LAS VEGAS-HENDERSON-NORTH LAS VEGAS, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 736000,
    '2 Unit': 942200,
    '3 Unit': 1138900,
    '4 Unit': 1415400,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 640000,
    'Median Price Det Limit': '640000',
    'Metro Div Code': '0',
    'MSA Code': '23820',
    'MSA Name': 'GARDNERVILLE RANCHOS, NV-CA',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELKO COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '21220',
    'MSA Name': 'ELKO, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESMERALDA COUNT',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EUREKA COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '21220',
    'MSA Name': 'ELKO, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUMBOLDT COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '49080',
    'MSA Name': 'WINNEMUCCA, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANDER COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 638250,
    '2 Unit': 817050,
    '3 Unit': 987650,
    '4 Unit': 1227400,
    'County Name': 'LYON COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 555000,
    'Median Price Det Limit': '555000',
    'Metro Div Code': '0',
    'MSA Code': '39900',
    'MSA Name': 'RENO, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINERAL COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NYE COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '37220',
    'MSA Name': 'PAHRUMP, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERSHING COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 638250,
    '2 Unit': 817050,
    '3 Unit': 987650,
    '4 Unit': 1227400,
    'County Name': 'STOREY COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 555000,
    'Median Price Det Limit': '555000',
    'Metro Div Code': '0',
    'MSA Code': '39900',
    'MSA Name': 'RENO, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 638250,
    '2 Unit': 817050,
    '3 Unit': 987650,
    '4 Unit': 1227400,
    'County Name': 'WASHOE COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 555000,
    'Median Price Det Limit': '555000',
    'Metro Div Code': '0',
    'MSA Code': '39900',
    'MSA Name': 'RENO, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITE PINE COUN',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 575000,
    '2 Unit': 736100,
    '3 Unit': 889800,
    '4 Unit': 1105800,
    'County Name': 'CARSON CITY',
    FIPS: '510',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 499000,
    'Median Price Det Limit': '500000',
    'Metro Div Code': '0',
    'MSA Code': '16180',
    'MSA Name': 'CARSON CITY, NV',
    'SOA Code': '203B',
    ST: 'NV',
    'State Name': 'NEVADA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALBANY COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 421000,
    'Median Price Det Limit': '421000',
    'Metro Div Code': '0',
    'MSA Code': '10580',
    'MSA Name': 'ALBANY-SCHENECTADY-TROY, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEGANY COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'BRONX COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROOME COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '13780',
    'MSA Name': 'BINGHAMTON, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CATTARAUGUS COU',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '36460',
    'MSA Name': 'OLEAN, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAYUGA COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '12180',
    'MSA Name': 'AUBURN, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAUTAUQUA COUN',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '27460',
    'MSA Name': 'JAMESTOWN-DUNKIRK, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEMUNG COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '21300',
    'MSA Name': 'ELMIRA, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHENANGO COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '38460',
    'MSA Name': 'PLATTSBURGH, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 352000,
    'Median Price Det Limit': '356000',
    'Metro Div Code': '0',
    'MSA Code': '26460',
    'MSA Name': 'HUDSON, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CORTLAND COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '18660',
    'MSA Name': 'CORTLAND, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELAWARE COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUTCHESS COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '28880',
    'MSA Name': 'KIRYAS JOEL-POUGHKEEPSIE-NEWBURGH, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ERIE COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '15380',
    'MSA Name': 'BUFFALO-CHEEKTOWAGA, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESSEX COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '24100',
    'MSA Name': 'GLOVERSVILLE, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GENESEE COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '12860',
    'MSA Name': 'BATAVIA, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 211000,
    'Median Price Det Limit': '219000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HERKIMER COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '187000',
    'Metro Div Code': '0',
    'MSA Code': '46540',
    'MSA Name': 'UTICA-ROME, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '48060',
    'MSA Name': 'WATERTOWN-FORT DRUM, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'KINGS COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVINGSTON COUN',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '40380',
    'MSA Name': 'ROCHESTER, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '45060',
    'MSA Name': 'SYRACUSE, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '40380',
    'MSA Name': 'ROCHESTER, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '11220',
    'MSA Name': 'AMSTERDAM, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'NASSAU COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35004',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'NEW YORK COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NIAGARA COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '15380',
    'MSA Name': 'BUFFALO-CHEEKTOWAGA, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONEIDA COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '187000',
    'Metro Div Code': '0',
    'MSA Code': '46540',
    'MSA Name': 'UTICA-ROME, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONONDAGA COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '45060',
    'MSA Name': 'SYRACUSE, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONTARIO COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '40380',
    'MSA Name': 'ROCHESTER, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGE COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '28880',
    'MSA Name': 'KIRYAS JOEL-POUGHKEEPSIE-NEWBURGH, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORLEANS COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '40380',
    'MSA Name': 'ROCHESTER, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSWEGO COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '45060',
    'MSA Name': 'SYRACUSE, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTSEGO COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '36580',
    'MSA Name': 'ONEONTA, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'QUEENS COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RENSSELAER COUN',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 421000,
    'Median Price Det Limit': '421000',
    'Metro Div Code': '0',
    'MSA Code': '10580',
    'MSA Name': 'ALBANY-SCHENECTADY-TROY, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'RICHMOND COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'ROCKLAND COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. LAWRENCE CO',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '32390',
    'MSA Name': 'MASSENA-OGDENSBURG, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SARATOGA COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 421000,
    'Median Price Det Limit': '421000',
    'Metro Div Code': '0',
    'MSA Code': '10580',
    'MSA Name': 'ALBANY-SCHENECTADY-TROY, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHENECTADY COU',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 421000,
    'Median Price Det Limit': '421000',
    'Metro Div Code': '0',
    'MSA Code': '10580',
    'MSA Name': 'ALBANY-SCHENECTADY-TROY, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHOHARIE COUNT',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 421000,
    'Median Price Det Limit': '421000',
    'Metro Div Code': '0',
    'MSA Code': '10580',
    'MSA Name': 'ALBANY-SCHENECTADY-TROY, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHUYLER COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SENECA COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '42900',
    'MSA Name': 'SENECA FALLS, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEUBEN COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '18500',
    'MSA Name': 'CORNING, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SUFFOLK COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35004',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLIVAN COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '33910',
    'MSA Name': 'MONTICELLO, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIOGA COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '13780',
    'MSA Name': 'BINGHAMTON, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TOMPKINS COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '27060',
    'MSA Name': 'ITHACA, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ULSTER COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 393000,
    'Median Price Det Limit': '393000',
    'Metro Div Code': '0',
    'MSA Code': '28740',
    'MSA Name': 'KINGSTON, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '24020',
    'MSA Name': 'GLENS FALLS, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '24020',
    'MSA Name': 'GLENS FALLS, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '40380',
    'MSA Name': 'ROCHESTER, NY',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'WESTCHESTER COU',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 996000,
    'Median Price Det Limit': '5315000',
    'Metro Div Code': '35614',
    'MSA Code': '35620',
    'MSA Name': 'NEW YORK-NEWARK-JERSEY CITY, NY-NJ',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WYOMING COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YATES COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'NY',
    'State Name': 'NEW YORK',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 99000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '30620',
    'MSA Name': 'LIMA, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASHLAND COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '11740',
    'MSA Name': 'ASHLAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASHTABULA COUNT',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '17410',
    'MSA Name': 'CLEVELAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ATHENS COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '11900',
    'MSA Name': 'ATHENS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AUGLAIZE COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 183000,
    'Median Price Det Limit': '183000',
    'Metro Div Code': '0',
    'MSA Code': '47540',
    'MSA Name': 'WAPAKONETA, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BELMONT COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48540',
    'MSA Name': 'WHEELING, WV-OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '15940',
    'MSA Name': 'CANTON-MASSILLON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAMPAIGN COUNT',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '46500',
    'MSA Name': 'URBANA, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '44220',
    'MSA Name': 'SPRINGFIELD, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLERMONT COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '48940',
    'MSA Name': 'WILMINGTON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIANA COUN',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '41400',
    'MSA Name': 'SALEM, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COSHOCTON COUNT',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '18740',
    'MSA Name': 'COSHOCTON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '15340',
    'MSA Name': 'BUCYRUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUYAHOGA COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '17410',
    'MSA Name': 'CLEVELAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DARKE COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '24820',
    'MSA Name': 'GREENVILLE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEFIANCE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '19580',
    'MSA Name': 'DEFIANCE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'DELAWARE COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ERIE COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '41780',
    'MSA Name': 'SANDUSKY, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'FAIRFIELD COUNT',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '47920',
    'MSA Name': 'WASHINGTON COURT HOUSE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '45780',
    'MSA Name': 'TOLEDO, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GALLIA COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '23680',
    'MSA Name': 'GALLIPOLIS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GEAUGA COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '17410',
    'MSA Name': 'CLEVELAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 269000,
    'Median Price Det Limit': '269000',
    'Metro Div Code': '0',
    'MSA Code': '19430',
    'MSA Name': 'DAYTON-KETTERING-BEAVERCREEK, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUERNSEY COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '15740',
    'MSA Name': 'CAMBRIDGE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '22300',
    'MSA Name': 'FINDLAY, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDIN COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HIGHLAND COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'HOCKING COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOLMES COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HURON COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '35940',
    'MSA Name': 'NORWALK, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '48260',
    'MSA Name': 'WEIRTON-STEUBENVILLE, WV-OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '248000',
    'Metro Div Code': '0',
    'MSA Code': '34540',
    'MSA Name': 'MOUNT VERNON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '17410',
    'MSA Name': 'CLEVELAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'LICKING COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '13340',
    'MSA Name': 'BELLEFONTAINE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LORAIN COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '17410',
    'MSA Name': 'CLEVELAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUCAS COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '45780',
    'MSA Name': 'TOLEDO, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'MADISON COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAHONING COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '49660',
    'MSA Name': 'YOUNGSTOWN-WARREN, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '32020',
    'MSA Name': 'MARION, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEDINA COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '17410',
    'MSA Name': 'CLEVELAND, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEIGS COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '16380',
    'MSA Name': 'CELINA, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIAMI COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 269000,
    'Median Price Det Limit': '269000',
    'Metro Div Code': '0',
    'MSA Code': '19430',
    'MSA Name': 'DAYTON-KETTERING-BEAVERCREEK, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 103000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 269000,
    'Median Price Det Limit': '269000',
    'Metro Div Code': '0',
    'MSA Code': '19430',
    'MSA Name': 'DAYTON-KETTERING-BEAVERCREEK, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'MORROW COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUSKINGUM COUNT',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '49780',
    'MSA Name': 'ZANESVILLE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOBLE COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTTAWA COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '41780',
    'MSA Name': 'SANDUSKY, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAULDING COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'PERRY COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'PICKAWAY COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '126000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PORTAGE COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '10420',
    'MSA Name': 'AKRON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PREBLE COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '31900',
    'MSA Name': 'MANSFIELD, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROSS COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '17060',
    'MSA Name': 'CHILLICOTHE, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANDUSKY COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '23380',
    'MSA Name': 'FREMONT, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCIOTO COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '39020',
    'MSA Name': 'PORTSMOUTH, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SENECA COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '45660',
    'MSA Name': 'TIFFIN, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '43380',
    'MSA Name': 'SIDNEY, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STARK COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '15940',
    'MSA Name': 'CANTON-MASSILLON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMMIT COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 235000,
    'Median Price Det Limit': '235000',
    'Metro Div Code': '0',
    'MSA Code': '10420',
    'MSA Name': 'AKRON, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRUMBULL COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '49660',
    'MSA Name': 'YOUNGSTOWN-WARREN, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TUSCARAWAS COUN',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '35420',
    'MSA Name': 'NEW PHILADELPHIA-DOVER, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 591100,
    '2 Unit': 756700,
    '3 Unit': 914700,
    '4 Unit': 1136750,
    'County Name': 'UNION COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 514000,
    'Median Price Det Limit': '514000',
    'Metro Div Code': '0',
    'MSA Code': '18140',
    'MSA Name': 'COLUMBUS, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAN WERT COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '46780',
    'MSA Name': 'VAN WERT, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VINTON COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 52000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '17140',
    'MSA Name': 'CINCINNATI, OH-KY-IN',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '31930',
    'MSA Name': 'MARIETTA, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '49300',
    'MSA Name': 'WOOSTER, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILLIAMS COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOOD COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '45780',
    'MSA Name': 'TOLEDO, OH',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WYANDOT COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OH',
    'State Name': 'OHIO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAIR COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '69000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALFALFA COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '72000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ATOKA COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '93000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAVER COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BECKHAM COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '21120',
    'MSA Name': 'ELK CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLAINE COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '93000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRYAN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '20460',
    'MSA Name': 'DURANT, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CADDO COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 81000,
    'Median Price Det Limit': '101000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CANADIAN COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARTER COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '11620',
    'MSA Name': 'ARDMORE, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '45140',
    'MSA Name': 'TAHLEQUAH, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHOCTAW COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 67000,
    'Median Price Det Limit': '76000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CIMARRON COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 30000,
    'Median Price Det Limit': '78000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEVELAND COUNT',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COAL COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 50000,
    'Median Price Det Limit': '63000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COMANCHE COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '30020',
    'MSA Name': 'LAWTON, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COTTON COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '30020',
    'MSA Name': 'LAWTON, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAIG COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CREEK COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUSTER COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '48220',
    'MSA Name': 'WEATHERFORD, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELAWARE COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEWEY COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 56000,
    'Median Price Det Limit': '91000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELLIS COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '83000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARFIELD COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '21420',
    'MSA Name': 'ENID, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARVIN COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRADY COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '69000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREER COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '78000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARMON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 34000,
    'Median Price Det Limit': '60000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARPER COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 48000,
    'Median Price Det Limit': '79000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HASKELL COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 88000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUGHES COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 57000,
    'Median Price Det Limit': '73000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '11060',
    'MSA Name': 'ALTUS, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 64000,
    'Median Price Det Limit': '64000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSTON COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 72000,
    'Median Price Det Limit': '75000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KAY COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '38620',
    'MSA Name': 'PONCA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KINGFISHER COUN',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIOWA COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 74000,
    'Median Price Det Limit': '78000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LATIMER COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '77000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LE FLORE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 99000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOVE COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 94000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCLAIN COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCURTAIN COUNT',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCINTOSH COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 84000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAJOR COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAYES COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MURRAY COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MUSKOGEE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '139000',
    'Metro Div Code': '0',
    'MSA Code': '34780',
    'MSA Name': 'MUSKOGEE, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOBLE COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOWATA COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OKFUSKEE COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OKLAHOMA COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '36420',
    'MSA Name': 'OKLAHOMA CITY, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OKMULGEE COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OSAGE COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OTTAWA COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '33060',
    'MSA Name': 'MIAMI, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAWNEE COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAYNE COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '44660',
    'MSA Name': 'STILLWATER, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PITTSBURG COUNT',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '32540',
    'MSA Name': 'MCALESTER, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PONTOTOC COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '10220',
    'MSA Name': 'ADA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POTTAWATOMIE CO',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '43060',
    'MSA Name': 'SHAWNEE, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUSHMATAHA COUN',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '76000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROGER MILLS COU',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROGERS COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEMINOLE COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 92000,
    'Median Price Det Limit': '92000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEQUOYAH COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '22900',
    'MSA Name': 'FORT SMITH, AR-OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEPHENS COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 97000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '20340',
    'MSA Name': 'DUNCAN, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TEXAS COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '25100',
    'MSA Name': 'GUYMON, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TILLMAN COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 32000,
    'Median Price Det Limit': '73000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TULSA COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAGONER COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '46140',
    'MSA Name': 'TULSA, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '12780',
    'MSA Name': 'BARTLESVILLE, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHITA COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '48220',
    'MSA Name': 'WEATHERFORD, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODS COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOODWARD COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '49260',
    'MSA Name': 'WOODWARD, OK',
    'SOA Code': '203B',
    ST: 'OK',
    'State Name': 'OKLAHOMA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAKER COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '266000',
    'Metro Div Code': '0',
    'MSA Code': '12520',
    'MSA Name': 'BAKER CITY, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 615250,
    '2 Unit': 787650,
    '3 Unit': 952050,
    '4 Unit': 1183200,
    'County Name': 'BENTON COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 535000,
    'Median Price Det Limit': '535000',
    'Metro Div Code': '0',
    'MSA Code': '18700',
    'MSA Name': 'CORVALLIS, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'CLACKAMAS COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'CLATSOP COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 490000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '0',
    'MSA Code': '11820',
    'MSA Name': 'ASTORIA, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOS COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 320000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '18300',
    'MSA Name': 'COOS BAY-NORTH BEND, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'CROOK COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '0',
    'MSA Code': '13460',
    'MSA Name': 'BEND, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CURRY COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 415000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '0',
    'MSA Code': '15060',
    'MSA Name': 'BROOKINGS, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'DESCHUTES COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '0',
    'MSA Code': '13460',
    'MSA Name': 'BEND, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 310000,
    'Median Price Det Limit': '310000',
    'Metro Div Code': '0',
    'MSA Code': '40700',
    'MSA Name': 'ROSEBURG, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILLIAM COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '212000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARNEY COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 762450,
    '2 Unit': 976100,
    '3 Unit': 1179850,
    '4 Unit': 1466250,
    'County Name': 'HOOD RIVER COUN',
    FIPS: '027',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 650000,
    'Median Price Det Limit': '663000',
    'Metro Div Code': '0',
    'MSA Code': '26220',
    'MSA Name': 'HOOD RIVER, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 415000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '0',
    'MSA Code': '32780',
    'MSA Name': 'MEDFORD, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 718750,
    '2 Unit': 920150,
    '3 Unit': 1112250,
    '4 Unit': 1382250,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 625000,
    'Median Price Det Limit': '625000',
    'Metro Div Code': '0',
    'MSA Code': '13460',
    'MSA Name': 'BEND, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOSEPHINE COUNT',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '375000',
    'Metro Div Code': '0',
    'MSA Code': '24420',
    'MSA Name': 'GRANTS PASS, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KLAMATH COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '28900',
    'MSA Name': 'KLAMATH FALLS, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '21660',
    'MSA Name': 'EUGENE-SPRINGFIELD, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 411000,
    'Median Price Det Limit': '411000',
    'Metro Div Code': '0',
    'MSA Code': '35440',
    'MSA Name': 'NEWPORT, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINN COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 388000,
    'Median Price Det Limit': '388000',
    'Metro Div Code': '0',
    'MSA Code': '10540',
    'MSA Name': 'ALBANY, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MALHEUR COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '36620',
    'MSA Name': 'ONTARIO, OR-ID',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '41420',
    'MSA Name': 'SALEM, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORROW COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 294000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '25840',
    'MSA Name': 'HERMISTON-PENDLETON, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'MULTNOMAH COUNT',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 450000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '41420',
    'MSA Name': 'SALEM, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERMAN COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 183000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TILLAMOOK COUNT',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 415000,
    'Median Price Det Limit': '415000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UMATILLA COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 294000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '25840',
    'MSA Name': 'HERMISTON-PENDLETON, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '29260',
    'MSA Name': 'LA GRANDE, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALLOWA COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 341000,
    'Median Price Det Limit': '341000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASCO COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 348000,
    'Median Price Det Limit': '348000',
    'Metro Div Code': '0',
    'MSA Code': '45520',
    'MSA Name': 'THE DALLES, OR',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'WASHINGTON COUN',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHEELER COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'YAMHILL COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'OR',
    'State Name': 'OREGON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 293000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '23900',
    'MSA Name': 'GETTYSBURG, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEGHENY COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARMSTRONG COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAVER COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEDFORD COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERKS COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '39740',
    'MSA Name': 'READING, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLAIR COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '11020',
    'MSA Name': 'ALTOONA, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRADFORD COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '42380',
    'MSA Name': 'SAYRE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'BUCKS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '33874',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTLER COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMBRIA COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '101000',
    'Metro Div Code': '0',
    'MSA Code': '27780',
    'MSA Name': 'JOHNSTOWN, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMERON COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 57000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARBON COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '10900',
    'MSA Name': 'ALLENTOWN-BETHLEHEM-EASTON, PA-NJ',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CENTRE COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 343000,
    'Median Price Det Limit': '343000',
    'Metro Div Code': '0',
    'MSA Code': '44300',
    'MSA Name': 'STATE COLLEGE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'CHESTER COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '33874',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARION COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLEARFIELD COUN',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '20180',
    'MSA Name': 'DUBOIS, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLINTON COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '30820',
    'MSA Name': 'LOCK HAVEN, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 183000,
    'Median Price Det Limit': '183000',
    'Metro Div Code': '0',
    'MSA Code': '14100',
    'MSA Name': 'BLOOMSBURG-BERWICK, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '32740',
    'MSA Name': 'MEADVILLE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 323000,
    'Median Price Det Limit': '323000',
    'Metro Div Code': '0',
    'MSA Code': '25420',
    'MSA Name': 'HARRISBURG-CARLISLE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAUPHIN COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 323000,
    'Median Price Det Limit': '323000',
    'Metro Div Code': '0',
    'MSA Code': '25420',
    'MSA Name': 'HARRISBURG-CARLISLE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'DELAWARE COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '37964',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ELK COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '41260',
    'MSA Name': 'ST. MARYS, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ERIE COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '21500',
    'MSA Name': 'ERIE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FOREST COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 89000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '16540',
    'MSA Name': 'CHAMBERSBURG, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FULTON COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUNTINGDON COUN',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '26500',
    'MSA Name': 'HUNTINGDON, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'INDIANA COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '26860',
    'MSA Name': 'INDIANA, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '93000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2013',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JUNIATA COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LACKAWANNA COUN',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 304000,
    'Median Price Det Limit': '304000',
    'Metro Div Code': '0',
    'MSA Code': '42540',
    'MSA Name': 'SCRANTON--WILKES-BARRE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANCASTER COUNT',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '29540',
    'MSA Name': 'LANCASTER, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEBANON COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 256000,
    'Median Price Det Limit': '256000',
    'Metro Div Code': '0',
    'MSA Code': '30140',
    'MSA Name': 'LEBANON, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEHIGH COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '10900',
    'MSA Name': 'ALLENTOWN-BETHLEHEM-EASTON, PA-NJ',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUZERNE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 304000,
    'Median Price Det Limit': '304000',
    'Metro Div Code': '0',
    'MSA Code': '42540',
    'MSA Name': 'SCRANTON--WILKES-BARRE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYCOMING COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '48700',
    'MSA Name': 'WILLIAMSPORT, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCKEAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '14620',
    'MSA Name': 'BRADFORD, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '25850',
    'MSA Name': 'HERMITAGE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIFFLIN COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '30380',
    'MSA Name': 'LEWISTOWN, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 295000,
    'Median Price Det Limit': '295000',
    'Metro Div Code': '0',
    'MSA Code': '20700',
    'MSA Name': 'EAST STROUDSBURG, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '33874',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTOUR COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '44980',
    'MSA Name': 'SUNBURY, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHAMPTON COU',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 395000,
    'Median Price Det Limit': '395000',
    'Metro Div Code': '0',
    'MSA Code': '10900',
    'MSA Name': 'ALLENTOWN-BETHLEHEM-EASTON, PA-NJ',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHUMBERLAND',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '44980',
    'MSA Name': 'SUNBURY, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 323000,
    'Median Price Det Limit': '323000',
    'Metro Div Code': '0',
    'MSA Code': '25420',
    'MSA Name': 'HARRISBURG-CARLISLE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 630200,
    '2 Unit': 806750,
    '3 Unit': 975200,
    '4 Unit': 1211950,
    'County Name': 'PHILADELPHIA CO',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 548000,
    'Median Price Det Limit': '548000',
    'Metro Div Code': '37964',
    'MSA Code': '37980',
    'MSA Name': 'PHILADELPHIA-CAMDEN-WILMINGTON, PA-NJ-DE-MD',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIKE COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 284000,
    'Median Price Det Limit': '284000',
    'Metro Div Code': '0',
    'MSA Code': '25770',
    'MSA Name': 'HEMLOCK FARMS, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POTTER COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHUYLKILL COUN',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '39060',
    'MSA Name': 'POTTSVILLE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SNYDER COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 202000,
    'Median Price Det Limit': '202000',
    'Metro Div Code': '0',
    'MSA Code': '42780',
    'MSA Name': 'SELINSGROVE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOMERSET COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '43740',
    'MSA Name': 'SOMERSET, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLIVAN COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUSQUEHANNA COU',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIOGA COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '149000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '30260',
    'MSA Name': 'LEWISBURG, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VENANGO COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '36340',
    'MSA Name': 'OIL CITY, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '47620',
    'MSA Name': 'WARREN, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WESTMORELAND CO',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 332000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '38300',
    'MSA Name': 'PITTSBURGH, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WYOMING COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 304000,
    'Median Price Det Limit': '304000',
    'Metro Div Code': '0',
    'MSA Code': '42540',
    'MSA Name': 'SCRANTON--WILKES-BARRE, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YORK COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 279000,
    'Median Price Det Limit': '279000',
    'Metro Div Code': '0',
    'MSA Code': '49620',
    'MSA Name': 'YORK-HANOVER, PA',
    'SOA Code': '203B',
    ST: 'PA',
    'State Name': 'PENNSYLVANIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADJUNTAS MUNICI',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AGUADA MUNICIPI',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AGUADILLA MUNIC',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'AGUAS BUENAS MU',
    FIPS: '007',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'AIBONITO MUNICI',
    FIPS: '009',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANASCO MUNICIPI',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARECIBO MUNICIP',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '11640',
    'MSA Name': 'ARECIBO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARROYO MUNICIPI',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '25020',
    'MSA Name': 'GUAYAMA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'BARCELONETA MUN',
    FIPS: '017',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'BARRANQUITAS MU',
    FIPS: '019',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'BAYAMON MUNICIP',
    FIPS: '021',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CABO ROJO MUNIC',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '32420',
    'MSA Name': 'MAYAGUEZ, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CAGUAS MUNICIPI',
    FIPS: '025',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMUY MUNICIPIO',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '11640',
    'MSA Name': 'ARECIBO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CANOVANAS MUNIC',
    FIPS: '029',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CAROLINA MUNICI',
    FIPS: '031',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CATANO MUNICIPI',
    FIPS: '033',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CAYEY MUNICIPIO',
    FIPS: '035',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CEIBA MUNICIPIO',
    FIPS: '037',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CIALES MUNICIPI',
    FIPS: '039',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CIDRA MUNICIPIO',
    FIPS: '041',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COAMO MUNICIPIO',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '17620',
    'MSA Name': 'COAMO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'COMERIO MUNICIP',
    FIPS: '045',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'COROZAL MUNICIP',
    FIPS: '047',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CULEBRA MUNICIP',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '463000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'DORADO MUNICIPI',
    FIPS: '051',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'FAJARDO MUNICIP',
    FIPS: '053',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'FLORIDA MUNICIP',
    FIPS: '054',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUANICA MUNICIP',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUAYAMA MUNICIP',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '25020',
    'MSA Name': 'GUAYAMA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GUAYANILLA MUNI',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '38660',
    'MSA Name': 'PONCE, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'GUAYNABO MUNICI',
    FIPS: '061',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'GURABO MUNICIPI',
    FIPS: '063',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HATILLO MUNICIP',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '11640',
    'MSA Name': 'ARECIBO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HORMIGUEROS MUN',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '32420',
    'MSA Name': 'MAYAGUEZ, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'HUMACAO MUNICIP',
    FIPS: '069',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ISABELA MUNICIP',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JAYUYA MUNICIPI',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JUANA DIAZ MUNI',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '38660',
    'MSA Name': 'PONCE, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'JUNCOS MUNICIPI',
    FIPS: '077',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAJAS MUNICIPIO',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '32420',
    'MSA Name': 'MAYAGUEZ, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LARES MUNICIPIO',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '29720',
    'MSA Name': 'LARES, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAS MARIAS MUNI',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'LAS PIEDRAS MUN',
    FIPS: '085',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'LOIZA MUNICIPIO',
    FIPS: '087',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'LUQUILLO MUNICI',
    FIPS: '089',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'MANATI MUNICIPI',
    FIPS: '091',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARICAO MUNICIP',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'MAUNABO MUNICIP',
    FIPS: '095',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAYAGUEZ MUNICI',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '32420',
    'MSA Name': 'MAYAGUEZ, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOCA MUNICIPIO',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'MOROVIS MUNICIP',
    FIPS: '101',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'NAGUABO MUNICIP',
    FIPS: '103',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'NARANJITO MUNIC',
    FIPS: '105',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'OROCOVIS MUNICI',
    FIPS: '107',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PATILLAS MUNICI',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '25020',
    'MSA Name': 'GUAYAMA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENUELAS MUNICI',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '38660',
    'MSA Name': 'PONCE, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PONCE MUNICIPIO',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '38660',
    'MSA Name': 'PONCE, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'QUEBRADILLAS MU',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '11640',
    'MSA Name': 'ARECIBO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RINCON MUNICIPI',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'RIO GRANDE MUNI',
    FIPS: '119',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SABANA GRANDE M',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '32420',
    'MSA Name': 'MAYAGUEZ, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALINAS MUNICIP',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '17640',
    'MSA Name': 'COCO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN GERMAN MUNI',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '32420',
    'MSA Name': 'MAYAGUEZ, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'SAN JUAN MUNICI',
    FIPS: '127',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'SAN LORENZO MUN',
    FIPS: '129',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN SEBASTIAN M',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 208000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '10380',
    'MSA Name': 'AGUADILLA, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANTA ISABEL MU',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '17620',
    'MSA Name': 'COAMO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'TOA ALTA MUNICI',
    FIPS: '135',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'TOA BAJA MUNICI',
    FIPS: '137',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'TRUJILLO ALTO M',
    FIPS: '139',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UTUADO MUNICIPI',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '46580',
    'MSA Name': 'UTUADO, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'VEGA ALTA MUNIC',
    FIPS: '143',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'VEGA BAJA MUNIC',
    FIPS: '145',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VIEQUES MUNICIP',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VILLALBA MUNICI',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '38660',
    'MSA Name': 'PONCE, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'YABUCOA MUNICIP',
    FIPS: '151',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 260000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '41980',
    'MSA Name': 'SAN JUAN-BAYAMON-CAGUAS, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YAUCO MUNICIPIO',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '161000',
    'Metro Div Code': '0',
    'MSA Code': '38660',
    'MSA Name': 'PONCE, PR',
    'SOA Code': '203B',
    ST: 'PR',
    'State Name': 'PUERTO RICO',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 787750,
    '2 Unit': 1008450,
    '3 Unit': 1219000,
    '4 Unit': 1514950,
    'County Name': 'BRISTOL COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 685000,
    'Median Price Det Limit': '685000',
    'Metro Div Code': '0',
    'MSA Code': '39300',
    'MSA Name': 'PROVIDENCE-WARWICK, RI-MA',
    'SOA Code': '203B',
    ST: 'RI',
    'State Name': 'RHODE ISLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 787750,
    '2 Unit': 1008450,
    '3 Unit': 1219000,
    '4 Unit': 1514950,
    'County Name': 'KENT COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 685000,
    'Median Price Det Limit': '685000',
    'Metro Div Code': '0',
    'MSA Code': '39300',
    'MSA Name': 'PROVIDENCE-WARWICK, RI-MA',
    'SOA Code': '203B',
    ST: 'RI',
    'State Name': 'RHODE ISLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 787750,
    '2 Unit': 1008450,
    '3 Unit': 1219000,
    '4 Unit': 1514950,
    'County Name': 'NEWPORT COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 685000,
    'Median Price Det Limit': '685000',
    'Metro Div Code': '0',
    'MSA Code': '39300',
    'MSA Name': 'PROVIDENCE-WARWICK, RI-MA',
    'SOA Code': '203B',
    ST: 'RI',
    'State Name': 'RHODE ISLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 787750,
    '2 Unit': 1008450,
    '3 Unit': 1219000,
    '4 Unit': 1514950,
    'County Name': 'PROVIDENCE COUN',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 685000,
    'Median Price Det Limit': '685000',
    'Metro Div Code': '0',
    'MSA Code': '39300',
    'MSA Name': 'PROVIDENCE-WARWICK, RI-MA',
    'SOA Code': '203B',
    ST: 'RI',
    'State Name': 'RHODE ISLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 787750,
    '2 Unit': 1008450,
    '3 Unit': 1219000,
    '4 Unit': 1514950,
    'County Name': 'WASHINGTON COUN',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 685000,
    'Median Price Det Limit': '685000',
    'Metro Div Code': '0',
    'MSA Code': '39300',
    'MSA Name': 'PROVIDENCE-WARWICK, RI-MA',
    'SOA Code': '203B',
    ST: 'RI',
    'State Name': 'RHODE ISLAND',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ABBEVILLE COUNT',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '24940',
    'MSA Name': 'GREENWOOD, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AIKEN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLENDALE COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 42000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDERSON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '24860',
    'MSA Name': 'GREENVILLE-ANDERSON-GREER, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAMBERG COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 52000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARNWELL COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '99000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 638250,
    '2 Unit': 817050,
    '3 Unit': 987650,
    '4 Unit': 1227400,
    'County Name': 'BEAUFORT COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 555000,
    'Median Price Det Limit': '555000',
    'Metro Div Code': '0',
    'MSA Code': '25940',
    'MSA Name': 'HILTON HEAD ISLAND-BLUFFTON-PORT ROYAL, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'BERKELEY COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 600000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '16700',
    'MSA Name': 'CHARLESTON-NORTH CHARLESTON, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '17900',
    'MSA Name': 'COLUMBIA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'CHARLESTON COUN',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 600000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '16700',
    'MSA Name': 'CHARLESTON-NORTH CHARLESTON, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '23500',
    'MSA Name': 'GAFFNEY, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHESTER COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHESTERFIELD CO',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARENDON COUNT',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLLETON COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DARLINGTON COUN',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '22500',
    'MSA Name': 'FLORENCE, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DILLON COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 52000,
    'Median Price Det Limit': '104000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 690000,
    '2 Unit': 883300,
    '3 Unit': 1067750,
    '4 Unit': 1326950,
    'County Name': 'DORCHESTER COUN',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 600000,
    'Median Price Det Limit': '600000',
    'Metro Div Code': '0',
    'MSA Code': '16700',
    'MSA Name': 'CHARLESTON-NORTH CHARLESTON, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDGEFIELD COUNT',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '12260',
    'MSA Name': 'AUGUSTA-RICHMOND COUNTY, GA-SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAIRFIELD COUNT',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '17900',
    'MSA Name': 'COLUMBIA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLORENCE COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '22500',
    'MSA Name': 'FLORENCE, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GEORGETOWN COUN',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 398000,
    'Median Price Det Limit': '398000',
    'Metro Div Code': '0',
    'MSA Code': '34680',
    'MSA Name': 'MURRELLS INLET, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENVILLE COUN',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '24860',
    'MSA Name': 'GREENVILLE-ANDERSON-GREER, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENWOOD COUNT',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '24940',
    'MSA Name': 'GREENWOOD, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMPTON COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HORRY COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 340000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '34820',
    'MSA Name': 'MYRTLE BEACH-CONWAY-NORTH MYRTLE BEACH, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 638250,
    '2 Unit': 817050,
    '3 Unit': 987650,
    '4 Unit': 1227400,
    'County Name': 'JASPER COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 555000,
    'Median Price Det Limit': '555000',
    'Metro Div Code': '0',
    'MSA Code': '25940',
    'MSA Name': 'HILTON HEAD ISLAND-BLUFFTON-PORT ROYAL, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KERSHAW COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '17900',
    'MSA Name': 'COLUMBIA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANCASTER COUNT',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAURENS COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '24860',
    'MSA Name': 'GREENVILLE-ANDERSON-GREER, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEXINGTON COUNT',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '17900',
    'MSA Name': 'COLUMBIA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCORMICK COUNT',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 121000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARLBORO COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 35000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWBERRY COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '35140',
    'MSA Name': 'NEWBERRY, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OCONEE COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '42860',
    'MSA Name': 'SENECA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGEBURG COUN',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 147000,
    'Median Price Det Limit': '147000',
    'Metro Div Code': '0',
    'MSA Code': '36700',
    'MSA Name': 'ORANGEBURG, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PICKENS COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 335000,
    'Median Price Det Limit': '335000',
    'Metro Div Code': '0',
    'MSA Code': '24860',
    'MSA Name': 'GREENVILLE-ANDERSON-GREER, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '17900',
    'MSA Name': 'COLUMBIA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALUDA COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '17900',
    'MSA Name': 'COLUMBIA, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SPARTANBURG COU',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '43900',
    'MSA Name': 'SPARTANBURG, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMTER COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '44940',
    'MSA Name': 'SUMTER, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '43900',
    'MSA Name': 'SPARTANBURG, SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILLIAMSBURG CO',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 38000,
    'Median Price Det Limit': '84000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YORK COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '440000',
    'Metro Div Code': '0',
    'MSA Code': '16740',
    'MSA Name': 'CHARLOTTE-CONCORD-GASTONIA, NC-SC',
    'SOA Code': '203B',
    ST: 'SC',
    'State Name': 'SOUTH CAROLINA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AURORA COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEADLE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '26700',
    'MSA Name': 'HURON, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENNETT COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BON HOMME COUNT',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROOKINGS COUNT',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 326000,
    'Median Price Det Limit': '326000',
    'Metro Div Code': '0',
    'MSA Code': '15100',
    'MSA Name': 'BROOKINGS, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '10100',
    'MSA Name': 'ABERDEEN, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRULE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 272000,
    'Median Price Det Limit': '272000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUFFALO COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUTTE COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMPBELL COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 117000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHARLES MIX COU',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 224000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '46820',
    'MSA Name': 'VERMILLION, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CODINGTON COUNT',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 217000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '47980',
    'MSA Name': 'WATERTOWN, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CORSON COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUSTER COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 394000,
    'Median Price Det Limit': '394000',
    'Metro Div Code': '0',
    'MSA Code': '39660',
    'MSA Name': 'RAPID CITY, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAVISON COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '33580',
    'MSA Name': 'MITCHELL, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAY COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEUEL COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 155000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEWEY COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDMUNDS COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 282000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '10100',
    'MSA Name': 'ABERDEEN, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FALL RIVER COUN',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 274000,
    'Median Price Det Limit': '274000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAULK COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 258000,
    'Median Price Det Limit': '258000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREGORY COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 171000,
    'Median Price Det Limit': '171000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAAKON COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 193000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMLIN COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAND COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANSON COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '33580',
    'MSA Name': 'MITCHELL, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDING COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 207000,
    'Median Price Det Limit': '207000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUGHES COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '344000',
    'Metro Div Code': '0',
    'MSA Code': '38180',
    'MSA Name': 'PIERRE, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUTCHINSON COUN',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '214000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HYDE COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JERAULD COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JONES COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KINGSBURY COUNT',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 186000,
    'Median Price Det Limit': '212000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 271000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541650,
    '2 Unit': 693400,
    '3 Unit': 838150,
    '4 Unit': 1041650,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '081',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 412000,
    'Median Price Det Limit': '471000',
    'Metro Div Code': '0',
    'MSA Code': '43940',
    'MSA Name': 'SPEARFISH, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 405000,
    'Median Price Det Limit': '405000',
    'Metro Div Code': '0',
    'MSA Code': '43620',
    'MSA Name': 'SIOUX FALLS, SD-MN',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYMAN COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCOOK COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 405000,
    'Median Price Det Limit': '405000',
    'Metro Div Code': '0',
    'MSA Code': '43620',
    'MSA Name': 'SIOUX FALLS, SD-MN',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCPHERSON COUNT',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 104000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEADE COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 394000,
    'Median Price Det Limit': '394000',
    'Metro Div Code': '0',
    'MSA Code': '39660',
    'MSA Name': 'RAPID CITY, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MELLETTE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '82000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINER COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINNEHAHA COUNT',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 405000,
    'Median Price Det Limit': '405000',
    'Metro Div Code': '0',
    'MSA Code': '43620',
    'MSA Name': 'SIOUX FALLS, SD-MN',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOODY COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 273000,
    'Median Price Det Limit': '276000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OGLALA LAKOTA C',
    FIPS: '102',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 61000,
    'Median Price Det Limit': '61000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENNINGTON COUN',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 394000,
    'Median Price Det Limit': '394000',
    'Metro Div Code': '0',
    'MSA Code': '39660',
    'MSA Name': 'RAPID CITY, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERKINS COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POTTER COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROBERTS COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANBORN COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '33580',
    'MSA Name': 'MITCHELL, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SPINK COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STANLEY COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '344000',
    'Metro Div Code': '0',
    'MSA Code': '38180',
    'MSA Name': 'PIERRE, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLY COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '271000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TODD COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 57000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2011',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRIPP COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '182000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TURNER COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 405000,
    'Median Price Det Limit': '405000',
    'Metro Div Code': '0',
    'MSA Code': '43620',
    'MSA Name': 'SIOUX FALLS, SD-MN',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '359000',
    'Metro Div Code': '0',
    'MSA Code': '43580',
    'MSA Name': 'SIOUX CITY, IA-NE-SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALWORTH COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 164000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YANKTON COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 255000,
    'Median Price Det Limit': '255000',
    'Metro Div Code': '0',
    'MSA Code': '49460',
    'MSA Name': 'YANKTON, SD',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ZIEBACH COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'SD',
    'State Name': 'SOUTH DAKOTA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDERSON COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEDFORD COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '43180',
    'MSA Name': 'SHELBYVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '76000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLEDSOE COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 71000,
    'Median Price Det Limit': '100000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLOUNT COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRADLEY COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '17420',
    'MSA Name': 'CLEVELAND, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMPBELL COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'CANNON COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 112000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARTER COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '27740',
    'MSA Name': 'JOHNSON CITY, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'CHEATHAM COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHESTER COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '27180',
    'MSA Name': 'JACKSON, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAIBORNE COUNT',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '75000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COCKE COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 97000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '35460',
    'MSA Name': 'NEWPORT, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COFFEE COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 256000,
    'Median Price Det Limit': '256000',
    'Metro Div Code': '0',
    'MSA Code': '46100',
    'MSA Name': 'TULLAHOMA-MANCHESTER, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROCKETT COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '27180',
    'MSA Name': 'JACKSON, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '18900',
    'MSA Name': 'CROSSVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'DAVIDSON COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DECATUR COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 69000,
    'Median Price Det Limit': '75000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEKALB COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 201000,
    'Median Price Det Limit': '201000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'DICKSON COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DYER COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 135000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '20540',
    'MSA Name': 'DYERSBURG, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FENTRESS COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '49010',
    'MSA Name': 'WINCHESTER, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GIBSON COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '27180',
    'MSA Name': 'JACKSON, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILES COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAINGER COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENE COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '24620',
    'MSA Name': 'GREENEVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRUNDY COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '93000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMBLEN COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 255000,
    'Median Price Det Limit': '255000',
    'Metro Div Code': '0',
    'MSA Code': '34100',
    'MSA Name': 'MORRISTOWN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '16860',
    'MSA Name': 'CHATTANOOGA, TN-GA',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 68000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDEMAN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '85000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDIN COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 110000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAWKINS COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '28700',
    'MSA Name': 'KINGSPORT-BRISTOL, TN-VA',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAYWOOD COUNTY',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDERSON COUNT',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 151000,
    'Median Price Det Limit': '151000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '37540',
    'MSA Name': 'PARIS, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'HICKMAN COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOUSTON COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '138000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUMPHREYS COUNT',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 157000,
    'Median Price Det Limit': '157000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '18260',
    'MSA Name': 'COOKEVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 255000,
    'Median Price Det Limit': '255000',
    'Metro Div Code': '0',
    'MSA Code': '34100',
    'MSA Name': 'MORRISTOWN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAKE COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '80000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAUDERDALE COUN',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAWRENCE COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '29980',
    'MSA Name': 'LAWRENCEBURG, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 199000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '22190',
    'MSA Name': 'FAYETTEVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOUDON COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCMINN COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '11940',
    'MSA Name': 'ATHENS, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCNAIRY COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'MACON COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 209000,
    'Median Price Det Limit': '209000',
    'Metro Div Code': '0',
    'MSA Code': '27180',
    'MSA Name': 'JACKSON, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '16860',
    'MSA Name': 'CHATTANOOGA, TN-GA',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '30280',
    'MSA Name': 'LEWISBURG, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'MAURY COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MEIGS COUNTY',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '11940',
    'MSA Name': 'ATHENS, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 305000,
    'Median Price Det Limit': '305000',
    'Metro Div Code': '0',
    'MSA Code': '17300',
    'MSA Name': 'CLARKSVILLE, TN-KY',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOORE COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 256000,
    'Median Price Det Limit': '256000',
    'Metro Div Code': '0',
    'MSA Code': '46100',
    'MSA Name': 'TULLAHOMA-MANCHESTER, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OBION COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '46460',
    'MSA Name': 'UNION CITY, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OVERTON COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '18260',
    'MSA Name': 'COOKEVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PERRY COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 71000,
    'Median Price Det Limit': '71000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PICKETT COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '17420',
    'MSA Name': 'CLEVELAND, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '18260',
    'MSA Name': 'COOKEVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RHEA COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROANE COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'ROBERTSON COUNT',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'RUTHERFORD COUN',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEQUATCHIE COUN',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '16860',
    'MSA Name': 'CHATTANOOGA, TN-GA',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEVIER COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '42940',
    'MSA Name': 'SEVIERVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'SMITH COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEWART COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 305000,
    'Median Price Det Limit': '305000',
    'Metro Div Code': '0',
    'MSA Code': '17300',
    'MSA Name': 'CLARKSVILLE, TN-KY',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SULLIVAN COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '28700',
    'MSA Name': 'KINGSPORT-BRISTOL, TN-VA',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'SUMNER COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TIPTON COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 339000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '32820',
    'MSA Name': 'MEMPHIS, TN-MS-AR',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'TROUSDALE COUNT',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNICOI COUNTY',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '27740',
    'MSA Name': 'JOHNSON CITY, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UNION COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 383000,
    'Median Price Det Limit': '383000',
    'Metro Div Code': '0',
    'MSA Code': '28940',
    'MSA Name': 'KNOXVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAN BUREN COUNT',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 60000,
    'Median Price Det Limit': '98000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARREN COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '32660',
    'MSA Name': 'MCMINNVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '27740',
    'MSA Name': 'JOHNSON CITY, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 63000,
    'Median Price Det Limit': '75000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEAKLEY COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '32280',
    'MSA Name': 'MARTIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHITE COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '18260',
    'MSA Name': 'COOKEVILLE, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'WILLIAMSON COUN',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1029250,
    '2 Unit': 1317650,
    '3 Unit': 1592700,
    '4 Unit': 1979350,
    'County Name': 'WILSON COUNTY',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 895000,
    'Median Price Det Limit': '895000',
    'Metro Div Code': '0',
    'MSA Code': '34980',
    'MSA Name': 'NASHVILLE-DAVIDSON--MURFREESBORO--FRANKLIN, TN',
    'SOA Code': '203B',
    ST: 'TN',
    'State Name': 'TENNESSEE',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDERSON COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '37300',
    'MSA Name': 'PALESTINE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANDREWS COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 324000,
    'Median Price Det Limit': '379000',
    'Metro Div Code': '0',
    'MSA Code': '11380',
    'MSA Name': 'ANDREWS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ANGELINA COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 206000,
    'Median Price Det Limit': '206000',
    'Metro Div Code': '0',
    'MSA Code': '31260',
    'MSA Name': 'LUFKIN, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARANSAS COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '18580',
    'MSA Name': 'CORPUS CHRISTI, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARCHER COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '48660',
    'MSA Name': 'WICHITA FALLS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ARMSTRONG COUNT',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '11100',
    'MSA Name': 'AMARILLO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'ATASCOSA COUNTY',
    FIPS: '013',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AUSTIN COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAILEY COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '158000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'BANDERA COUNTY',
    FIPS: '019',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 571550,
    '2 Unit': 731700,
    '3 Unit': 884450,
    '4 Unit': 1099150,
    'County Name': 'BASTROP COUNTY',
    FIPS: '021',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 467000,
    'Median Price Det Limit': '497000',
    'Metro Div Code': '0',
    'MSA Code': '12420',
    'MSA Name': 'AUSTIN-ROUND ROCK-SAN MARCOS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAYLOR COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEE COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '13300',
    'MSA Name': 'BEEVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BELL COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '28660',
    'MSA Name': 'KILLEEN-TEMPLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'BEXAR COUNTY',
    FIPS: '029',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLANCO COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 362000,
    'Median Price Det Limit': '384000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BORDEN COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '283000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOSQUE COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 281000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '47380',
    'MSA Name': 'WACO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOWIE COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '194000',
    'Metro Div Code': '0',
    'MSA Code': '45500',
    'MSA Name': 'TEXARKANA, TX-AR',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRAZORIA COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRAZOS COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 322000,
    'Median Price Det Limit': '322000',
    'Metro Div Code': '0',
    'MSA Code': '17780',
    'MSA Name': 'COLLEGE STATION-BRYAN, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BREWSTER COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 248000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRISCOE COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROOKS COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '10860',
    'MSA Name': 'ALICE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '15220',
    'MSA Name': 'BROWNWOOD, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURLESON COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 322000,
    'Median Price Det Limit': '322000',
    'Metro Div Code': '0',
    'MSA Code': '17780',
    'MSA Name': 'COLLEGE STATION-BRYAN, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURNET COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 314000,
    'Median Price Det Limit': '318000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 571550,
    '2 Unit': 731700,
    '3 Unit': 884450,
    '4 Unit': 1099150,
    'County Name': 'CALDWELL COUNTY',
    FIPS: '055',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 467000,
    'Median Price Det Limit': '497000',
    'Metro Div Code': '0',
    'MSA Code': '12420',
    'MSA Name': 'AUSTIN-ROUND ROCK-SAN MARCOS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '38920',
    'MSA Name': 'PORT LAVACA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALLAHAN COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '10180',
    'MSA Name': 'ABILENE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMERON COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '15180',
    'MSA Name': 'BROWNSVILLE-HARLINGEN, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMP COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 227000,
    'Median Price Det Limit': '227000',
    'Metro Div Code': '0',
    'MSA Code': '34420',
    'MSA Name': 'MOUNT PLEASANT, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARSON COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '11100',
    'MSA Name': 'AMARILLO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASS COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '156000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CASTRO COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHAMBERS COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHEROKEE COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '27380',
    'MSA Name': 'JACKSONVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHILDRESS COUNT',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '48660',
    'MSA Name': 'WICHITA FALLS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COCHRAN COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '31180',
    'MSA Name': 'LUBBOCK, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COKE COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 117000,
    'Median Price Det Limit': '135000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLEMAN COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 143000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'COLLIN COUNTY',
    FIPS: '085',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLLINGSWORTH C',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 127000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLORADO COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'COMAL COUNTY',
    FIPS: '091',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COMANCHE COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CONCHO COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COOKE COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 306000,
    'Median Price Det Limit': '306000',
    'Metro Div Code': '0',
    'MSA Code': '23620',
    'MSA Name': 'GAINESVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CORYELL COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '28660',
    'MSA Name': 'KILLEEN-TEMPLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COTTLE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 82000,
    'Median Price Det Limit': '82000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRANE COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 63000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2017',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROCKETT COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROSBY COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '31180',
    'MSA Name': 'LUBBOCK, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CULBERSON COUNT',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DALLAM COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'DALLAS COUNTY',
    FIPS: '113',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAWSON COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEAF SMITH COUN',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 156000,
    'Median Price Det Limit': '193000',
    'Metro Div Code': '0',
    'MSA Code': '25820',
    'MSA Name': 'HEREFORD, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DELTA COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '318000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'DENTON COUNTY',
    FIPS: '121',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DEWITT COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 188000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DICKENS COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '103000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DIMMIT COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 153000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DONLEY COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUVAL COUNTY',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 69000,
    'Median Price Det Limit': '120000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EASTLAND COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 168000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ECTOR COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '36220',
    'MSA Name': 'ODESSA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EDWARDS COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 219000,
    'Median Price Det Limit': '219000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'ELLIS COUNTY',
    FIPS: '139',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EL PASO COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '21340',
    'MSA Name': 'EL PASO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ERATH COUNTY',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 278000,
    'Median Price Det Limit': '278000',
    'Metro Div Code': '0',
    'MSA Code': '44500',
    'MSA Name': 'STEPHENVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FALLS COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 281000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '47380',
    'MSA Name': 'WACO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FANNIN COUNTY',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 264000,
    'Median Price Det Limit': '264000',
    'Metro Div Code': '0',
    'MSA Code': '14300',
    'MSA Name': 'BONHAM, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '297000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FISHER COUNTY',
    FIPS: '151',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLOYD COUNTY',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '38380',
    'MSA Name': 'PLAINVIEW, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FOARD COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 64000,
    'Median Price Det Limit': '92000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FORT BEND COUNT',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 224000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREESTONE COUNT',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 181000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRIO COUNTY',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '177000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GAINES COUNTY',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 68000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2014',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GALVESTON COUNT',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARZA COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '31180',
    'MSA Name': 'LUBBOCK, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILLESPIE COUNT',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 333000,
    'Median Price Det Limit': '405000',
    'Metro Div Code': '0',
    'MSA Code': '23240',
    'MSA Name': 'FREDERICKSBURG, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 813050,
    '2 Unit': 1040850,
    '3 Unit': 1258150,
    '4 Unit': 1563600,
    'County Name': 'GLASSCOCK COUNT',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 707000,
    'Median Price Det Limit': '707000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOLIAD COUNTY',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '47020',
    'MSA Name': 'VICTORIA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GONZALES COUNTY',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 203000,
    'Median Price Det Limit': '212000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAY COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '37420',
    'MSA Name': 'PAMPA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAYSON COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 294000,
    'Median Price Det Limit': '294000',
    'Metro Div Code': '0',
    'MSA Code': '43300',
    'MSA Name': 'SHERMAN-DENISON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREGG COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '30980',
    'MSA Name': 'LONGVIEW, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRIMES COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'GUADALUPE COUNT',
    FIPS: '187',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALE COUNTY',
    FIPS: '189',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '38380',
    'MSA Name': 'PLAINVIEW, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALL COUNTY',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 106000,
    'Median Price Det Limit': '106000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMILTON COUNTY',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '198000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANSFORD COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDEMAN COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 77000,
    'Median Price Det Limit': '79000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDIN COUNTY',
    FIPS: '199',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '13140',
    'MSA Name': 'BEAUMONT-PORT ARTHUR, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRIS COUNTY',
    FIPS: '201',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '203',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '30980',
    'MSA Name': 'LONGVIEW, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARTLEY COUNTY',
    FIPS: '205',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HASKELL COUNTY',
    FIPS: '207',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 123000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 571550,
    '2 Unit': 731700,
    '3 Unit': 884450,
    '4 Unit': 1099150,
    'County Name': 'HAYS COUNTY',
    FIPS: '209',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 467000,
    'Median Price Det Limit': '497000',
    'Metro Div Code': '0',
    'MSA Code': '12420',
    'MSA Name': 'AUSTIN-ROUND ROCK-SAN MARCOS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HEMPHILL COUNTY',
    FIPS: '211',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 132000,
    'Median Price Det Limit': '181000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENDERSON COUNT',
    FIPS: '213',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '11980',
    'MSA Name': 'ATHENS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HIDALGO COUNTY',
    FIPS: '215',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 221000,
    'Median Price Det Limit': '221000',
    'Metro Div Code': '0',
    'MSA Code': '32580',
    'MSA Name': 'MCALLEN-EDINBURG-MISSION, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HILL COUNTY',
    FIPS: '217',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOCKLEY COUNTY',
    FIPS: '219',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '31180',
    'MSA Name': 'LUBBOCK, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOOD COUNTY',
    FIPS: '221',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '24180',
    'MSA Name': 'GRANBURY, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOPKINS COUNTY',
    FIPS: '223',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 247000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '44860',
    'MSA Name': 'SULPHUR SPRINGS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOUSTON COUNTY',
    FIPS: '225',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOWARD COUNTY',
    FIPS: '227',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 181000,
    'Median Price Det Limit': '186000',
    'Metro Div Code': '0',
    'MSA Code': '13700',
    'MSA Name': 'BIG SPRING, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUDSPETH COUNTY',
    FIPS: '229',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '21340',
    'MSA Name': 'EL PASO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'HUNT COUNTY',
    FIPS: '231',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HUTCHINSON COUN',
    FIPS: '233',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '14420',
    'MSA Name': 'BORGER, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IRION COUNTY',
    FIPS: '235',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '41660',
    'MSA Name': 'SAN ANGELO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACK COUNTY',
    FIPS: '237',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '211000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '239',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JASPER COUNTY',
    FIPS: '241',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFF DAVIS COUN',
    FIPS: '243',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 355000,
    'Median Price Det Limit': '355000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '245',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '13140',
    'MSA Name': 'BEAUMONT-PORT ARTHUR, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JIM HOGG COUNTY',
    FIPS: '247',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 133000,
    'Median Price Det Limit': '152000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2012',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JIM WELLS COUNT',
    FIPS: '249',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '10860',
    'MSA Name': 'ALICE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '251',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '23104',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JONES COUNTY',
    FIPS: '253',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '10180',
    'MSA Name': 'ABILENE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KARNES COUNTY',
    FIPS: '255',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 189000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'KAUFMAN COUNTY',
    FIPS: '257',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'KENDALL COUNTY',
    FIPS: '259',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENEDY COUNTY',
    FIPS: '261',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENT COUNTY',
    FIPS: '263',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 197000,
    'Median Price Det Limit': '197000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KERR COUNTY',
    FIPS: '265',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 291000,
    'Median Price Det Limit': '298000',
    'Metro Div Code': '0',
    'MSA Code': '28500',
    'MSA Name': 'KERRVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KIMBLE COUNTY',
    FIPS: '267',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 262000,
    'Median Price Det Limit': '292000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KING COUNTY',
    FIPS: '269',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 53000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KINNEY COUNTY',
    FIPS: '271',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '302000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KLEBERG COUNTY',
    FIPS: '273',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '28780',
    'MSA Name': 'KINGSVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KNOX COUNTY',
    FIPS: '275',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMAR COUNTY',
    FIPS: '277',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37580',
    'MSA Name': 'PARIS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMB COUNTY',
    FIPS: '279',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '143000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMPASAS COUNTY',
    FIPS: '281',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '28660',
    'MSA Name': 'KILLEEN-TEMPLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LA SALLE COUNTY',
    FIPS: '283',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 85000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAVACA COUNTY',
    FIPS: '285',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 223000,
    'Median Price Det Limit': '223000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '287',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 273000,
    'Median Price Det Limit': '273000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEON COUNTY',
    FIPS: '289',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 176000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIBERTY COUNTY',
    FIPS: '291',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIMESTONE COUNT',
    FIPS: '293',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIPSCOMB COUNTY',
    FIPS: '295',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '123000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LIVE OAK COUNTY',
    FIPS: '297',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LLANO COUNTY',
    FIPS: '299',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOVING COUNTY',
    FIPS: '301',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '308000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUBBOCK COUNTY',
    FIPS: '303',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '31180',
    'MSA Name': 'LUBBOCK, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYNN COUNTY',
    FIPS: '305',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '237000',
    'Metro Div Code': '0',
    'MSA Code': '31180',
    'MSA Name': 'LUBBOCK, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCCULLOCH COUNT',
    FIPS: '307',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCLENNAN COUNTY',
    FIPS: '309',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 281000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '47380',
    'MSA Name': 'WACO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCMULLEN COUNTY',
    FIPS: '311',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 146000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '313',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 198000,
    'Median Price Det Limit': '228000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '315',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 142000,
    'Median Price Det Limit': '172000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARTIN COUNTY',
    FIPS: '317',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '33260',
    'MSA Name': 'MIDLAND, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASON COUNTY',
    FIPS: '319',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MATAGORDA COUNT',
    FIPS: '321',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '13060',
    'MSA Name': 'BAY CITY, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MAVERICK COUNTY',
    FIPS: '323',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 249000,
    'Median Price Det Limit': '249000',
    'Metro Div Code': '0',
    'MSA Code': '20580',
    'MSA Name': 'EAGLE PASS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'MEDINA COUNTY',
    FIPS: '325',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MENARD COUNTY',
    FIPS: '327',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIDLAND COUNTY',
    FIPS: '329',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '350000',
    'Metro Div Code': '0',
    'MSA Code': '33260',
    'MSA Name': 'MIDLAND, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILAM COUNTY',
    FIPS: '331',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 231000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILLS COUNTY',
    FIPS: '333',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 277000,
    'Median Price Det Limit': '277000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MITCHELL COUNTY',
    FIPS: '335',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '108000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTAGUE COUNTY',
    FIPS: '337',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 183000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '339',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOORE COUNTY',
    FIPS: '341',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '182000',
    'Metro Div Code': '0',
    'MSA Code': '20300',
    'MSA Name': 'DUMAS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORRIS COUNTY',
    FIPS: '343',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 227000,
    'Median Price Det Limit': '227000',
    'Metro Div Code': '0',
    'MSA Code': '34420',
    'MSA Name': 'MOUNT PLEASANT, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MOTLEY COUNTY',
    FIPS: '345',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NACOGDOCHES COU',
    FIPS: '347',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 213000,
    'Median Price Det Limit': '216000',
    'Metro Div Code': '0',
    'MSA Code': '34860',
    'MSA Name': 'NACOGDOCHES, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NAVARRO COUNTY',
    FIPS: '349',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '18620',
    'MSA Name': 'CORSICANA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NEWTON COUNTY',
    FIPS: '351',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '168000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOLAN COUNTY',
    FIPS: '353',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '45020',
    'MSA Name': 'SWEETWATER, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NUECES COUNTY',
    FIPS: '355',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '18580',
    'MSA Name': 'CORPUS CHRISTI, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OCHILTREE COUNT',
    FIPS: '357',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 184000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OLDHAM COUNTY',
    FIPS: '359',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '11100',
    'MSA Name': 'AMARILLO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGE COUNTY',
    FIPS: '361',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '13140',
    'MSA Name': 'BEAUMONT-PORT ARTHUR, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PALO PINTO COUN',
    FIPS: '363',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 223000,
    'Median Price Det Limit': '227000',
    'Metro Div Code': '0',
    'MSA Code': '33420',
    'MSA Name': 'MINERAL WELLS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PANOLA COUNTY',
    FIPS: '365',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 184000,
    'Median Price Det Limit': '199000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'PARKER COUNTY',
    FIPS: '367',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '23104',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PARMER COUNTY',
    FIPS: '369',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 176000,
    'Median Price Det Limit': '176000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PECOS COUNTY',
    FIPS: '371',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '373',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POTTER COUNTY',
    FIPS: '375',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '11100',
    'MSA Name': 'AMARILLO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRESIDIO COUNTY',
    FIPS: '377',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '272000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RAINS COUNTY',
    FIPS: '379',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 288000,
    'Median Price Det Limit': '288000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDALL COUNTY',
    FIPS: '381',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '11100',
    'MSA Name': 'AMARILLO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REAGAN COUNTY',
    FIPS: '383',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REAL COUNTY',
    FIPS: '385',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 161000,
    'Median Price Det Limit': '183000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RED RIVER COUNT',
    FIPS: '387',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 172000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '37580',
    'MSA Name': 'PARIS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REEVES COUNTY',
    FIPS: '389',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '45880',
    'MSA Name': 'TOWN OF PECOS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'REFUGIO COUNTY',
    FIPS: '391',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROBERTS COUNTY',
    FIPS: '393',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '231000',
    'Metro Div Code': '0',
    'MSA Code': '37420',
    'MSA Name': 'PAMPA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROBERTSON COUNT',
    FIPS: '395',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 322000,
    'Median Price Det Limit': '322000',
    'Metro Div Code': '0',
    'MSA Code': '17780',
    'MSA Name': 'COLLEGE STATION-BRYAN, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'ROCKWALL COUNTY',
    FIPS: '397',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '19124',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUNNELS COUNTY',
    FIPS: '399',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSK COUNTY',
    FIPS: '401',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '30980',
    'MSA Name': 'LONGVIEW, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SABINE COUNTY',
    FIPS: '403',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '173000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN AUGUSTINE C',
    FIPS: '405',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 113000,
    'Median Price Det Limit': '132000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN JACINTO COU',
    FIPS: '407',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN PATRICIO CO',
    FIPS: '409',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '299000',
    'Metro Div Code': '0',
    'MSA Code': '18580',
    'MSA Name': 'CORPUS CHRISTI, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN SABA COUNTY',
    FIPS: '411',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCHLEICHER COUN',
    FIPS: '413',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCURRY COUNTY',
    FIPS: '415',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 158000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '43660',
    'MSA Name': 'SNYDER, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHACKELFORD COU',
    FIPS: '417',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '306000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHELBY COUNTY',
    FIPS: '419',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 154000,
    'Median Price Det Limit': '154000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERMAN COUNTY',
    FIPS: '421',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SMITH COUNTY',
    FIPS: '423',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '46340',
    'MSA Name': 'TYLER, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOMERVELL COUNT',
    FIPS: '425',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 333000,
    'Median Price Det Limit': '333000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STARR COUNTY',
    FIPS: '427',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '40100',
    'MSA Name': 'RIO GRANDE CITY-ROMA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEPHENS COUNTY',
    FIPS: '429',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 139000,
    'Median Price Det Limit': '171000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STERLING COUNTY',
    FIPS: '431',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 351000,
    'Median Price Det Limit': '351000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STONEWALL COUNT',
    FIPS: '433',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 73000,
    'Median Price Det Limit': '188000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUTTON COUNTY',
    FIPS: '435',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWISHER COUNTY',
    FIPS: '437',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 96000,
    'Median Price Det Limit': '129000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'TARRANT COUNTY',
    FIPS: '439',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '23104',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '441',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '10180',
    'MSA Name': 'ABILENE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TERRELL COUNTY',
    FIPS: '443',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 87000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TERRY COUNTY',
    FIPS: '445',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 149000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'THROCKMORTON CO',
    FIPS: '447',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '179000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TITUS COUNTY',
    FIPS: '449',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 227000,
    'Median Price Det Limit': '227000',
    'Metro Div Code': '0',
    'MSA Code': '34420',
    'MSA Name': 'MOUNT PLEASANT, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TOM GREEN COUNT',
    FIPS: '451',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 239000,
    'Median Price Det Limit': '239000',
    'Metro Div Code': '0',
    'MSA Code': '41660',
    'MSA Name': 'SAN ANGELO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 571550,
    '2 Unit': 731700,
    '3 Unit': 884450,
    '4 Unit': 1099150,
    'County Name': 'TRAVIS COUNTY',
    FIPS: '453',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 467000,
    'Median Price Det Limit': '497000',
    'Metro Div Code': '0',
    'MSA Code': '12420',
    'MSA Name': 'AUSTIN-ROUND ROCK-SAN MARCOS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TRINITY COUNTY',
    FIPS: '455',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 148000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TYLER COUNTY',
    FIPS: '457',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 170000,
    'Median Price Det Limit': '170000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UPSHUR COUNTY',
    FIPS: '459',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '30980',
    'MSA Name': 'LONGVIEW, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UPTON COUNTY',
    FIPS: '461',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UVALDE COUNTY',
    FIPS: '463',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '210000',
    'Metro Div Code': '0',
    'MSA Code': '46620',
    'MSA Name': 'UVALDE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAL VERDE COUNT',
    FIPS: '465',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 222000,
    'Median Price Det Limit': '222000',
    'Metro Div Code': '0',
    'MSA Code': '19620',
    'MSA Name': 'DEL RIO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VAN ZANDT COUNT',
    FIPS: '467',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 247000,
    'Median Price Det Limit': '247000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VICTORIA COUNTY',
    FIPS: '469',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 232000,
    'Median Price Det Limit': '232000',
    'Metro Div Code': '0',
    'MSA Code': '47020',
    'MSA Name': 'VICTORIA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALKER COUNTY',
    FIPS: '471',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 237000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '26660',
    'MSA Name': 'HUNTSVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALLER COUNTY',
    FIPS: '473',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '26420',
    'MSA Name': 'HOUSTON-PASADENA-THE WOODLANDS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WARD COUNTY',
    FIPS: '475',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '477',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 283000,
    'Median Price Det Limit': '293000',
    'Metro Div Code': '0',
    'MSA Code': '14780',
    'MSA Name': 'BRENHAM, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBB COUNTY',
    FIPS: '479',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 247000,
    'Median Price Det Limit': '247000',
    'Metro Div Code': '0',
    'MSA Code': '29700',
    'MSA Name': 'LAREDO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHARTON COUNTY',
    FIPS: '481',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 207000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '20900',
    'MSA Name': 'EL CAMPO, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WHEELER COUNTY',
    FIPS: '483',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 131000,
    'Median Price Det Limit': '148000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WICHITA COUNTY',
    FIPS: '485',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 238000,
    'Median Price Det Limit': '238000',
    'Metro Div Code': '0',
    'MSA Code': '48660',
    'MSA Name': 'WICHITA FALLS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILBARGER COUNT',
    FIPS: '487',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 128000,
    'Median Price Det Limit': '128000',
    'Metro Div Code': '0',
    'MSA Code': '46900',
    'MSA Name': 'VERNON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WILLACY COUNTY',
    FIPS: '489',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 97000,
    'Median Price Det Limit': '97000',
    'Metro Div Code': '0',
    'MSA Code': '39700',
    'MSA Name': 'RAYMONDVILLE, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 571550,
    '2 Unit': 731700,
    '3 Unit': 884450,
    '4 Unit': 1099150,
    'County Name': 'WILLIAMSON COUN',
    FIPS: '491',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 467000,
    'Median Price Det Limit': '497000',
    'Metro Div Code': '0',
    'MSA Code': '12420',
    'MSA Name': 'AUSTIN-ROUND ROCK-SAN MARCOS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 557750,
    '2 Unit': 714000,
    '3 Unit': 863100,
    '4 Unit': 1072600,
    'County Name': 'WILSON COUNTY',
    FIPS: '493',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 469000,
    'Median Price Det Limit': '485000',
    'Metro Div Code': '0',
    'MSA Code': '41700',
    'MSA Name': 'SAN ANTONIO-NEW BRAUNFELS, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINKLER COUNTY',
    FIPS: '495',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 185000,
    'Median Price Det Limit': '185000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 563500,
    '2 Unit': 721400,
    '3 Unit': 872000,
    '4 Unit': 1083650,
    'County Name': 'WISE COUNTY',
    FIPS: '497',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 479000,
    'Median Price Det Limit': '490000',
    'Metro Div Code': '23104',
    'MSA Code': '19100',
    'MSA Name': 'DALLAS-FORT WORTH-ARLINGTON, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOOD COUNTY',
    FIPS: '499',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YOAKUM COUNTY',
    FIPS: '501',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 213000,
    'Median Price Det Limit': '213000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YOUNG COUNTY',
    FIPS: '503',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 182000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ZAPATA COUNTY',
    FIPS: '505',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '92000',
    'Metro Div Code': '0',
    'MSA Code': '49820',
    'MSA Name': 'ZAPATA, TX',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ZAVALA COUNTY',
    FIPS: '507',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 94000,
    'Median Price Det Limit': '95000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'TX',
    'State Name': 'TEXAS',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEAVER COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 289000,
    'Median Price Det Limit': '289000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOX ELDER COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 401000,
    'Median Price Det Limit': '404000',
    'Metro Div Code': '0',
    'MSA Code': '14940',
    'MSA Name': 'BRIGHAM CITY, UT-ID',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CACHE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '430000',
    'Metro Div Code': '0',
    'MSA Code': '30860',
    'MSA Name': 'LOGAN, UT-ID',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARBON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 259000,
    'Median Price Det Limit': '259000',
    'Metro Div Code': '0',
    'MSA Code': '39220',
    'MSA Name': 'PRICE, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DAGGETT COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 323000,
    'Median Price Det Limit': '385000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 744050,
    '2 Unit': 952500,
    '3 Unit': 1151400,
    '4 Unit': 1430900,
    'County Name': 'DAVIS COUNTY',
    FIPS: '011',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '647000',
    'Metro Div Code': '0',
    'MSA Code': '36260',
    'MSA Name': 'OGDEN, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUCHESNE COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 297000,
    'Median Price Det Limit': '308000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EMERY COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 263000,
    'Median Price Det Limit': '263000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARFIELD COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 381000,
    'Median Price Det Limit': '381000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 839500,
    '2 Unit': 1074700,
    '3 Unit': 1299100,
    '4 Unit': 1614450,
    'County Name': 'GRAND COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 730000,
    'Median Price Det Limit': '730000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IRON COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 370000,
    'Median Price Det Limit': '370000',
    'Metro Div Code': '0',
    'MSA Code': '16260',
    'MSA Name': 'CEDAR CITY, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 601450,
    '2 Unit': 769950,
    '3 Unit': 930700,
    '4 Unit': 1156650,
    'County Name': 'JUAB COUNTY',
    FIPS: '023',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 523000,
    'Median Price Det Limit': '523000',
    'Metro Div Code': '0',
    'MSA Code': '39340',
    'MSA Name': 'PROVO-OREM-LEHI, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KANE COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILLARD COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 304000,
    'Median Price Det Limit': '332000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 744050,
    '2 Unit': 952500,
    '3 Unit': 1151400,
    '4 Unit': 1430900,
    'County Name': 'MORGAN COUNTY',
    FIPS: '029',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '647000',
    'Metro Div Code': '0',
    'MSA Code': '36260',
    'MSA Name': 'OGDEN, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PIUTE COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 314000,
    'Median Price Det Limit': '319000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 579600,
    '2 Unit': 742000,
    '3 Unit': 896900,
    '4 Unit': 1114650,
    'County Name': 'RICH COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 433000,
    'Median Price Det Limit': '504000',
    'Metro Div Code': '0',
    'MSA Code': '21740',
    'MSA Name': 'EVANSTON, WY-UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 637100,
    '2 Unit': 815600,
    '3 Unit': 985900,
    '4 Unit': 1225200,
    'County Name': 'SALT LAKE COUNT',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 554000,
    'Median Price Det Limit': '554000',
    'Metro Div Code': '0',
    'MSA Code': '41620',
    'MSA Name': 'SALT LAKE CITY-MURRAY, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAN JUAN COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '257000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SANPETE COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 348000,
    'Median Price Det Limit': '349000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SEVIER COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1163800,
    '2 Unit': 1489900,
    '3 Unit': 1800950,
    '4 Unit': 2238150,
    'County Name': 'SUMMIT COUNTY',
    FIPS: '043',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 1000000,
    'Median Price Det Limit': '1012000',
    'Metro Div Code': '0',
    'MSA Code': '25720',
    'MSA Name': 'HEBER, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 637100,
    '2 Unit': 815600,
    '3 Unit': 985900,
    '4 Unit': 1225200,
    'County Name': 'TOOELE COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 554000,
    'Median Price Det Limit': '554000',
    'Metro Div Code': '0',
    'MSA Code': '41620',
    'MSA Name': 'SALT LAKE CITY-MURRAY, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UINTAH COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '425000',
    'Metro Div Code': '0',
    'MSA Code': '46860',
    'MSA Name': 'VERNAL, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 601450,
    '2 Unit': 769950,
    '3 Unit': 930700,
    '4 Unit': 1156650,
    'County Name': 'UTAH COUNTY',
    FIPS: '049',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 523000,
    'Median Price Det Limit': '523000',
    'Metro Div Code': '0',
    'MSA Code': '39340',
    'MSA Name': 'PROVO-OREM-LEHI, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1163800,
    '2 Unit': 1489900,
    '3 Unit': 1800950,
    '4 Unit': 2238150,
    'County Name': 'WASATCH COUNTY',
    FIPS: '051',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 1000000,
    'Median Price Det Limit': '1012000',
    'Metro Div Code': '0',
    'MSA Code': '25720',
    'MSA Name': 'HEBER, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 607200,
    '2 Unit': 777300,
    '3 Unit': 939600,
    '4 Unit': 1167700,
    'County Name': 'WASHINGTON COUN',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 528000,
    'Median Price Det Limit': '528000',
    'Metro Div Code': '0',
    'MSA Code': '41100',
    'MSA Name': 'ST. GEORGE, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 997050,
    '2 Unit': 1276400,
    '3 Unit': 1542900,
    '4 Unit': 1917450,
    'County Name': 'WAYNE COUNTY',
    FIPS: '055',
    'Limit Date': 20240101,
    'Limit Type': 'H',
    'Median Price': 487000,
    'Median Price Det Limit': '867000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 744050,
    '2 Unit': 952500,
    '3 Unit': 1151400,
    '4 Unit': 1430900,
    'County Name': 'WEBER COUNTY',
    FIPS: '057',
    'Limit Date': 20230101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '647000',
    'Metro Div Code': '0',
    'MSA Code': '36260',
    'MSA Name': 'OGDEN, UT',
    'SOA Code': '203B',
    ST: 'UT',
    'State Name': 'UTAH',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ACCOMACK COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'ALBEMARLE COUNT',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '16820',
    'MSA Name': 'CHARLOTTESVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALLEGHANY COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'AMELIA COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AMHERST COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '31340',
    'MSA Name': 'LYNCHBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'APPOMATTOX COUN',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '31340',
    'MSA Name': 'LYNCHBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'ARLINGTON COUNT',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'AUGUSTA COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 333000,
    'Median Price Det Limit': '333000',
    'Metro Div Code': '0',
    'MSA Code': '44420',
    'MSA Name': 'STAUNTON-STUARTS DRAFT, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BATH COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BEDFORD COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '31340',
    'MSA Name': 'LYNCHBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BLAND COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 105000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOTETOURT COUNT',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40220',
    'MSA Name': 'ROANOKE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRUNSWICK COUNT',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 230000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUCHANAN COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '109000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUCKINGHAM COUN',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMPBELL COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '31340',
    'MSA Name': 'LYNCHBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAROLINE COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 340000,
    'Median Price Det Limit': '340000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARROLL COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'CHARLES CITY CO',
    FIPS: '036',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHARLOTTE COUNT',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 108000,
    'Median Price Det Limit': '124000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'CHESTERFIELD CO',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'CLARKE COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAIG COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40220',
    'MSA Name': 'ROANOKE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'CULPEPER COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CUMBERLAND COUN',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DICKENSON COUNT',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 55000,
    'Median Price Det Limit': '90000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'DINWIDDIE COUNT',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESSEX COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'FAIRFAX COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'FAUQUIER COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLOYD COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '13980',
    'MSA Name': 'BLACKSBURG-CHRISTIANSBURG-RADFORD, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'FLUVANNA COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '16820',
    'MSA Name': 'CHARLOTTESVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40220',
    'MSA Name': 'ROANOKE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREDERICK COUNT',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 420000,
    'Median Price Det Limit': '420000',
    'Metro Div Code': '0',
    'MSA Code': '49020',
    'MSA Name': 'WINCHESTER, VA-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILES COUNTY',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '13980',
    'MSA Name': 'BLACKSBURG-CHRISTIANSBURG-RADFORD, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'GLOUCESTER COUN',
    FIPS: '073',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'GOOCHLAND COUNT',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAYSON COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'GREENE COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '16820',
    'MSA Name': 'CHARLOTTESVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENSVILLE COU',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 217000,
    'Median Price Det Limit': '217000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HALIFAX COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 96000,
    'Median Price Det Limit': '127000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'HANOVER COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'HENRICO COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HENRY COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '32300',
    'MSA Name': 'MARTINSVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HIGHLAND COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'ISLE OF WIGHT C',
    FIPS: '093',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'JAMES CITY COUN',
    FIPS: '095',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'KING AND QUEEN',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KING GEORGE COU',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'KING WILLIAM CO',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANCASTER COUNT',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '385000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEE COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 78000,
    'Median Price Det Limit': '88000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'LOUDOUN COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOUISA COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '375000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LUNENBURG COUNT',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 100000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MADISON COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'MATHEWS COUNTY',
    FIPS: '115',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MECKLENBURG COU',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MIDDLESEX COUNT',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 365000,
    'Median Price Det Limit': '367000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONTGOMERY COUN',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '13980',
    'MSA Name': 'BLACKSBURG-CHRISTIANSBURG-RADFORD, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'NELSON COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '16820',
    'MSA Name': 'CHARLOTTESVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'NEW KENT COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHAMPTON COU',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 214000,
    'Median Price Det Limit': '255000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTHUMBERLAND',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '292000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NOTTOWAY COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGE COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 390000,
    'Median Price Det Limit': '390000',
    'Metro Div Code': '0',
    'MSA Code': '29470',
    'MSA Name': 'LAKE OF THE WOODS, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PAGE COUNTY',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 262000,
    'Median Price Det Limit': '262000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PATRICK COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 183000,
    'Median Price Det Limit': '184000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PITTSYLVANIA CO',
    FIPS: '143',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '162000',
    'Metro Div Code': '0',
    'MSA Code': '19260',
    'MSA Name': 'DANVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'POWHATAN COUNTY',
    FIPS: '145',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRINCE EDWARD C',
    FIPS: '147',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'PRINCE GEORGE C',
    FIPS: '149',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'PRINCE WILLIAM',
    FIPS: '153',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PULASKI COUNTY',
    FIPS: '155',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '13980',
    'MSA Name': 'BLACKSBURG-CHRISTIANSBURG-RADFORD, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'RAPPAHANNOCK CO',
    FIPS: '157',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHMOND COUNTY',
    FIPS: '159',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 215000,
    'Median Price Det Limit': '215000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROANOKE COUNTY',
    FIPS: '161',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40220',
    'MSA Name': 'ROANOKE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCKBRIDGE COUN',
    FIPS: '163',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 326000,
    'Median Price Det Limit': '328000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCKINGHAM COUN',
    FIPS: '165',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '401000',
    'Metro Div Code': '0',
    'MSA Code': '25500',
    'MSA Name': 'HARRISONBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSSELL COUNTY',
    FIPS: '167',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 97000,
    'Median Price Det Limit': '119000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SCOTT COUNTY',
    FIPS: '169',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '28700',
    'MSA Name': 'KINGSPORT-BRISTOL, TN-VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHENANDOAH COUN',
    FIPS: '171',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 289000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SMYTH COUNTY',
    FIPS: '173',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '140000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SOUTHAMPTON COU',
    FIPS: '175',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '285000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'SPOTSYLVANIA CO',
    FIPS: '177',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'STAFFORD COUNTY',
    FIPS: '179',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'SURRY COUNTY',
    FIPS: '181',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'SUSSEX COUNTY',
    FIPS: '183',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAZEWELL COUNTY',
    FIPS: '185',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '14140',
    'MSA Name': 'BLUEFIELD, WV-VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'WARREN COUNTY',
    FIPS: '187',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '191',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '28700',
    'MSA Name': 'KINGSPORT-BRISTOL, TN-VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WESTMORELAND CO',
    FIPS: '193',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 275000,
    'Median Price Det Limit': '275000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WISE COUNTY',
    FIPS: '195',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 80000,
    'Median Price Det Limit': '118000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WYTHE COUNTY',
    FIPS: '197',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'YORK COUNTY',
    FIPS: '199',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'ALEXANDRIA CITY',
    FIPS: '510',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRISTOL CITY',
    FIPS: '520',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 254000,
    'Median Price Det Limit': '254000',
    'Metro Div Code': '0',
    'MSA Code': '28700',
    'MSA Name': 'KINGSPORT-BRISTOL, TN-VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUENA VISTA CIT',
    FIPS: '530',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 598000,
    '2 Unit': 765550,
    '3 Unit': 925350,
    '4 Unit': 1150000,
    'County Name': 'CHARLOTTESVILLE',
    FIPS: '540',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 520000,
    'Median Price Det Limit': '520000',
    'Metro Div Code': '0',
    'MSA Code': '16820',
    'MSA Name': 'CHARLOTTESVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'CHESAPEAKE CITY',
    FIPS: '550',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'COLONIAL HEIGHT',
    FIPS: '570',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COVINGTON CITY',
    FIPS: '580',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 73000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DANVILLE CITY',
    FIPS: '590',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 119000,
    'Median Price Det Limit': '162000',
    'Metro Div Code': '0',
    'MSA Code': '19260',
    'MSA Name': 'DANVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EMPORIA CITY',
    FIPS: '595',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 179000,
    'Median Price Det Limit': '211000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'FAIRFAX CITY',
    FIPS: '600',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'FALLS CHURCH CI',
    FIPS: '610',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN CITY',
    FIPS: '620',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 255000,
    'Median Price Det Limit': '255000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'FREDERICKSBURG',
    FIPS: '630',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GALAX CITY',
    FIPS: '640',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 173000,
    'Median Price Det Limit': '208000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'HAMPTON CITY',
    FIPS: '650',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISONBURG CI',
    FIPS: '660',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 350000,
    'Median Price Det Limit': '401000',
    'Metro Div Code': '0',
    'MSA Code': '25500',
    'MSA Name': 'HARRISONBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'HOPEWELL CITY',
    FIPS: '670',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEXINGTON CITY',
    FIPS: '678',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 349000,
    'Median Price Det Limit': '403000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LYNCHBURG CITY',
    FIPS: '680',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 311000,
    'Median Price Det Limit': '311000',
    'Metro Div Code': '0',
    'MSA Code': '31340',
    'MSA Name': 'LYNCHBURG, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MANASSAS CITY',
    FIPS: '683',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'MANASSAS PARK C',
    FIPS: '685',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARTINSVILLE CI',
    FIPS: '690',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 120000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '32300',
    'MSA Name': 'MARTINSVILLE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2008',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'NEWPORT NEWS CI',
    FIPS: '700',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'NORFOLK CITY',
    FIPS: '710',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NORTON CITY',
    FIPS: '720',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 129000,
    'Median Price Det Limit': '166000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'PETERSBURG CITY',
    FIPS: '730',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'POQUOSON CITY',
    FIPS: '735',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'PORTSMOUTH CITY',
    FIPS: '740',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RADFORD CITY',
    FIPS: '750',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '13980',
    'MSA Name': 'BLACKSBURG-CHRISTIANSBURG-RADFORD, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 707250,
    '2 Unit': 905400,
    '3 Unit': 1094450,
    '4 Unit': 1360100,
    'County Name': 'RICHMOND CITY',
    FIPS: '760',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 615000,
    'Median Price Det Limit': '615000',
    'Metro Div Code': '0',
    'MSA Code': '40060',
    'MSA Name': 'RICHMOND, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROANOKE CITY',
    FIPS: '770',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40220',
    'MSA Name': 'ROANOKE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SALEM CITY',
    FIPS: '775',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40220',
    'MSA Name': 'ROANOKE, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STAUNTON CITY',
    FIPS: '790',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 333000,
    'Median Price Det Limit': '333000',
    'Metro Div Code': '0',
    'MSA Code': '44420',
    'MSA Name': 'STAUNTON-STUARTS DRAFT, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'SUFFOLK CITY',
    FIPS: '800',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'VIRGINIA BEACH',
    FIPS: '810',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNESBORO CITY',
    FIPS: '820',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 333000,
    'Median Price Det Limit': '333000',
    'Metro Div Code': '0',
    'MSA Code': '44420',
    'MSA Name': 'STAUNTON-STUARTS DRAFT, VA',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 757850,
    '2 Unit': 970200,
    '3 Unit': 1172750,
    '4 Unit': 1457450,
    'County Name': 'WILLIAMSBURG CI',
    FIPS: '830',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 630000,
    'Median Price Det Limit': '659000',
    'Metro Div Code': '0',
    'MSA Code': '47260',
    'MSA Name': 'VIRGINIA BEACH-CHESAPEAKE-NORFOLK, VA-NC',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINCHESTER CITY',
    FIPS: '840',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 420000,
    'Median Price Det Limit': '420000',
    'Metro Div Code': '0',
    'MSA Code': '49020',
    'MSA Name': 'WINCHESTER, VA-WV',
    'SOA Code': '203B',
    ST: 'VA',
    'State Name': 'VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ST. CROIX ISLAN',
    FIPS: '010',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 408000,
    'Median Price Det Limit': '408000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VI',
    'State Name': 'VIRGIN ISLANDS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1121250,
    '2 Unit': 1435400,
    '3 Unit': 1735100,
    '4 Unit': 2156300,
    'County Name': 'ST. JOHN ISLAND',
    FIPS: '020',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 975000,
    'Median Price Det Limit': '975000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VI',
    'State Name': 'VIRGIN ISLANDS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 677350,
    '2 Unit': 867150,
    '3 Unit': 1048150,
    '4 Unit': 1302600,
    'County Name': 'ST. THOMAS ISLA',
    FIPS: '030',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 589000,
    'Median Price Det Limit': '589000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VI',
    'State Name': 'VIRGIN ISLANDS',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADDISON COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 345000,
    'Median Price Det Limit': '345000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENNINGTON COUN',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '320000',
    'Metro Div Code': '0',
    'MSA Code': '13540',
    'MSA Name': 'BENNINGTON, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALEDONIA COUNT',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 229000,
    'Median Price Det Limit': '229000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 575000,
    '2 Unit': 736100,
    '3 Unit': 889800,
    '4 Unit': 1105800,
    'County Name': 'CHITTENDEN COUN',
    FIPS: '007',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 499000,
    'Median Price Det Limit': '500000',
    'Metro Div Code': '0',
    'MSA Code': '15540',
    'MSA Name': 'BURLINGTON-SOUTH BURLINGTON, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ESSEX COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '142000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 575000,
    '2 Unit': 736100,
    '3 Unit': 889800,
    '4 Unit': 1105800,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '011',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 499000,
    'Median Price Det Limit': '500000',
    'Metro Div Code': '0',
    'MSA Code': '15540',
    'MSA Name': 'BURLINGTON-SOUTH BURLINGTON, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 575000,
    '2 Unit': 736100,
    '3 Unit': 889800,
    '4 Unit': 1105800,
    'County Name': 'GRAND ISLE COUN',
    FIPS: '013',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 499000,
    'Median Price Det Limit': '500000',
    'Metro Div Code': '0',
    'MSA Code': '15540',
    'MSA Name': 'BURLINGTON-SOUTH BURLINGTON, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAMOILLE COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 342000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORANGE COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 379000,
    'Median Price Det Limit': '379000',
    'Metro Div Code': '0',
    'MSA Code': '30150',
    'MSA Name': 'LEBANON-CLAREMONT, NH-VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ORLEANS COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 192000,
    'Median Price Det Limit': '192000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUTLAND COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 242000,
    'Median Price Det Limit': '242000',
    'Metro Div Code': '0',
    'MSA Code': '40860',
    'MSA Name': 'RUTLAND, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 323000,
    'Median Price Det Limit': '323000',
    'Metro Div Code': '0',
    'MSA Code': '12740',
    'MSA Name': 'BARRE, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINDHAM COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 299000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '14710',
    'MSA Name': 'BRATTLEBORO, VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINDSOR COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 379000,
    'Median Price Det Limit': '379000',
    'Metro Div Code': '0',
    'MSA Code': '30150',
    'MSA Name': 'LEBANON-CLAREMONT, NH-VT',
    'SOA Code': '203B',
    ST: 'VT',
    'State Name': 'VERMONT',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '36830',
    'MSA Name': 'OTHELLO, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASOTIN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 357000,
    'Median Price Det Limit': '357000',
    'Metro Div Code': '0',
    'MSA Code': '30300',
    'MSA Name': 'LEWISTON, ID-WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BENTON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '425000',
    'Metro Div Code': '0',
    'MSA Code': '28420',
    'MSA Name': 'KENNEWICK-RICHLAND, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'CHELAN COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 510000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '48300',
    'MSA Name': 'WENATCHEE-EAST WENATCHEE, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLALLAM COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 435000,
    'Median Price Det Limit': '435000',
    'Metro Div Code': '0',
    'MSA Code': '38820',
    'MSA Name': 'PORT ANGELES, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'CLARK COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COWLITZ COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 390000,
    'Median Price Det Limit': '390000',
    'Metro Div Code': '0',
    'MSA Code': '31020',
    'MSA Name': 'LONGVIEW-KELSO, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 510000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '48300',
    'MSA Name': 'WENATCHEE-EAST WENATCHEE, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FERRY COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FRANKLIN COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 425000,
    'Median Price Det Limit': '425000',
    'Metro Div Code': '0',
    'MSA Code': '28420',
    'MSA Name': 'KENNEWICK-RICHLAND, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GARFIELD COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 279000,
    'Median Price Det Limit': '279000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '34180',
    'MSA Name': 'MOSES LAKE, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRAYS HARBOR CO',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 301000,
    'Median Price Det Limit': '302000',
    'Metro Div Code': '0',
    'MSA Code': '10140',
    'MSA Name': 'ABERDEEN, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 671600,
    '2 Unit': 859750,
    '3 Unit': 1039250,
    '4 Unit': 1291550,
    'County Name': 'ISLAND COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 584000,
    'Median Price Det Limit': '584000',
    'Metro Div Code': '0',
    'MSA Code': '36020',
    'MSA Name': 'OAK HARBOR, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 117000,
    'Median Price Det Limit': '450000',
    'Metro Div Code': '0',
    'MSA Code': '39040',
    'MSA Name': 'PORT TOWNSEND, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 1063750,
    '2 Unit': 1361800,
    '3 Unit': 1646100,
    '4 Unit': 2045700,
    'County Name': 'KING COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 925000,
    'Median Price Det Limit': '925000',
    'Metro Div Code': '42644',
    'MSA Code': '42660',
    'MSA Name': 'SEATTLE-TACOMA-BELLEVUE, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 616400,
    '2 Unit': 789100,
    '3 Unit': 953850,
    '4 Unit': 1185400,
    'County Name': 'KITSAP COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 536000,
    'Median Price Det Limit': '536000',
    'Metro Div Code': '0',
    'MSA Code': '14740',
    'MSA Name': 'BREMERTON-SILVERDALE-PORT ORCHARD, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KITTITAS COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 440000,
    'Median Price Det Limit': '448000',
    'Metro Div Code': '0',
    'MSA Code': '21260',
    'MSA Name': 'ELLENSBURG, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KLICKITAT COUNT',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 285000,
    'Median Price Det Limit': '287000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 375000,
    'Median Price Det Limit': '375000',
    'Metro Div Code': '0',
    'MSA Code': '16500',
    'MSA Name': 'CENTRALIA, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 380000,
    'Median Price Det Limit': '380000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASON COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 355000,
    'Median Price Det Limit': '355000',
    'Metro Div Code': '0',
    'MSA Code': '43220',
    'MSA Name': 'SHELTON, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OKANOGAN COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PACIFIC COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEND OREILLE CO',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 308000,
    'Median Price Det Limit': '308000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1063750,
    '2 Unit': 1361800,
    '3 Unit': 1646100,
    '4 Unit': 2045700,
    'County Name': 'PIERCE COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 925000,
    'Median Price Det Limit': '925000',
    'Metro Div Code': '45104',
    'MSA Code': '42660',
    'MSA Name': 'SEATTLE-TACOMA-BELLEVUE, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 680800,
    '2 Unit': 871550,
    '3 Unit': 1053500,
    '4 Unit': 1309250,
    'County Name': 'SAN JUAN COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 592000,
    'Median Price Det Limit': '592000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 621000,
    '2 Unit': 795000,
    '3 Unit': 960950,
    '4 Unit': 1194250,
    'County Name': 'SKAGIT COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 540000,
    'Median Price Det Limit': '540000',
    'Metro Div Code': '0',
    'MSA Code': '34580',
    'MSA Name': 'MOUNT VERNON-ANACORTES, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 701500,
    '2 Unit': 898050,
    '3 Unit': 1085550,
    '4 Unit': 1349050,
    'County Name': 'SKAMANIA COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 610000,
    'Median Price Det Limit': '610000',
    'Metro Div Code': '0',
    'MSA Code': '38900',
    'MSA Name': 'PORTLAND-VANCOUVER-HILLSBORO, OR-WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1063750,
    '2 Unit': 1361800,
    '3 Unit': 1646100,
    '4 Unit': 2045700,
    'County Name': 'SNOHOMISH COUNT',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 925000,
    'Median Price Det Limit': '925000',
    'Metro Div Code': '21794',
    'MSA Code': '42660',
    'MSA Name': 'SEATTLE-TACOMA-BELLEVUE, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SPOKANE COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 413000,
    'Median Price Det Limit': '413000',
    'Metro Div Code': '0',
    'MSA Code': '44060',
    'MSA Name': 'SPOKANE-SPOKANE VALLEY, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'STEVENS COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 413000,
    'Median Price Det Limit': '413000',
    'Metro Div Code': '0',
    'MSA Code': '44060',
    'MSA Name': 'SPOKANE-SPOKANE VALLEY, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 586500,
    '2 Unit': 750800,
    '3 Unit': 907550,
    '4 Unit': 1127900,
    'County Name': 'THURSTON COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 510000,
    'Median Price Det Limit': '510000',
    'Metro Div Code': '0',
    'MSA Code': '36500',
    'MSA Name': 'OLYMPIA-LACEY-TUMWATER, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAHKIAKUM COUNT',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 204000,
    'Median Price Det Limit': '305000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALLA WALLA COU',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 422000,
    'Median Price Det Limit': '422000',
    'Metro Div Code': '0',
    'MSA Code': '47460',
    'MSA Name': 'WALLA WALLA, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 664700,
    '2 Unit': 850950,
    '3 Unit': 1028600,
    '4 Unit': 1278300,
    'County Name': 'WHATCOM COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 578000,
    'Median Price Det Limit': '578000',
    'Metro Div Code': '0',
    'MSA Code': '13380',
    'MSA Name': 'BELLINGHAM, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 579600,
    '2 Unit': 742000,
    '3 Unit': 896900,
    '4 Unit': 1114650,
    'County Name': 'WHITMAN COUNTY',
    FIPS: '075',
    'Limit Date': 20250101,
    'Limit Type': 'H',
    'Median Price': 450000,
    'Median Price Det Limit': '504000',
    'Metro Div Code': '0',
    'MSA Code': '39420',
    'MSA Name': 'PULLMAN, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'YAKIMA COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 330000,
    'Median Price Det Limit': '330000',
    'Metro Div Code': '0',
    'MSA Code': '49420',
    'MSA Name': 'YAKIMA, WA',
    'SOA Code': '203B',
    ST: 'WA',
    'State Name': 'WASHINGTON',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ADAMS COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ASHLAND COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 138000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARRON COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 220000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '39960',
    'MSA Name': 'RICE LAKE, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BAYFIELD COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 196000,
    'Median Price Det Limit': '196000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROWN COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '24580',
    'MSA Name': 'GREEN BAY, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BUFFALO COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BURNETT COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALUMET COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 310000,
    'Median Price Det Limit': '310000',
    'Metro Div Code': '0',
    'MSA Code': '11540',
    'MSA Name': 'APPLETON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CHIPPEWA COUNTY',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '20740',
    'MSA Name': 'EAU CLAIRE, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLARK COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 160000,
    'Median Price Det Limit': '160000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'COLUMBIA COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 448000,
    'Median Price Det Limit': '448000',
    'Metro Div Code': '0',
    'MSA Code': '31540',
    'MSA Name': 'MADISON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CRAWFORD COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DANE COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 448000,
    'Median Price Det Limit': '448000',
    'Metro Div Code': '0',
    'MSA Code': '31540',
    'MSA Name': 'MADISON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DODGE COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 261000,
    'Median Price Det Limit': '261000',
    'Metro Div Code': '0',
    'MSA Code': '13180',
    'MSA Name': 'BEAVER DAM, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOOR COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 325000,
    'Median Price Det Limit': '325000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DOUGLAS COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 236000,
    'Median Price Det Limit': '236000',
    'Metro Div Code': '0',
    'MSA Code': '20260',
    'MSA Name': 'DULUTH, MN-WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DUNN COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 245000,
    'Median Price Det Limit': '245000',
    'Metro Div Code': '0',
    'MSA Code': '32860',
    'MSA Name': 'MENOMONIE, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'EAU CLAIRE COUN',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 290000,
    'Median Price Det Limit': '290000',
    'Metro Div Code': '0',
    'MSA Code': '20740',
    'MSA Name': 'EAU CLAIRE, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FLORENCE COUNTY',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '27020',
    'MSA Name': 'IRON MOUNTAIN, MI-WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FOND DU LAC COU',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '22540',
    'MSA Name': 'FOND DU LAC, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FOREST COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 102000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '38420',
    'MSA Name': 'PLATTEVILLE, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREEN COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 448000,
    'Median Price Det Limit': '448000',
    'Metro Div Code': '0',
    'MSA Code': '31540',
    'MSA Name': 'MADISON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREEN LAKE COUN',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 205000,
    'Median Price Det Limit': '205000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IOWA COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 448000,
    'Median Price Det Limit': '448000',
    'Metro Div Code': '0',
    'MSA Code': '31540',
    'MSA Name': 'MADISON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'IRON COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 163000,
    'Median Price Det Limit': '163000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 308000,
    'Median Price Det Limit': '308000',
    'Metro Div Code': '0',
    'MSA Code': '48020',
    'MSA Name': 'WATERTOWN-FORT ATKINSON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JUNEAU COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '145000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KENOSHA COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 281000,
    'Median Price Det Limit': '281000',
    'Metro Div Code': '0',
    'MSA Code': '28450',
    'MSA Name': 'KENOSHA, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KEWAUNEE COUNTY',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '24580',
    'MSA Name': 'GREEN BAY, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LA CROSSE COUNT',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '29100',
    'MSA Name': 'LA CROSSE-ONALASKA, WI-MN',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LAFAYETTE COUNT',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 189000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LANGLADE COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 159000,
    'Median Price Det Limit': '159000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MANITOWOC COUNT',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 202000,
    'Median Price Det Limit': '202000',
    'Metro Div Code': '0',
    'MSA Code': '31820',
    'MSA Name': 'MANITOWOC, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARATHON COUNTY',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '48140',
    'MSA Name': 'WAUSAU, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARINETTE COUNT',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 130000,
    'Median Price Det Limit': '130000',
    'Metro Div Code': '0',
    'MSA Code': '31940',
    'MSA Name': 'MARINETTE, WI-MI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARQUETTE COUNT',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 200000,
    'Median Price Det Limit': '200000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MENOMINEE COUNT',
    FIPS: '078',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '226000',
    'Metro Div Code': '0',
    'MSA Code': '43020',
    'MSA Name': 'SHAWANO, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MILWAUKEE COUNT',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 447000,
    'Median Price Det Limit': '447000',
    'Metro Div Code': '0',
    'MSA Code': '33340',
    'MSA Name': 'MILWAUKEE-WAUKESHA, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '225000',
    'Metro Div Code': '0',
    'MSA Code': '43890',
    'MSA Name': 'SPARTA, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OCONTO COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '24580',
    'MSA Name': 'GREEN BAY, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ONEIDA COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 223000,
    'Median Price Det Limit': '223000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OUTAGAMIE COUNT',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 310000,
    'Median Price Det Limit': '310000',
    'Metro Div Code': '0',
    'MSA Code': '11540',
    'MSA Name': 'APPLETON, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OZAUKEE COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 447000,
    'Median Price Det Limit': '447000',
    'Metro Div Code': '0',
    'MSA Code': '33340',
    'MSA Name': 'MILWAUKEE-WAUKESHA, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PEPIN COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 191000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'PIERCE COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POLK COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 225000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PORTAGE COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '44620',
    'MSA Name': 'STEVENS POINT-PLOVER, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRICE COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '125000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RACINE COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 260000,
    'Median Price Det Limit': '260000',
    'Metro Div Code': '0',
    'MSA Code': '39540',
    'MSA Name': 'RACINE-MOUNT PLEASANT, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RICHLAND COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROCK COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 240000,
    'Median Price Det Limit': '240000',
    'Metro Div Code': '0',
    'MSA Code': '27500',
    'MSA Name': 'JANESVILLE-BELOIT, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RUSK COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 136000,
    'Median Price Det Limit': '136000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 552000,
    '2 Unit': 706650,
    '3 Unit': 854200,
    '4 Unit': 1061550,
    'County Name': 'ST. CROIX COUNT',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 480000,
    'Median Price Det Limit': '480000',
    'Metro Div Code': '0',
    'MSA Code': '33460',
    'MSA Name': 'MINNEAPOLIS-ST. PAUL-BLOOMINGTON, MN-WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAUK COUNTY',
    FIPS: '111',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 262000,
    'Median Price Det Limit': '262000',
    'Metro Div Code': '0',
    'MSA Code': '12660',
    'MSA Name': 'BARABOO, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SAWYER COUNTY',
    FIPS: '113',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 190000,
    'Median Price Det Limit': '190000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHAWANO COUNTY',
    FIPS: '115',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 210000,
    'Median Price Det Limit': '226000',
    'Metro Div Code': '0',
    'MSA Code': '43020',
    'MSA Name': 'SHAWANO, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHEBOYGAN COUNT',
    FIPS: '117',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '43100',
    'MSA Name': 'SHEBOYGAN, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '119',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 175000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TREMPEALEAU COU',
    FIPS: '121',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 203000,
    'Median Price Det Limit': '203000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VERNON COUNTY',
    FIPS: '123',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 280000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '29100',
    'MSA Name': 'LA CROSSE-ONALASKA, WI-MN',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'VILAS COUNTY',
    FIPS: '125',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 265000,
    'Median Price Det Limit': '265000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WALWORTH COUNTY',
    FIPS: '127',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 349000,
    'Median Price Det Limit': '349000',
    'Metro Div Code': '0',
    'MSA Code': '48580',
    'MSA Name': 'WHITEWATER-ELKHORN, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHBURN COUNTY',
    FIPS: '129',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 189000,
    'Median Price Det Limit': '189000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHINGTON COUN',
    FIPS: '131',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 447000,
    'Median Price Det Limit': '447000',
    'Metro Div Code': '0',
    'MSA Code': '33340',
    'MSA Name': 'MILWAUKEE-WAUKESHA, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAUKESHA COUNTY',
    FIPS: '133',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 447000,
    'Median Price Det Limit': '447000',
    'Metro Div Code': '0',
    'MSA Code': '33340',
    'MSA Name': 'MILWAUKEE-WAUKESHA, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAUPACA COUNTY',
    FIPS: '135',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 180000,
    'Median Price Det Limit': '180000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAUSHARA COUNTY',
    FIPS: '137',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 447000,
    'Median Price Det Limit': '447000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WINNEBAGO COUNT',
    FIPS: '139',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '36780',
    'MSA Name': 'OSHKOSH-NEENAH, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOOD COUNTY',
    FIPS: '141',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 177000,
    'Median Price Det Limit': '177000',
    'Metro Div Code': '0',
    'MSA Code': '49220',
    'MSA Name': 'WISCONSIN RAPIDS-MARSHFIELD, WI',
    'SOA Code': '203B',
    ST: 'WI',
    'State Name': 'WISCONSIN',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BARBOUR COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 98000,
    'Median Price Det Limit': '114000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BERKELEY COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '25180',
    'MSA Name': 'HAGERSTOWN-MARTINSBURG, MD-WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BOONE COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '16620',
    'MSA Name': 'CHARLESTON, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BRAXTON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '117000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BROOKE COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '48260',
    'MSA Name': 'WEIRTON-STEUBENVILLE, WV-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CABELL COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CALHOUN COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 144000,
    'Median Price Det Limit': '144000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CLAY COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '16620',
    'MSA Name': 'CHARLESTON, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'DODDRIDGE COUNT',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '17220',
    'MSA Name': 'CLARKSBURG, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FAYETTE COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '13220',
    'MSA Name': 'BECKLEY, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GILMER COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '112000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GRANT COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '177000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GREENBRIER COUN',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 169000,
    'Median Price Det Limit': '169000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HAMPSHIRE COUNT',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 420000,
    'Median Price Det Limit': '420000',
    'Metro Div Code': '0',
    'MSA Code': '49020',
    'MSA Name': 'WINCHESTER, VA-WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HANCOCK COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 174000,
    'Median Price Det Limit': '174000',
    'Metro Div Code': '0',
    'MSA Code': '48260',
    'MSA Name': 'WEIRTON-STEUBENVILLE, WV-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARDY COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '150000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HARRISON COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '17220',
    'MSA Name': 'CLARKSBURG, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JACKSON COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '152000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'JEFFERSON COUNT',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1198000,
    'Median Price Det Limit': '1198000',
    'Metro Div Code': '11694',
    'MSA Code': '47900',
    'MSA Name': 'WASHINGTON-ARLINGTON-ALEXANDRIA, DC-VA-MD-WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'KANAWHA COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '16620',
    'MSA Name': 'CHARLESTON, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LEWIS COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 90000,
    'Median Price Det Limit': '110000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 134000,
    'Median Price Det Limit': '134000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LOGAN COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 70000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MCDOWELL COUNTY',
    FIPS: '047',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 64000,
    'Median Price Det Limit': '79000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARION COUNTY',
    FIPS: '049',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 141000,
    'Median Price Det Limit': '141000',
    'Metro Div Code': '0',
    'MSA Code': '21900',
    'MSA Name': 'FAIRMONT, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MARSHALL COUNTY',
    FIPS: '051',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48540',
    'MSA Name': 'WHEELING, WV-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MASON COUNTY',
    FIPS: '053',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '165000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MERCER COUNTY',
    FIPS: '055',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '146000',
    'Metro Div Code': '0',
    'MSA Code': '14140',
    'MSA Name': 'BLUEFIELD, WV-VA',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2019',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINERAL COUNTY',
    FIPS: '057',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 187000,
    'Median Price Det Limit': '187000',
    'Metro Div Code': '0',
    'MSA Code': '19060',
    'MSA Name': 'CUMBERLAND, MD-WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MINGO COUNTY',
    FIPS: '059',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 54000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONONGALIA COUN',
    FIPS: '061',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '34060',
    'MSA Name': 'MORGANTOWN, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MONROE COUNTY',
    FIPS: '063',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 125000,
    'Median Price Det Limit': '155000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'MORGAN COUNTY',
    FIPS: '065',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 300000,
    'Median Price Det Limit': '300000',
    'Metro Div Code': '0',
    'MSA Code': '25180',
    'MSA Name': 'HAGERSTOWN-MARTINSBURG, MD-WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NICHOLAS COUNTY',
    FIPS: '067',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 115000,
    'Median Price Det Limit': '115000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'OHIO COUNTY',
    FIPS: '069',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '241000',
    'Metro Div Code': '0',
    'MSA Code': '48540',
    'MSA Name': 'WHEELING, WV-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PENDLETON COUNT',
    FIPS: '071',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 150000,
    'Median Price Det Limit': '220000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLEASANTS COUNT',
    FIPS: '073',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 137000,
    'Median Price Det Limit': '137000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'POCAHONTAS COUN',
    FIPS: '075',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 93000,
    'Median Price Det Limit': '122000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PRESTON COUNTY',
    FIPS: '077',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 270000,
    'Median Price Det Limit': '270000',
    'Metro Div Code': '0',
    'MSA Code': '34060',
    'MSA Name': 'MORGANTOWN, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PUTNAM COUNTY',
    FIPS: '079',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RALEIGH COUNTY',
    FIPS: '081',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 140000,
    'Median Price Det Limit': '164000',
    'Metro Div Code': '0',
    'MSA Code': '13220',
    'MSA Name': 'BECKLEY, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RANDOLPH COUNTY',
    FIPS: '083',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 178000,
    'Median Price Det Limit': '178000',
    'Metro Div Code': '0',
    'MSA Code': '21180',
    'MSA Name': 'ELKINS, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'RITCHIE COUNTY',
    FIPS: '085',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '86000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2018',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ROANE COUNTY',
    FIPS: '087',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 75000,
    'Median Price Det Limit': '105000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2016',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUMMERS COUNTY',
    FIPS: '089',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 96000,
    'Median Price Det Limit': '175000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TAYLOR COUNTY',
    FIPS: '091',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 145000,
    'Median Price Det Limit': '191000',
    'Metro Div Code': '0',
    'MSA Code': '17220',
    'MSA Name': 'CLARKSBURG, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TUCKER COUNTY',
    FIPS: '093',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 195000,
    'Median Price Det Limit': '195000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'TYLER COUNTY',
    FIPS: '095',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 95000,
    'Median Price Det Limit': '102000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2009',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'UPSHUR COUNTY',
    FIPS: '097',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 165000,
    'Median Price Det Limit': '167000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WAYNE COUNTY',
    FIPS: '099',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 243000,
    'Median Price Det Limit': '246000',
    'Metro Div Code': '0',
    'MSA Code': '26580',
    'MSA Name': 'HUNTINGTON-ASHLAND, WV-KY-OH',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2022',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WEBSTER COUNTY',
    FIPS: '101',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 65000,
    'Median Price Det Limit': '107000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WETZEL COUNTY',
    FIPS: '103',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 111000,
    'Median Price Det Limit': '111000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WIRT COUNTY',
    FIPS: '105',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '152000',
    'Metro Div Code': '0',
    'MSA Code': '37620',
    'MSA Name': 'PARKERSBURG-VIENNA, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WOOD COUNTY',
    FIPS: '107',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 152000,
    'Median Price Det Limit': '152000',
    'Metro Div Code': '0',
    'MSA Code': '37620',
    'MSA Name': 'PARKERSBURG-VIENNA, WV',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WYOMING COUNTY',
    FIPS: '109',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 40000,
    'Median Price Det Limit': '81000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WV',
    'State Name': 'WEST VIRGINIA',
    'Year Median Price Det Limit': '2021',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'ALBANY COUNTY',
    FIPS: '001',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 382000,
    'Median Price Det Limit': '382000',
    'Metro Div Code': '0',
    'MSA Code': '29660',
    'MSA Name': 'LARAMIE, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'BIG HORN COUNTY',
    FIPS: '003',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 250000,
    'Median Price Det Limit': '250000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CAMPBELL COUNTY',
    FIPS: '005',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 221000,
    'Median Price Det Limit': '302000',
    'Metro Div Code': '0',
    'MSA Code': '23940',
    'MSA Name': 'GILLETTE, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CARBON COUNTY',
    FIPS: '007',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 194000,
    'Median Price Det Limit': '224000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CONVERSE COUNTY',
    FIPS: '009',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 297000,
    'Median Price Det Limit': '297000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'CROOK COUNTY',
    FIPS: '011',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 297000,
    'Median Price Det Limit': '313000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'FREMONT COUNTY',
    FIPS: '013',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 114000,
    'Median Price Det Limit': '280000',
    'Metro Div Code': '0',
    'MSA Code': '40180',
    'MSA Name': 'RIVERTON, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'GOSHEN COUNTY',
    FIPS: '015',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 228000,
    'Median Price Det Limit': '230000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'HOT SPRINGS COU',
    FIPS: '017',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 308000,
    'Median Price Det Limit': '308000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'JOHNSON COUNTY',
    FIPS: '019',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 358000,
    'Median Price Det Limit': '358000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LARAMIE COUNTY',
    FIPS: '021',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 360000,
    'Median Price Det Limit': '360000',
    'Metro Div Code': '0',
    'MSA Code': '16940',
    'MSA Name': 'CHEYENNE, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'LINCOLN COUNTY',
    FIPS: '023',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 394000,
    'Median Price Det Limit': '394000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NATRONA COUNTY',
    FIPS: '025',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 297000,
    'Median Price Det Limit': '297000',
    'Metro Div Code': '0',
    'MSA Code': '16220',
    'MSA Name': 'CASPER, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'NIOBRARA COUNTY',
    FIPS: '027',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 253000,
    'Median Price Det Limit': '253000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PARK COUNTY',
    FIPS: '029',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 364000,
    'Median Price Det Limit': '364000',
    'Metro Div Code': '0',
    'MSA Code': '17650',
    'MSA Name': 'CODY, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'PLATTE COUNTY',
    FIPS: '031',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 244000,
    'Median Price Det Limit': '244000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SHERIDAN COUNTY',
    FIPS: '033',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 397000,
    'Median Price Det Limit': '426000',
    'Metro Div Code': '0',
    'MSA Code': '43260',
    'MSA Name': 'SHERIDAN, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2020',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SUBLETTE COUNTY',
    FIPS: '035',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 366000,
    'Median Price Det Limit': '366000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'SWEETWATER COUN',
    FIPS: '037',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 315000,
    'Median Price Det Limit': '315000',
    'Metro Div Code': '0',
    'MSA Code': '40540',
    'MSA Name': 'ROCK SPRINGS, WY',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 1249125,
    '2 Unit': 1599375,
    '3 Unit': 1933200,
    '4 Unit': 2402625,
    'County Name': 'TETON COUNTY',
    FIPS: '039',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 1740000,
    'Median Price Det Limit': '1800000',
    'Metro Div Code': '0',
    'MSA Code': '27220',
    'MSA Name': 'JACKSON, WY-ID',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2024',
  },
  {
    '1 Unit': 579600,
    '2 Unit': 742000,
    '3 Unit': 896900,
    '4 Unit': 1114650,
    'County Name': 'UINTA COUNTY',
    FIPS: '041',
    'Limit Date': 20260101,
    'Limit Type': 'H',
    'Median Price': 433000,
    'Median Price Det Limit': '504000',
    'Metro Div Code': '0',
    'MSA Code': '21740',
    'MSA Name': 'EVANSTON, WY-UT',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2023',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WASHAKIE COUNTY',
    FIPS: '043',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 252000,
    'Median Price Det Limit': '252000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2025',
  },
  {
    '1 Unit': 541287,
    '2 Unit': 693050,
    '3 Unit': 837700,
    '4 Unit': 1041125,
    'County Name': 'WESTON COUNTY',
    FIPS: '045',
    'Limit Date': 20260101,
    'Limit Type': 'S',
    'Median Price': 279000,
    'Median Price Det Limit': '282000',
    'Metro Div Code': '0',
    'MSA Code': '99999',
    'MSA Name': 'NON-METRO',
    'SOA Code': '203B',
    ST: 'WY',
    'State Name': 'WYOMING',
    'Year Median Price Det Limit': '2024',
  },
];
